import type { Dictionary } from "@/lib/i18n/dictionaries/en";

const pl: Dictionary = {
  // ---- /citation-styles/alphabetical/<letter> ----
  styleDirectory: {
    notFoundTitle: "Nie znaleziono katalogu stylów cytowania",
    metaTitle: "Style cytowania zaczynające się na {label}",
    metaDescription:
      "Przeglądaj {count} stylów Citation Style Language zaczynających się na {label}. Otwórz dowolny styl, aby zobaczyć prawdziwe przykłady cytowań i darmowy generator.",
    ogSubtitle: "{count} stylów z własnymi przykładami i generatorami.",
    ogKind: "Katalog A–Z",
    schemaName: "Style cytowania zaczynające się na {label}",
    schemaDescription:
      "Alfabetyczny katalog {count} stylów Citation Style Language zaczynających się na {label}.",
    breadcrumbStyles: "Style cytowania",
    heading: "Style cytowania zaczynające się na {label}",
    intro:
      "Przeglądaj wszystkie {count} stylów w tej części katalogu CSL. Każda strona zawiera sformatowane przykłady danego stylu i darmowy generator cytowań.",
    navLabel: "Style cytowania od A do Z",
    listHeading: "Wszystkie style zaczynające się na {label}",
  },
  nav: {
    tools: "Narzędzia",
    guides: "Poradniki",
    styles: "Wszystkie style",
    bibliography: "Moja bibliografia",
    search: "Szukaj",
    glossary: "Słowniczek",
    home: "Strona główna",
    menu: "Menu",
  },

  home: {
    title: "Darmowy generator przypisów",
    subtitle: "Zaktualizowany na 2026",
    intro:
      "Wklej DOI, adres URL lub wpis BibTeX — albo wyszukaj książkę — a otrzymasz poprawnie sformatowany opis bibliograficzny w stylu APA, MLA, Chicago, Vancouver, Harvard i tysiącach innych. Całkowicie za darmo, bez płatnej subskrypcji i bez rejestracji.",
    browseAllStyles: "Przeglądaj wszystkie {count} stylów cytowania →",
    featuresHeading: "Wszystko, czego potrzebujesz do cytowania",
    featureStyles: "{count} stylów",
    featureStylesDetail: "APA, MLA, Chicago i więcej",
    featureBibliographies: "Wiele bibliografii",
    featureBibliographiesDetail: "Uporządkowane według pracy",
    featureBookSearch: "Wyszukiwanie książek",
    featureBookSearchDetail: "Po tytule lub autorze",
    featureExport: "Eksport wszędzie",
    featureExportDetail: "BibTeX, Word, RIS, CSV",
    featureDarkMode: "Tryb ciemny",
    featureDarkModeDetail: "Łagodny dla oczu",
    featureNoSignup: "Bez rejestracji",
    featureNoSignupDetail: "Zawsze za darmo, bez płatnej subskrypcji",
    aboutHeading: "Darmowy generator przypisów dla studentów i badaczy",
    aboutBody:
      "CitationEasy obsługuje ponad 10 000 naukowych stylów cytowania. Niezależnie od tego, czy potrzebujesz APA w psychologii, MLA w filologii, Chicago w historii czy Vancouver w czasopismach medycznych, formatowanie pochodzi z oficjalnej definicji samego stylu, a nie z przybliżenia.",
    howItWorksHeading: "Jak to działa",
    howItWorksStep1:
      "Wklej DOI, adres URL, ISBN, identyfikator PubMed lub arXiv albo wpis BibTeX; możesz też wyszukać książkę po tytule.",
    howItWorksStep2:
      "Wybierz styl cytowania. Zacznij pisać, aby przeszukać wszystkie {count} stylów.",
    howItWorksStep3:
      "Skopiuj gotowy opis albo zapisz go w bibliografii i wyeksportuj do Worda, BibTeX-a lub RIS-a.",
    privacyNote:
      "Twoja bibliografia jest przechowywana w Twojej przeglądarce. Bez konta i bez wysyłania czegokolwiek na serwer.",
  },

  hubs: {
    toolsTitle: "Darmowe narzędzia do pisania i cytowania",
    toolsIntro:
      "{count} narzędzi działających w przeglądarce, przydatnych przy pisaniu i cytowaniu: generatory dla każdego rodzaju źródła, liczniki słów i znaków, analiza czytelności, narzędzia do formatowania i konwertery. Wszystkie darmowe i natychmiastowe.",
    stylesTitle: "Przeglądaj wszystkie style cytowania",
    stylesIntro:
      "Wszystkie {count} stylów z projektu Citation Style Language, z wyszukiwaniem i filtrami według kraju, dziedziny i dyscypliny naukowej.",
    guidesTitle: "Poradniki o cytowaniu i pisaniu naukowym",
    guidesIntro:
      "Szczegółowe poradniki o tym, jak cytować poszczególne rodzaje źródeł, oceniać znalezione materiały i lepiej pisać.",
    howToCiteTitle: "Jak zacytować dowolne źródło",
    howToCiteIntro:
      "Strony krok po kroku łączące każdy typowy rodzaj źródła z najważniejszymi stylami cytowania — każda z prawdziwym, gotowym przykładem.",
    faqTitle: "Najczęstsze pytania o cytowanie",
    faqIntro:
      "Krótkie i rzetelne odpowiedzi na pytania, które studenci naprawdę zadają przy cytowaniu.",
    glossaryTitle: "Słowniczek pojęć bibliograficznych",
    glossaryIntro:
      "Zrozumiałe definicje pojęć pojawiających się w podręcznikach stylu i w treści zadań.",
    openHub: "Otwórz",
  },

  styleLanding: {
    metaTitle: "Darmowy generator przypisów {style}",
    metaDescription:
      "Twórz opisy bibliograficzne {style} za darmo. Wklej DOI, adres URL, ISBN lub BibTeX i otrzymaj opis oraz przypis w tekście w poprawnym formacie {style}.",
    heading: "Generator przypisów {style}",
    intro:
      "Twórz jednym kliknięciem poprawne opisy {style} dla książek, artykułów naukowych i stron internetowych. Za darmo i bez rejestracji.",
    aboutHeading: "O stylu {style}",
    whenToUseHeading: "Kiedy stosować {style}",
    factsHeading: "{style} w skrócie",
    factEdition: "Wydanie",
    factSystem: "System cytowania",
    factInText: "Format w tekście",
    factReferenceList: "Nazwa wykazu",
    factFields: "Popularny w",
    systemAuthorDate: "Autor–data",
    systemNumbered: "Numeryczny",
    systemFootnotes: "Przypisy dolne",
    howToHeading: "Jak korzystać z tego generatora {style}",
    howToStep1:
      "Wklej powyżej adres URL, DOI, ISBN lub wpis BibTeX albo wyszukaj książkę po tytule.",
    howToStep2:
      "Styl {style} jest już wybrany na tej stronie, więc możesz od razu generować.",
    howToStep3:
      "Skopiuj wynik do swojego dokumentu albo zapisz go i wyeksportuj całą listę później.",
    relatedHeading: "Więcej materiałów o stylu {style}",
    englishOnlyNote:
      "Szczegółowe poradniki o stylu {style} oraz przykłady według rodzaju źródła są dostępne po angielsku.",
  },

  // The per-style pages at `/<locale>/citation-style/<slug>` — one per catalog style.
  //
  // The formatted examples the page is built around (the style's own output for a
  // fixed journal article, book and website) and the style's own name stay in
  // `src/data/citation-styles.ts` and `src/data/style-examples-generated.json`. They
  // are language-neutral: a citation rendered by the style's own CSL definition looks
  // the same whatever language the reader speaks, and "translating" one would make the
  // page wrong.
  //
  // The rest of what `src/data/**` supplies to these pages is NOT like that — see the
  // `generic*`, `discipline*` and `internationalLabel` keys below.
  citationStylePage: {
    notFoundTitle: "Nie znaleziono stylu cytowania",
    metaTitle: "Generator przypisów {style} - darmowy format {style}",
    metaFormatAndFields:
      "{style} to styl typu {format}, stosowany w: {fields}.",
    metaFormatOnly: "{style} to styl typu {format}.",
    metaFieldsOnly: "Styl {style} jest stosowany w: {fields}.",
    metaPromiseNote:
      "Zobacz prawdziwy przypis dolny w stylu {style} i wygeneruj własny za darmo.",
    metaPromiseExamples:
      "Zobacz prawdziwe przykłady cytowań w stylu {style} dla artykułu naukowego, książki i strony internetowej — i wygeneruj własny za darmo.",
    ogKindFormat: "styl {format}",
    ogKindDefault: "Styl cytowania",
    // Joins the style's discipline list: "psychology, education and nursing".
    disciplineConjunction: "i",
    // ---- Data-derived facts that are nonetheless mail-merged prose ----
    //
    // Every entry in `src/data/citation-styles-generated.ts` carries exactly the
    // two sentences below with their own name spliced in, exactly one region value
    // ("International" — that is `internationalLabel` above, reused rather than
    // duplicated), and discipline tokens drawn from a closed 26-word vocabulary. None
    // of that is a citation, so none of it is language-neutral the way the formatted
    // examples are. Left in `src/data/**` it renders English facts inside translated
    // chrome, which is precisely the hybrid page this tree exists to avoid.
    //
    // The page substitutes the two templates ONLY when a style's stored text is
    // byte-identical to the English template with its own name interpolated, so the
    // ~100 hand-curated styles keep their bespoke English descriptions instead of
    // being flattened into a generic sentence. `{name}` is the style's full name.
    genericDescription: "Styl {name}. Z repozytorium Citation Style Language.",
    genericWhenUsed:
      "Przy zgłaszaniu do publikacji stosujących styl {name} lub cytowaniu w takich publikacjach.",

    // The 26 discipline tokens `style-examples-generated.json` uses. Each English
    // value is the exact string the page printed before these keys existed — the raw
    // token with hyphens turned into spaces — so `generic-base` reads "generic base"
    // and `political_science` keeps its underscore. An unknown token (a new one from
    // upstream CSL) falls back to that same prettified form rather than to a key name.
    disciplineAnthropology: "antropologia",
    disciplineAstronomy: "astronomia",
    disciplineBiology: "biologia",
    disciplineBotany: "botanika",
    disciplineChemistry: "chemia",
    disciplineCommunications: "komunikacja społeczna",
    disciplineEngineering: "inżynieria",
    disciplineGenericBase: "ogólne",
    disciplineGeography: "geografia",
    disciplineGeology: "geologia",
    disciplineHistory: "historia",
    disciplineHumanities: "nauki humanistyczne",
    disciplineLaw: "prawo",
    disciplineLinguistics: "językoznawstwo",
    disciplineLiterature: "literaturoznawstwo",
    disciplineMath: "matematyka",
    disciplineMedicine: "medycyna",
    disciplinePhilosophy: "filozofia",
    disciplinePhysics: "fizyka",
    disciplinePoliticalScience: "politologia",
    disciplinePsychology: "psychologia",
    disciplineScience: "nauki przyrodnicze",
    disciplineSocialScience: "nauki społeczne",
    disciplineSociology: "socjologia",
    disciplineTheology: "teologia",
    disciplineZoology: "zoologia",

    // Plain-language descriptions of the citation-format classes the CSL definitions
    // declare. `{format}` in the fallback is the raw class name from the data.
    formatClassAuthorDate:
      "styl autor–data: cytowania w tekście podają nazwisko autora i rok, a wykaz literatury jest ułożony alfabetycznie według autorów",
    formatClassNumeric:
      "styl numeryczny: źródła są numerowane w kolejności pierwszego przywołania, a cytowania w tekście odwołują się do tych numerów",
    formatClassNote:
      "styl oparty na przypisach: cytowania pojawiają się w przypisach dolnych lub końcowych, a nie w nawiasach w tekście",
    formatClassLabel:
      "styl etykietowy: cytowania w tekście korzystają ze zwięzłej etykiety utworzonej z nazwiska autora i roku",
    formatClassAuthor:
      "styl wskazujący tylko autora: cytowania w tekście podają nazwisko autora, a pełne dane znajdują się w wykazie literatury",
    formatClassOther: "styl typu {format}",
    breadcrumbStyles: "Style cytowania",
    internationalLabel: "Międzynarodowy",
    heading: "Generator przypisów {style}",
    intro:
      "Twórz jednym kliknięciem dokładne cytowania w stylu {style} dla książek, artykułów i stron internetowych.",
    examplesHeading: "Przykłady cytowań w stylu {style}",
    examplesIntro: "Te same trzy źródła sformatowane w stylu {style}:",
    examplesIntroWithFormat:
      "Te same trzy źródła sformatowane w stylu {style} — {format}:",
    examplesNoteOnlyIntro:
      "{style} to styl oparty na przypisach: nie ma wykazu literatury, a każde cytowanie jest przypisem dolnym. Oto nasz przykładowy artykuł naukowy zacytowany w stylu {style}:",
    labelJournalArticle: "Artykuł naukowy",
    labelBook: "Książka",
    labelWebsite: "Strona internetowa",
    labelFootnote: "Przypis dolny (artykuł naukowy)",
    labelInText: "Cytowanie w tekście (dla artykułu naukowego)",
    aboutHeading: "O stylu {style}",
    whenToUseLabel: "Kiedy stosować {style}:",
    commonInLabel: "Popularny w:",
    subjectAreasLabel: "Dziedziny:",
    formattingRulesLabel: "Zasady formatowania:",
    parentStylePrefix: "{style} bazuje na formatowaniu stylu",
    parentStyleSuffix: ", na którym jest oparty.",
    howToHeading: "Jak korzystać z tego generatora {style}",
    howToBody:
      "Wklej powyżej DOI, adres URL artykułu prasowego lub strony internetowej albo surowy wpis BibTeX. Możesz też wyszukać książkę po tytule lub autorze i zacytować ją po numerze ISBN. Wybierz „{style}” z listy stylów (jest już wstępnie zaznaczony na tej stronie), a następnie kliknij „Generuj cytowanie”. Skopiuj wynik do swojego wykazu literatury lub bibliografii. Przed skopiowaniem możesz edytować wygenerowany opis (np. poprawić tytuł lub dodać datę).",
    faqHeading: "Najczęstsze pytania o stylu {style}",
    faqWhatIsQ: "Czym jest styl {style}?",
    faqWhenQ: "Kiedy warto stosować {style}?",
    faqInTextQ: "Jak wygląda cytowanie w tekście w stylu {style}?",
    faqInTextA:
      "{style} to {format}. Cytowanie naszego przykładowego artykułu naukowego w tekście wygląda tak: {example}",
    faqReferenceQ: "Jak wygląda pozycja w wykazie literatury w stylu {style}?",
    faqReferenceA:
      "Artykuł naukowy sformatowany w stylu {style} wygląda tak: {example}",
    faqWhereQ: "Gdzie powszechnie stosuje się styl {style}?",
    faqWhereA: "Styl {style} jest stosowany {region}. {whenUsed}",
    faqRegionDefault: "międzynarodowo",
    faqGenerateQ: "Jak wygenerować cytowanie w stylu {style}?",
    faqGenerateA:
      "Skorzystaj z darmowego generatora na tej stronie: wklej DOI, adres URL (np. artykułu prasowego) lub BibTeX, albo wyszukaj książkę po tytule lub autorze. Wybierz styl {style} i kliknij „Generuj cytowanie”, aby otrzymać sformatowany opis, który skopiujesz do swojej pracy lub bibliografii.",
    footerSupports:
      "obsługuje wiele stylów cytowania z całego świata. Nasz generator korzysta ze stylów Citation Style Language (CSL) z",
    footerRepoLink: "oficjalnego repozytorium CSL",
  },

  // The source × style pages at `/<locale>/how-to-cite/<slug>` — 1,290 combinations.
  //
  // Same division as above: the citation templates, the worked examples generated from
  // each style's own CSL definition, the in-text samples and the hand-checked
  // formatting rules stay in the page module and in
  // `src/data/how-to-cite-examples-generated.json`. They are the citations themselves,
  // not prose about them. Source names, style names and editions come from
  // `src/data/how-to-cite.ts` and arrive here as placeholder values.
  crossLinks: {
    generateHeading: "Wygeneruj ten przypis",
    generateBody:
      "Wklej adres URL, DOI, ISBN lub dane źródła, aby zacytować {source} w stylu {style} — gotowy przypis otrzymasz od razu.",
    generateCta: "Otwórz {tool} →",
    guideHeading: "Dowiedz się więcej",
    guideCta: "Przeczytaj pełny poradnik: {guide}",
    howToCiteHeading: "Jak cytować {source} w każdym stylu",
    howToCiteBody:
      "Zasady formatowania, szablony i rozwiązane przykłady dla najczęściej wymaganych stylów.",
    howToCiteMore: "Wszystkie typy źródeł i style →",
    citeNowHeading: "Zacytuj {source} w stylu {style} teraz",
    citeNowHowTo: "Zasady formatowania i rozwiązane przykłady",
    citeNowTool: "Wygeneruj za pomocą narzędzia {tool}",
    citeNowHub: "Generator cytowań {style}",
    hubSourcesHeading: "Jak cytować popularne źródła w stylu {style}",
    hubGuidesHeading: "Poradniki {style}",
    hubCompareHeading: "Porównaj {style} z innymi stylami",
    moreInCollection: "Więcej z kategorii {collection}",
    seeAllInCollection: "Zobacz wszystkie z kategorii {collection}",
  },

  howToCitePage: {
    notFoundTitle: "Nie znaleziono",
    title: "Jak zacytować {source} w stylu {style} ({edition})",
    metaTitle:
      "Jak zacytować {source} w stylu {style} [{edition}, aktualizacja 2026]",
    metaDescription:
      "Dowiedz się, jak zacytować {description} w formacie {style} ({edition}). Darmowe przykłady, szablony i wskazówki dotyczące cytowania w tekście.",
    keywordCite: "przypis {style} {source}",
    keywordCitation: "cytowanie {style} {source}",
    keywordHowTo: "{source} jak cytować",
    keywordExample: "przykład cytowania {style}",
    keywordReference: "{source} w bibliografii {style}",
    // What each style calls the list at the back of the paper, in the two casings the
    // prose needs. MLA says "Works Cited", Chicago and the legal styles "Bibliography".
    refListWorksCited: "Prace cytowane",
    refListWorksCitedPage: "prace cytowane",
    refListBibliography: "Bibliografia",
    refListBibliographyLower: "bibliografia",
    refListReferenceList: "Wykaz literatury",
    refListReferenceListLower: "wykaz literatury",
    backLink: "← Wszystkie poradniki cytowania",
    lead: "Dowiedz się, jak zacytować {description} w formacie {style} ({edition}). Ten poradnik obejmuje format wykazu literatury, przykłady cytowań w tekście oraz najważniejsze zasady formatowania.",
    referenceFormatHeading: "Format „{list}” w stylu {style}",
    referenceFormatIntro:
      "Oto standardowy format {style}, według którego zapiszesz {source} w sekcji „{list}”:",
    noTemplateNote:
      "Zastosuj standardowy szablon {style} dla tego rodzaju źródła.",
    workedHeading: "Przykład w stylu {style}: jak zacytować {source}",
    workedIntro:
      "Tak zacytujesz {source} w stylu {style} — pełny opis bibliograficzny sformatowany na podstawie oficjalnej definicji stylu CSL {style}, czyli tego samego mechanizmu, który napędza generator na tej stronie:",
    workedNoteOnlyIntro:
      "Gdy cytujesz {source}, styl {style} nie tworzy osobnej pozycji w sekcji „{list}” — takie źródło jest cytowane wyłącznie w przypisie. Oto ten przypis, sformatowany na podstawie oficjalnej definicji stylu CSL {style}:",
    workedOscolaNote:
      "Wynik OSCOLA generowany na tej stronie podąża za stylem CSL 4. wydania, ponieważ w repozytorium Citation Style Language nie opublikowano jeszcze stylu CSL 5. wydania. Popraw go ręcznie: zastąp każde ibid krótką nazwą i (n X), użyj identyfikatorów sądów z 5. wydania, ujmij skróconą formę ustawy w pojedyncze cudzysłowy i preferuj trwały link lub DOI zamiast daty dostępu",
    workedCheckedIntro:
      "Tak zacytujesz {source} w stylu {style} — pełny opis bibliograficzny napisany ręcznie i sprawdzony pod kątem zgodności z oficjalnymi wytycznymi stylu {style} dla tego rodzaju źródła:",
    workedCheckedNoteOnlyIntro:
      "Gdy cytujesz {source}, styl {style} nie tworzy osobnej pozycji w sekcji „{list}” — takie źródło jest cytowane wyłącznie w przypisie. Oto ten przypis, napisany ręcznie i sprawdzony pod kątem zgodności z oficjalnymi wytycznymi stylu {style}:",
    workedInTextLabel: "Odpowiadające cytowanie w tekście:",
    inTextHeading: "Cytowanie w tekście w stylu {style}",
    inTextIntro:
      "Użyj jednego z poniższych formatów, odwołując się do tego źródła w swojej pracy:",
    inTextParenthetical: "Nawiasowe",
    inTextNarrative: "Narracyjne",
    rulesHeading: "Najważniejsze zasady formatowania w stylu {style}",
    stepsHeading: "Instrukcja krok po kroku",
    step1Label: "Zbierz informacje o źródle:",
    step1Body:
      "Gdy źródłem jest {source}, zbierz nazwisko autora, tytuł, datę publikacji oraz adres URL lub DOI.",
    step2Label: "Sformatuj opis bibliograficzny:",
    step2Body:
      "Ułóż elementy zgodnie z szablonem {style} ({edition}) przedstawionym powyżej.",
    step3Label: "Utwórz cytowanie w tekście:",
    step3Body:
      "Dodaj w swojej pracy cytowanie nawiasowe lub narracyjne w miejscu, w którym odwołujesz się do tego źródła.",
    step4Label: "Dodaj do swojej listy „{list}”:",
    step4Body: "Umieść pełny, sformatowany opis na końcu swojej pracy.",
    step5Label: "Sprawdź dokładnie formatowanie:",
    step5Body:
      "Sprawdź, czy kursywa, interpunkcja, wielkość liter i wcięcia wiszące odpowiadają wymaganiom stylu {style}.",
    ctaHeading: "Wygeneruj to cytowanie automatycznie",
    ctaBody:
      "Pomiń ręczne formatowanie. Wklej DOI, adres URL lub ISBN do CitationEasy i w kilka sekund otrzymaj bezbłędnie sformatowane cytowanie w stylu {style}.",
    ctaButton: "Zacytuj w stylu {style} teraz →",
    otherStylesHeading: "Zacytuj {source} w innych stylach",
    comboLink: "{source} w stylu {style}",
    otherSourcesHeading: "Zacytuj inne źródła w stylu {style}",
    resourcesHeading: "Więcej materiałów",
    resourceGenerator: "Darmowy generator przypisów ({count} style)",
    resourceTools: "Darmowe narzędzia do pisania",
    resourceCompare: "Porównaj style cytowania",
    resourceGuides: "Wszystkie poradniki cytowania",
    resourceCheatSheets: "Ściągawki (APA, MLA, Chicago)",
    resourceGlossary:
      "Słowniczek cytowania (et al., ibid., DOI, wcięcie wiszące)",
    // HowTo structured data. Deliberately worded differently from the visible steps
    // above: the schema describes the task generically, the page walks the reader
    // through this particular source and style.
    schemaStep1Name: "Zbierz informacje o źródle",
    schemaStep1Text:
      "Zbierz wszystkie niezbędne informacje o źródle ({source}): autora, tytuł, datę oraz adres URL lub DOI.",
    schemaStep2Name: "Sformatuj w stylu {style}",
    schemaStep2Text:
      "Zastosuj zasady formatowania {style} ({edition}), aby ułożyć elementy cytowania we właściwej kolejności.",
    schemaStep3Name: "Utwórz cytowanie w tekście",
    schemaStep3Text:
      "Dodaj w swojej pracy odpowiadające cytowanie w tekście, stosując format {style}.",
    schemaStep4Name: "Dodaj do wykazu literatury",
    schemaStep4Text: "Umieść pełne cytowanie w sekcji „{list}” na końcu pracy.",
    faqHowQ: "Jak zacytować {source} w stylu {style}?",
    faqHowA:
      "Aby zacytować {source} w stylu {style} ({edition}), podaj autora, tytuł, datę i miejsce publikacji źródła. Skorzystaj z naszego darmowego generatora przypisów, aby sformatować je automatycznie.",
    faqFormatQ: "Jakiego formatu {style} użyć, aby zacytować {source}?",
    faqFormatA:
      "Aby zacytować {source} w stylu {style}, zastosuj ten format: {example}",
    faqFormatFallback:
      "Format {style} wymaga określonych elementów, takich jak autor, tytuł, data i miejsce publikacji, ułożonych w konkretnej kolejności.",
    faqInTextQ: "Jak w tekście pracy powołać się na {source} w stylu {style}?",
    faqInTextA:
      "W stylu {style} cytowanie w tekście dla powyższego przykładu wygląda tak: {example}",
  },

  // The 43 source types the how-to-cite pages are built from (`SOURCE_TYPES` in
  // `src/data/how-to-cite.ts`), in the five forms those pages print. Each form is a whole
  // phrase, never an article and a noun joined in code: an article agrees with its noun
  // in gender, number and case, elides in French and Italian, and has no counterpart
  // at all in Polish, Russian or Japanese.
  //
  // - `…Name` ("Book") is the type on its own, as a label: `howToCitePage.comboLink`.
  //   English also lower-cases it into the `keyword*` templates.
  // - `…Title` ("a Book") is the type as the object of "cite" in a title or heading:
  //   `title`, `metaTitle`, `workedHeading` and `otherStylesHeading`, plus
  //   `crossLinks.generateBody`, `howToCiteHeading` and `citeNowHeading`. Through
  //   `title` it is also the HowTo name, the OG card and every link to the page.
  // - `…Phrase` ("a book") is the same inside a sentence: `referenceFormatIntro`,
  //   `workedIntro`, `workedNoteOnlyIntro` and the five `faq*` questions and answers.
  // - `…Noun` ("book") is the bare noun inside a sentence, where English puts "your" in
  //   front of it: `step1Body` and `schemaStep1Text`. A translation also uses it in the
  //   `keyword*` templates, which read as search queries.
  // - `…Description` is what the type covers: `{description}` in `lead` and
  //   `metaDescription`.
  //
  // A language with case picks one case per form and words every template above around
  // it — German writes Title and Phrase in the accusative, Polish and Russian write Name
  // and Noun in the nominative. Changing a form's case means re-reading every template
  // that receives it. A key missing here falls back to the English data
  // (`howToCiteSourceForms`), so a new source type renders in English, not as a key.
  // Polish: Name, Noun nominative; Title, Phrase, Description accusative ("książkę").
  howToCiteSources: {
    websiteName: "Strona internetowa",
    websiteTitle: "stronę internetową",
    websitePhrase: "stronę internetową",
    websiteNoun: "strona internetowa",
    websiteDescription:
      "strony internetowe, artykuły online i inne treści internetowe",

    bookName: "Książka",
    bookTitle: "książkę",
    bookPhrase: "książkę",
    bookNoun: "książka",
    bookDescription: "książki drukowane i elektroniczne",

    journalArticleName: "Artykuł naukowy",
    journalArticleTitle: "artykuł naukowy",
    journalArticlePhrase: "artykuł naukowy",
    journalArticleNoun: "artykuł naukowy",
    journalArticleDescription:
      "recenzowane artykuły z czasopism naukowych i akademickich",

    youtubeVideoName: "Film na YouTube",
    youtubeVideoTitle: "film na YouTube",
    youtubeVideoPhrase: "film na YouTube",
    youtubeVideoNoun: "film na YouTube",
    youtubeVideoDescription: "filmy z YouTube i inne nagrania wideo online",

    podcastName: "Podcast",
    podcastTitle: "podcast",
    podcastPhrase: "podcast",
    podcastNoun: "podcast",
    podcastDescription: "pojedyncze odcinki i całe serie podcastów",

    newspaperArticleName: "Artykuł prasowy",
    newspaperArticleTitle: "artykuł prasowy",
    newspaperArticlePhrase: "artykuł prasowy",
    newspaperArticleNoun: "artykuł prasowy",
    newspaperArticleDescription: "artykuły z gazet drukowanych i internetowych",

    magazineArticleName: "Artykuł z czasopisma",
    magazineArticleTitle: "artykuł z czasopisma",
    magazineArticlePhrase: "artykuł z czasopisma",
    magazineArticleNoun: "artykuł z czasopisma",
    magazineArticleDescription:
      "artykuły z czasopism drukowanych i internetowych",

    blogPostName: "Wpis na blogu",
    blogPostTitle: "wpis na blogu",
    blogPostPhrase: "wpis na blogu",
    blogPostNoun: "wpis na blogu",
    blogPostDescription: "wpisy na blogach i internetowe teksty publicystyczne",

    wikipediaName: "Wikipedia",
    wikipediaTitle: "Wikipedię",
    wikipediaPhrase: "Wikipedię",
    wikipediaNoun: "Wikipedia",
    wikipediaDescription: "artykuły z Wikipedii i hasła z innych serwisów wiki",

    pdfName: "Dokument PDF",
    pdfTitle: "dokument PDF",
    pdfPhrase: "dokument PDF",
    pdfNoun: "dokument PDF",
    pdfDescription: "dokumenty i raporty PDF",

    interviewName: "Wywiad",
    interviewTitle: "wywiad",
    interviewPhrase: "wywiad",
    interviewNoun: "wywiad",
    interviewDescription: "wywiady osobiste, prasowe, radiowe i telewizyjne",

    socialMediaName: "Post w mediach społecznościowych",
    socialMediaTitle: "post w mediach społecznościowych",
    socialMediaPhrase: "post w mediach społecznościowych",
    socialMediaNoun: "post w mediach społecznościowych",
    socialMediaDescription:
      "tweety, posty na Instagramie i Facebooku oraz filmy na TikToku",

    governmentDocumentName: "Dokument rządowy",
    governmentDocumentTitle: "dokument rządowy",
    governmentDocumentPhrase: "dokument rządowy",
    governmentDocumentNoun: "dokument rządowy",
    governmentDocumentDescription:
      "raporty rządowe, akty prawne i dokumenty urzędowe",

    dissertationName: "Praca doktorska lub dyplomowa",
    dissertationTitle: "pracę doktorską lub dyplomową",
    dissertationPhrase: "pracę doktorską lub dyplomową",
    dissertationNoun: "praca doktorska lub dyplomowa",
    dissertationDescription: "rozprawy doktorskie i prace magisterskie",

    conferencePaperName: "Referat konferencyjny",
    conferencePaperTitle: "referat konferencyjny",
    conferencePaperPhrase: "referat konferencyjny",
    conferencePaperNoun: "referat konferencyjny",
    conferencePaperDescription:
      "materiały konferencyjne i wystąpienia na konferencjach",

    lectureNotesName: "Wykład lub prezentacja PowerPoint",
    lectureNotesTitle: "wykład lub prezentację PowerPoint",
    lectureNotesPhrase: "wykład lub prezentację PowerPoint",
    lectureNotesNoun: "wykład lub prezentacja PowerPoint",
    lectureNotesDescription: "wykłady, slajdy i materiały z zajęć",

    webinarName: "Webinar",
    webinarTitle: "webinar",
    webinarPhrase: "webinar",
    webinarNoun: "webinar",
    webinarDescription: "webinary i seminaria internetowe (na żywo i nagrane)",

    onlineCourseName: "Kurs online",
    onlineCourseTitle: "kurs online",
    onlineCoursePhrase: "kurs online",
    onlineCourseNoun: "kurs online",
    onlineCourseDescription:
      "kursy online i kursy MOOC (Coursera, edX, Udemy, FutureLearn)",

    presentationSlidesName: "Prezentacja PowerPoint",
    presentationSlidesTitle: "prezentację PowerPoint",
    presentationSlidesPhrase: "prezentację PowerPoint",
    presentationSlidesNoun: "prezentacja PowerPoint",
    presentationSlidesDescription:
      "prezentacje PowerPoint i inne zestawy slajdów",

    imageName: "Obraz lub zdjęcie",
    imageTitle: "obraz lub zdjęcie",
    imagePhrase: "obraz lub zdjęcie",
    imageNoun: "obraz lub zdjęcie",
    imageDescription: "zdjęcia, dzieła sztuki, wykresy i obrazy z internetu",

    movieName: "Film",
    movieTitle: "film",
    moviePhrase: "film",
    movieNoun: "film",
    movieDescription: "film",

    documentaryName: "Film dokumentalny",
    documentaryTitle: "film dokumentalny",
    documentaryPhrase: "film dokumentalny",
    documentaryNoun: "film dokumentalny",
    documentaryDescription: "filmy dokumentalne i inne filmy niefabularne",

    tvShowName: "Program telewizyjny",
    tvShowTitle: "program telewizyjny",
    tvShowPhrase: "program telewizyjny",
    tvShowNoun: "program telewizyjny",
    tvShowDescription: "program lub serial telewizyjny",

    songName: "Piosenka lub utwór muzyczny",
    songTitle: "piosenkę lub utwór muzyczny",
    songPhrase: "piosenkę lub utwór muzyczny",
    songNoun: "piosenka lub utwór muzyczny",
    songDescription: "piosenkę lub nagranie muzyczne",

    poemName: "Wiersz",
    poemTitle: "wiersz",
    poemPhrase: "wiersz",
    poemNoun: "wiersz",
    poemDescription: "wiersze i inne utwory poetyckie z antologii lub tomików",

    courtCaseName: "Sprawa sądowa",
    courtCaseTitle: "sprawę sądową",
    courtCasePhrase: "sprawę sądową",
    courtCaseNoun: "sprawa sądowa",
    courtCaseDescription: "sprawę sądową lub orzeczenie sądu",

    patentName: "Patent",
    patentTitle: "patent",
    patentPhrase: "patent",
    patentNoun: "patent",
    patentDescription:
      "patent lub inne zgłoszenie z zakresu własności intelektualnej",

    encyclopediaName: "Hasło encyklopedyczne",
    encyclopediaTitle: "hasło encyklopedyczne",
    encyclopediaPhrase: "hasło encyklopedyczne",
    encyclopediaNoun: "hasło encyklopedyczne",
    encyclopediaDescription: "artykuł lub hasło z encyklopedii",

    dictionaryName: "Hasło słownikowe",
    dictionaryTitle: "hasło słownikowe",
    dictionaryPhrase: "hasło słownikowe",
    dictionaryNoun: "hasło słownikowe",
    dictionaryDescription: "definicję lub hasło ze słownika",

    datasetName: "Zbiór danych",
    datasetTitle: "zbiór danych",
    datasetPhrase: "zbiór danych",
    datasetNoun: "zbiór danych",
    datasetDescription: "zbiór danych lub bazę danych",

    softwareName: "Oprogramowanie lub aplikacja",
    softwareTitle: "oprogramowanie lub aplikację",
    softwarePhrase: "oprogramowanie lub aplikację",
    softwareNoun: "oprogramowanie lub aplikacja",
    softwareDescription: "oprogramowanie, aplikację lub program komputerowy",

    videoGameName: "Gra wideo",
    videoGameTitle: "grę wideo",
    videoGamePhrase: "grę wideo",
    videoGameNoun: "gra wideo",
    videoGameDescription: "gry wideo i interaktywne oprogramowanie rozrywkowe",

    pressReleaseName: "Komunikat prasowy",
    pressReleaseTitle: "komunikat prasowy",
    pressReleasePhrase: "komunikat prasowy",
    pressReleaseNoun: "komunikat prasowy",
    pressReleaseDescription: "komunikat prasowy lub informację prasową",

    reportName: "Raport",
    reportTitle: "raport",
    reportPhrase: "raport",
    reportNoun: "raport",
    reportDescription: "raport lub białą księgę",

    preprintName: "Preprint",
    preprintTitle: "preprint",
    preprintPhrase: "preprint",
    preprintNoun: "preprint",
    preprintDescription:
      "artykuły z arXiv, bioRxiv i innych serwerów preprintów",

    bookChapterName: "Rozdział książki",
    bookChapterTitle: "rozdział książki",
    bookChapterPhrase: "rozdział książki",
    bookChapterNoun: "rozdział książki",
    bookChapterDescription: "rozdziały i eseje w pracach zbiorowych",

    chatgptName: "ChatGPT",
    chatgptTitle: "ChatGPT",
    chatgptPhrase: "ChatGPT",
    chatgptNoun: "ChatGPT",
    chatgptDescription:
      "ChatGPT i inne narzędzia generatywnej sztucznej inteligencji",

    bibleName: "Biblia",
    bibleTitle: "Biblię",
    biblePhrase: "Biblię",
    bibleNoun: "Biblia",
    bibleDescription: "Biblię oraz inne pisma święte i teksty religijne",

    tedTalkName: "Wystąpienie TED",
    tedTalkTitle: "wystąpienie TED",
    tedTalkPhrase: "wystąpienie TED",
    tedTalkNoun: "wystąpienie TED",
    tedTalkDescription:
      "wystąpienia TED i inne nagrane prelekcje z konferencji",

    emailName: "E-mail",
    emailTitle: "e-mail",
    emailPhrase: "e-mail",
    emailNoun: "e-mail",
    emailDescription: "e-maile, listy i inną komunikację osobistą",

    redditName: "Post na Reddicie lub forum",
    redditTitle: "post na Reddicie lub forum",
    redditPhrase: "post na Reddicie",
    redditNoun: "post na Reddicie",
    redditDescription:
      "wątki na Reddicie, sesje AMA oraz posty na forach i internetowych grupach dyskusyjnych",

    tweetName: "Post na X (Twitterze)",
    tweetTitle: "post na X (Twitterze)",
    tweetPhrase: "post na X",
    tweetNoun: "post na X",
    tweetDescription: "tweety i posty na X (dawniej Twitterze)",

    mapName: "Mapa",
    mapTitle: "mapę",
    mapPhrase: "mapę",
    mapNoun: "mapa",
    mapDescription:
      "mapy drukowane, atlasy oraz mapy interaktywne (np. Google Maps)",

    claudeName: "Claude",
    claudeTitle: "Claude",
    claudePhrase: "Claude",
    claudeNoun: "Claude",
    claudeDescription: "czaty z Claude i inne odpowiedzi AI firmy Anthropic",

    geminiName: "Gemini",
    geminiTitle: "Gemini",
    geminiPhrase: "Gemini",
    geminiNoun: "Gemini",
    geminiDescription: "czaty z Google Gemini i odpowiedzi AI",

    copilotName: "Microsoft Copilot",
    copilotTitle: "Microsoft Copilot",
    copilotPhrase: "Microsoft Copilot",
    copilotNoun: "Microsoft Copilot",
    copilotDescription: "czaty z Microsoft Copilot i odpowiedzi AI",

    perplexityName: "Perplexity",
    perplexityTitle: "Perplexity",
    perplexityPhrase: "Perplexity",
    perplexityNoun: "Perplexity",
    perplexityDescription:
      "odpowiedzi i wątki Perplexity AI oraz cytowane w nich źródła",

    aiImageName: "Obraz wygenerowany przez AI",
    aiImageTitle: "obraz wygenerowany przez AI",
    aiImagePhrase: "obraz wygenerowany przez AI",
    aiImageNoun: "obraz wygenerowany przez AI",
    aiImageDescription:
      "obrazy utworzone w DALL·E, Midjourney, Gemini i innych narzędziach AI",

    tiktokName: "Film na TikToku",
    tiktokTitle: "film na TikToku",
    tiktokPhrase: "film na TikToku",
    tiktokNoun: "film na TikToku",
    tiktokDescription: "filmy na TikToku i posty twórców",

    instagramName: "Post na Instagramie",
    instagramTitle: "post na Instagramie",
    instagramPhrase: "post na Instagramie",
    instagramNoun: "post na Instagramie",
    instagramDescription: "posty, rolki i relacje na Instagramie",

    statuteName: "Ustawa lub akt prawny",
    statuteTitle: "ustawę lub akt prawny",
    statutePhrase: "ustawę lub akt prawny",
    statuteNoun: "ustawa lub akt prawny",
    statuteDescription: "ustawy, akty prawne i skodyfikowane przepisy",

    isoStandardName: "Norma ISO",
    isoStandardTitle: "normę ISO",
    isoStandardPhrase: "normę ISO",
    isoStandardNoun: "norma ISO",
    isoStandardDescription:
      "normy ISO, IEC i inne opublikowane normy techniczne",

    quranName: "Koran",
    quranTitle: "Koran",
    quranPhrase: "Koran",
    quranNoun: "Koran",
    quranDescription: "Koran w języku arabskim lub w przekładzie",

    ebookNoPageNumbersName: "E-book bez numerów stron",
    ebookNoPageNumbersTitle: "e-book bez numerów stron",
    ebookNoPageNumbersPhrase: "e-book bez numerów stron",
    ebookNoPageNumbersNoun: "e-book bez numerów stron",
    ebookNoPageNumbersDescription:
      "e-booki na Kindle, w formacie EPUB i online, które nie mają stałych numerów stron",

    speechName: "Przemówienie",
    speechTitle: "przemówienie",
    speechPhrase: "przemówienie",
    speechNoun: "przemówienie",
    speechDescription:
      "przemówienia, wystąpienia i kazania — na żywo lub w nagraniu",

    letterName: "List",
    letterTitle: "list",
    letterPhrase: "list",
    letterNoun: "list",
    letterDescription: "opublikowane listy, listy archiwalne i listy otwarte",

    secondarySourceName: "Źródło wtórne",
    secondarySourceTitle: "źródło wtórne",
    secondarySourcePhrase: "źródło wtórne",
    secondarySourceNoun: "źródło wtórne",
    secondarySourceDescription: "źródło przytoczone lub cytowane w innej pracy",
  },

  // ---------------------------------------------------------------------------
  // NOT YET TRANSLATED. These five sections were copied verbatim from `en.ts` so
  // this file still satisfies `Dictionary`; the page types they cover
  // (`taxonomy`, `compare`, `convert`) are deliberately absent from
  // TRANSLATED_PAGE_TYPES, so nothing publishes them in this language yet. The
  // translation pass replaces the strings and only then adds the types.
  // ---------------------------------------------------------------------------
  // The three browse-by-facet pages under `/<locale>/citation-styles/…` — 32 academic
  // fields, 68 countries and 39 subject categories, 139 pages in one section because
  // they share a shell, a breadcrumb trail and a styles browser.
  //
  // The style NAMES, slugs and the CSL catalog itself stay in `src/data/**`: those are
  // subject matter. What the facets themselves are called is not — "Political Science",
  // "United Kingdom" and "Film & Media" are ordinary nouns that every reader expects in
  // their own language, and there are only 139 of them in total (see the `academicFields`,
  // `regions` and `styleCategories` sections below).
  taxonomyPage: {
    // ---- /citation-styles/field/<slug> ----
    fieldNotFoundTitle: "Nie znaleziono",
    fieldMetaTitle:
      "Style cytowania w dziedzinie: {field} - najlepsze style bibliograficzne [2026]",
    fieldMetaDescription:
      "Poznaj najczęściej stosowane style cytowania w dziedzinie: {field}. Znajdź właściwy format bibliograficzny dla pracy, rozprawy lub artykułu naukowego w dziedzinie «{fieldLower}».",
    fieldOgTitle: "Style cytowania w dziedzinie: {field}",
    fieldOgSubtitle: "Najczęściej wymagane: {styles}.",
    fieldOgKind: "Według dziedziny naukowej",
    fieldKeywordStyle: "styl cytowania «{field}»",
    fieldKeywordReferencing: "cytowanie «{field}»",
    fieldKeywordBest: "najlepszy styl cytowania dla dziedziny «{fieldLower}»",
    fieldKeywordBibliography: "format bibliografii w dziedzinie «{fieldLower}»",
    fieldKeywordDiscipline: "style cytowania według dziedzin",
    fieldBackLink: "← Wszystkie style cytowania",
    fieldHeading: "Style cytowania w dziedzinie: {field}",
    fieldRecommendedHeading: "Polecane style cytowania",
    fieldRecommendedIntro:
      "Poniższe style cytowania są powszechnie stosowane w badaniach, czasopismach i pracach zaliczeniowych z dziedziny «{field}». Wybierz styl, aby dowiedzieć się więcej i zacząć generować cytowania.",
    fieldStyleFallback:
      "Styl cytowania stosowany w dziedzinie «{field}» i dziedzinach pokrewnych.",
    fieldRelatedHeading: "Powiązane dziedziny",
    fieldRelatedIntro:
      "Poznaj style cytowania stosowane w pokrewnych dziedzinach naukowych:",
    fieldCtaHeading: "Poznaj wszystkie style cytowania",
    fieldCtaBody:
      "CitationEasy obsługuje {count} stylów cytowania ze wszystkich dziedzin naukowych. Przejrzyj pełną kolekcję, aby znaleźć dokładnie taki format, jakiego potrzebujesz.",
    fieldCtaButton: "Przeglądaj wszystkie style →",
    fieldFaqWhichQ:
      "Jaki styl cytowania jest stosowany w dziedzinie «{field}»?",
    fieldFaqWhichA:
      "Styl cytowania stosowany w dziedzinie «{field}» zależy od konkretnego czasopisma, instytucji lub wymagań prowadzącego zajęcia. Popularne style to m.in. {styles}. Zawsze sprawdź wytyczne swojego zadania lub wymagania czasopisma docelowego dotyczące wymaganego formatu.",
    fieldFaqSameQ:
      "Czy wszystkie czasopisma z dziedziny «{field}» stosują ten sam styl?",
    fieldFaqSameA:
      "Nie, czasopisma z dziedziny «{field}» nie zawsze stosują ten sam styl cytowania. Choć niektóre style są w tej dziedzinie bardziej popularne, poszczególne czasopisma mogą mieć własne wymagania formatowania. Zawsze sprawdź wytyczne dla autorów danego czasopisma przed przygotowaniem manuskryptu.",
    fieldFaqChooseQ:
      "Jak wybrać styl cytowania do pracy z dziedziny «{field}»?",
    fieldFaqChooseA:
      "Aby wybrać styl cytowania do pracy z dziedziny «{field}», sprawdź najpierw, czy prowadzący zajęcia lub czasopismo docelowe wskazują wymagany styl. Jeśli nie, skorzystaj z jednego z polecanych powyżej stylów dla dziedziny «{field}». CitationEasy obsługuje ponad {count} stylów i może za darmo wygenerować cytowanie w każdym z nich.",

    // ---- /citation-styles/country/<slug> ----
    countryNotFoundTitle: "Nie znaleziono kraju",
    countryMetaTitle: "Style cytowania - {country} - APA, MLA i inne",
    countryMetaDescription:
      "Przeglądaj style cytowania stosowane w kraju: {country}. Darmowy generator przypisów dla formatów z kraju: {country}.",
    countryOgTitle: "Style cytowania stosowane w kraju: {country}",
    countryOgKind: "Według kraju",
    countryHeading: "Style cytowania — {country}",
    countryIntroOne:
      "{count} styl cytowania powszechnie stosowany w kraju: {country} lub z nim kojarzony. Wybierz go, aby otworzyć dedykowany generator.",
    countryIntroMany:
      "{count} stylów cytowania powszechnie stosowanych w kraju: {country} lub z nim kojarzonych. Wybierz jeden, aby otworzyć dedykowany generator.",
    countryBrowserTitle: "Style cytowania — {country}",

    // ---- /citation-styles/type/<slug> ----
    typeNotFoundTitle: "Nie znaleziono kategorii",
    typeMetaTitle: "Style cytowania - {type} - darmowy generator",
    typeMetaDescription:
      "Style cytowania dla kategorii «{typeLower}». APA, MLA, Vancouver i inne. Darmowy generator przypisów.",
    typeOgTitle: "Style cytowania - {type}",
    typeOgKind: "Według kategorii",
    typeHeading: "Style cytowania — {type}",
    typeIntroOne:
      "{count} styl cytowania dla kategorii «{typeLower}». Wybierz go, aby otworzyć dedykowany generator z FAQ.",
    typeIntroMany:
      "{count} stylów cytowania dla kategorii «{typeLower}». Wybierz jeden, aby otworzyć dedykowany generator z FAQ.",
    typeBrowserTitle: "Style cytowania — {type}",

    // ---- Shared chrome ----
    breadcrumbStyles: "Style cytowania",
    // Title case, because the BreadcrumbList markup says "Citation Styles" while the
    // visible trail says "Citation styles". Two keys rather than one so translating
    // either does not silently change the other.
    breadcrumbStylesSchema: "Style cytowania",
    breadcrumbByCountry: "Według kraju",
    breadcrumbByDiscipline: "Według dziedziny",
    allStylesLink: "← Wszystkie style cytowania",
    internationalLabel: "Międzynarodowy",
  },

  // The 32 academic fields (`ACADEMIC_FIELDS` in src/data/style-pages.ts), keyed by
  // slug. Their one-sentence `description` is next door in `academicFieldDescriptions`.
  academicFields: {
    psychology: "Psychologia",
    education: "Pedagogika",
    sociology: "Socjologia",
    anthropology: "Antropologia",
    politicalScience: "Nauki polityczne",
    economics: "Ekonomia",
    business: "Biznes i zarządzanie",
    literature: "Literatura i języki",
    history: "Historia",
    philosophy: "Filozofia",
    law: "Prawo i nauki prawne",
    medicine: "Medycyna i nauki kliniczne",
    nursing: "Pielęgniarstwo i położnictwo",
    publicHealth: "Zdrowie publiczne i epidemiologia",
    pharmacy: "Farmacja",
    biology: "Biologia i nauki przyrodnicze",
    chemistry: "Chemia",
    physics: "Fizyka",
    engineering: "Inżynieria",
    computerScience: "Informatyka",
    mathematics: "Matematyka i statystyka",
    environmentalScience: "Nauki o środowisku",
    earthScience: "Nauki o Ziemi i geologia",
    artHistory: "Historia sztuki i sztuki wizualne",
    music: "Muzyka i muzykologia",
    theology: "Teologia i religioznawstwo",
    socialWork: "Praca socjalna",
    linguistics: "Językoznawstwo",
    architecture: "Architektura i urbanistyka",
    filmMedia: "Filmoznawstwo i medioznawstwo",
    journalism: "Dziennikarstwo i komunikacja społeczna",
    criminology: "Kryminologia i wymiar sprawiedliwości karnej",
  },

  // The same 32 fields' one-sentence ledes — the opening paragraph of every
  // `/citation-styles/field/<slug>` page.
  //
  // Unlike everything above, these are hand-written per field rather than mail-merged
  // from a template, which is why the extraction pass left them in
  // `src/data/style-pages.ts`: translating them is a content job, not a string swap.
  // But "hand-written" describes how they were produced, not where they belong. With
  // the chrome translated and the lede still English, the page is the hybrid CLAUDE.md
  // calls worse than an honest redirect — translated furniture around an English core.
  // `academicFieldDescription()` (src/lib/i18n/data-labels.ts) falls back to the data
  // file's own value, so a field added upstream is untranslated rather than blank.
  academicFieldDescriptions: {
    psychology:
      "Style cytowania powszechnie stosowane w psychologii, naukach behawioralnych i badaniach nad poznaniem.",
    education:
      "Style cytowania dla badań edukacyjnych, pedagogiki i badań nad programami nauczania.",
    sociology:
      "Style cytowania stosowane w badaniach socjologicznych i teorii społecznej.",
    anthropology:
      "Style cytowania dla badań antropologicznych i etnograficznych.",
    politicalScience:
      "Style cytowania dla nauk politycznych, administracji publicznej i badań nad polityką publiczną.",
    economics:
      "Style cytowania stosowane w badaniach ekonomicznych i ekonometrycznych.",
    business:
      "Style cytowania dla badań z zakresu biznesu, zarządzania, marketingu i finansów.",
    literature:
      "Style cytowania dla literaturoznawstwa, językoznawstwa i badań nad językiem.",
    history:
      "Style cytowania dla badań historycznych, historiografii i badań archiwalnych.",
    philosophy:
      "Style cytowania dla tekstów filozoficznych i badań z zakresu etyki.",
    law: "Prawnicze style cytowania dla dokumentów sądowych, czasopism prawniczych i literatury prawniczej.",
    medicine:
      "Style cytowania dla badań medycznych, badań klinicznych i ochrony zdrowia.",
    nursing:
      "Style cytowania dla badań pielęgniarskich i praktyki w ochronie zdrowia.",
    publicHealth:
      "Style cytowania dla badań nad zdrowiem publicznym i badań epidemiologicznych.",
    pharmacy: "Style cytowania dla badań farmaceutycznych i farmakologicznych.",
    biology: "Style cytowania dla badań biologicznych, ekologii i genetyki.",
    chemistry:
      "Style cytowania dla chemii, biochemii i badań z zakresu nauki o materiałach.",
    physics:
      "Style cytowania dla fizyki, astrofizyki i badań z zakresu fizyki stosowanej.",
    engineering:
      "Style cytowania dla inżynierii i badań nad technologią stosowaną.",
    computerScience:
      "Style cytowania dla informatyki, badań nad AI i inżynierii oprogramowania.",
    mathematics:
      "Style cytowania dla matematyki, matematyki stosowanej i statystyki.",
    environmentalScience:
      "Style cytowania dla badań środowiskowych i badań nad zrównoważonym rozwojem.",
    earthScience: "Style cytowania dla geologii, geofizyki i nauk o Ziemi.",
    artHistory:
      "Style cytowania dla historii sztuki, kultury wizualnej i muzealnictwa.",
    music:
      "Style cytowania dla badań muzykologicznych, teorii muzyki i praktyki wykonawczej.",
    theology: "Style cytowania dla badań teologicznych i religioznawczych.",
    socialWork: "Style cytowania dla badań i praktyki w pracy socjalnej.",
    linguistics:
      "Style cytowania dla językoznawstwa, fonetyki i nauki o języku.",
    architecture:
      "Style cytowania dla architektury, urbanistyki i badań planistycznych.",
    filmMedia:
      "Style cytowania dla filmoznawstwa, telewizji, medioznawstwa i komunikacji.",
    journalism:
      "Style cytowania dla dziennikarstwa, medioznawstwa i badań nad komunikacją.",
    criminology:
      "Style cytowania dla kryminologii i badań nad wymiarem sprawiedliwości karnej.",
  },

  // The 68 country/region facets (`REGIONS` in src/data/citation-styles.ts), keyed by
  // slug. `getRegionCountryCode` still keys off the English data value, so translating these
  // moves the label without moving the flag.
  regions: {
    unitedStates: "Stany Zjednoczone",
    unitedKingdom: "Wielka Brytania",
    australia: "Australia",
    canada: "Kanada",
    newZealand: "Nowa Zelandia",
    ireland: "Irlandia",
    southAfrica: "RPA",
    germany: "Niemcy",
    france: "Francja",
    spain: "Hiszpania",
    italy: "Włochy",
    netherlands: "Holandia",
    belgium: "Belgia",
    switzerland: "Szwajcaria",
    austria: "Austria",
    portugal: "Portugalia",
    luxembourg: "Luksemburg",
    sweden: "Szwecja",
    norway: "Norwegia",
    denmark: "Dania",
    finland: "Finlandia",
    iceland: "Islandia",
    poland: "Polska",
    czechRepublic: "Czechy",
    hungary: "Węgry",
    romania: "Rumunia",
    russia: "Rosja",
    ukraine: "Ukraina",
    greece: "Grecja",
    turkey: "Turcja",
    croatia: "Chorwacja",
    slovenia: "Słowenia",
    slovakia: "Słowacja",
    serbia: "Serbia",
    bulgaria: "Bułgaria",
    lithuania: "Litwa",
    latvia: "Łotwa",
    estonia: "Estonia",
    japan: "Japonia",
    china: "Chiny",
    southKorea: "Korea Południowa",
    india: "Indie",
    singapore: "Singapur",
    hongKong: "Hongkong",
    taiwan: "Tajwan",
    malaysia: "Malezja",
    indonesia: "Indonezja",
    thailand: "Tajlandia",
    vietnam: "Wietnam",
    philippines: "Filipiny",
    pakistan: "Pakistan",
    bangladesh: "Bangladesz",
    sriLanka: "Sri Lanka",
    israel: "Izrael",
    saudiArabia: "Arabia Saudyjska",
    unitedArabEmirates: "Zjednoczone Emiraty Arabskie",
    brazil: "Brazylia",
    mexico: "Meksyk",
    argentina: "Argentyna",
    chile: "Chile",
    colombia: "Kolumbia",
    peru: "Peru",
    venezuela: "Wenezuela",
    egypt: "Egipt",
    nigeria: "Nigeria",
    kenya: "Kenia",
    morocco: "Maroko",
    international: "Międzynarodowy",
  },

  // The 39 subject categories (`CATEGORIES` in src/data/citation-styles.ts), keyed by
  // slug. The emoji beside each one stays in the data — it is language-neutral.
  styleCategories: {
    medicine: "Medycyna",
    nursing: "Pielęgniarstwo",
    publicHealth: "Zdrowie publiczne",
    pharmacy: "Farmacja",
    dentistry: "Stomatologia",
    veterinary: "Weterynaria",
    psychology: "Psychologia",
    sociology: "Socjologia",
    anthropology: "Antropologia",
    politicalScience: "Nauki polityczne",
    economics: "Ekonomia",
    education: "Pedagogika",
    socialWork: "Praca socjalna",
    biology: "Biologia",
    chemistry: "Chemia",
    physics: "Fizyka",
    environmentalScience: "Nauki o środowisku",
    earthScience: "Nauki o Ziemi i geologia",
    agriculture: "Rolnictwo",
    ecology: "Ekologia",
    engineering: "Inżynieria",
    computerScience: "Informatyka",
    mathematics: "Matematyka",
    statistics: "Statystyka",
    history: "Historia",
    literature: "Literatura",
    philosophy: "Filozofia",
    linguistics: "Językoznawstwo",
    artHistory: "Historia sztuki",
    music: "Muzyka",
    filmMedia: "Film i media",
    archaeology: "Archeologia",
    law: "Prawo",
    business: "Biznes",
    architecture: "Architektura",
    religion: "Religia i teologia",
    geography: "Geografia",
    general: "Ogólne / interdyscyplinarne",
    other: "Inne",
  },

  // The closed vocabularies `STYLE_LANDING_PAGES` (src/data/style-pages.ts) draws on for
  // the 30 major styles: what each style calls its end-of-paper list, the shape of its
  // in-text citation, its edition, and the disciplines that require it. The comparison
  // pages print all four in a table and the field pages print two of them under every
  // style card, so leaving them in the data means a translated page with an English
  // table in the middle of it.
  //
  // Style NAMES (`name`, `fullName`) are NOT here: a style's official name is what it
  // is called everywhere. The 30 hand-written taglines are, in `styleTaglines` below.
  styleFacts: {
    // `referenceListName` — 6 distinct values across the 30 styles.
    listReferenceList: "Wykaz literatury",
    listWorksCited: "Prace cytowane",
    listReferences: "Bibliografia",
    listBibliography: "Spis bibliograficzny",
    listTableOfAuthorities: "Wykaz aktów prawnych i orzecznictwa",
    listReferencesCited: "Cytowana literatura",
    listLowerReferenceList: "wykaz literatury",
    listLowerWorksCited: "prace cytowane",
    listLowerReferences: "bibliografia",
    listLowerBibliography: "spis bibliograficzny",
    listLowerTableOfAuthorities: "wykaz aktów prawnych i orzecznictwa",
    listLowerReferencesCited: "cytowana literatura",

    // `inTextFormat` — 14 distinct values. "Author", "Year" and "Page" are slot names,
    // not part of the citation, so they read as English words on a Spanish page.
    inTextAuthorCommaYear: "(Autor, Rok)",
    inTextAuthorPage: "(Autor Strona)",
    inTextAuthorYear: "(Autor Rok)",
    inTextSuperscriptOrBracketed: "Indeks górny lub liczby w nawiasach (1)",
    inTextBracketedNumbers: "Liczby w nawiasach kwadratowych [1]",
    inTextSuperscriptNumbers: "Liczby w indeksie górnym¹",
    inTextSuperscriptOrAuthorYear: "Liczby w indeksie górnym lub (Autor Rok)",
    inTextKeyBased: "Odniesienia oparte na kluczu",
    inTextSuperscriptOrAuthorCommaYear:
      "Liczby w indeksie górnym lub (Autor, Rok)",
    inTextFootnotesCaseLegislation:
      "Przypisy dolne z cytowaniami orzeczeń i aktów prawnych",
    inTextFootnotesSignals: "Przypisy dolne ze skrótami sygnalizującymi",
    inTextFootnotesPinpoint: "Przypisy dolne z precyzyjnym odniesieniem",
    inTextParenNumbers: "Liczby w nawiasach (1)",
    inTextItalicNumbers: "Liczby kursywą (1)",

    // `edition` — 12 distinct values. The ordinal and the word "edition" translate; the
    // handbook name inside "Cite Them Right 11th edition" does not.
    edition4th: "4. wydanie",
    edition5th: "5. wydanie",
    edition7th: "7. wydanie",
    edition8th: "8. wydanie",
    edition9th: "9. wydanie",
    edition11th: "11. wydanie",
    edition18th: "18. wydanie",
    edition22nd: "22. wydanie",
    editionCiteThemRight11th: "Cite Them Right, wydanie 11",
    editionIcmjeStandard: "standard ICMJE",
    editionStandard: "wydanie standardowe",
    editionCurrent: "wydanie bieżące",

    // `fields` — the 67 discipline names the 30 styles are tagged with.
    fieldAcoustics: "akustyka",
    fieldAnthropology: "antropologia",
    fieldAppliedPhysics: "fizyka stosowana",
    fieldArchaeology: "archeologia",
    fieldArts: "sztuka",
    fieldAstrophysics: "astrofizyka",
    fieldAustralianLaw: "prawo australijskie",
    fieldBiochemistry: "biochemia",
    fieldBiology: "biologia",
    fieldBiomedicalSciences: "nauki biomedyczne",
    fieldBiotechnology: "biotechnologia",
    fieldBusiness: "biznes",
    fieldCellBiology: "biologia komórki",
    fieldChemicalEngineering: "inżynieria chemiczna",
    fieldChemistry: "chemia",
    fieldClinicalResearch: "badania kliniczne",
    fieldComputerScience: "informatyka",
    fieldCondensedMatter: "fizyka materii skondensowanej",
    fieldCourtDocuments: "dokumenty sądowe",
    fieldCriminology: "kryminologia",
    fieldCulturalStudies: "kulturoznawstwo",
    fieldDemography: "demografia",
    fieldEcology: "ekologia",
    fieldEducation: "pedagogika",
    fieldElectronics: "elektronika",
    fieldEngineering: "inżynieria",
    fieldEnvironmentalScience: "nauki o środowisku",
    fieldEpidemiology: "epidemiologia",
    fieldEthnography: "etnografia",
    fieldGenetics: "genetyka",
    fieldGeology: "geologia",
    fieldGlobalHealth: "zdrowie globalne",
    fieldHealthSciences: "nauki o zdrowiu",
    fieldHistory: "historia",
    fieldHumanities: "nauki humanistyczne",
    fieldInformationSystems: "systemy informacyjne",
    fieldInformationTechnology: "technologia informacyjna",
    fieldInternationalRelations: "stosunki międzynarodowe",
    fieldJurisprudence: "jurysprudencja",
    fieldLanguages: "języki",
    fieldLaw: "prawo",
    fieldLawReview: "przegląd prawniczy",
    fieldLegalStudies: "nauki prawne",
    fieldLifeSciences: "nauki o życiu",
    fieldLiterature: "literaturoznawstwo",
    fieldMaterialsScience: "inżynieria materiałowa",
    fieldMathematics: "matematyka",
    fieldMedicine: "medycyna",
    fieldMolecularBiology: "biologia molekularna",
    fieldMultidisciplinary: "interdyscyplinarne",
    fieldMultidisciplinaryScience: "nauki interdyscyplinarne",
    fieldNaturalSciences: "nauki przyrodnicze",
    fieldNursing: "pielęgniarstwo",
    fieldPharmacy: "farmacja",
    fieldPhysics: "fizyka",
    fieldPoliticalScience: "nauki polityczne",
    fieldPsychology: "psychologia",
    fieldPublicHealth: "zdrowie publiczne",
    fieldPublicPolicy: "polityka publiczna",
    fieldPublishing: "wydawnictwo",
    fieldScience: "nauka",
    fieldSciences: "nauki ścisłe",
    fieldSocialSciences: "nauki społeczne",
    fieldSocialWork: "praca socjalna",
    fieldSociology: "socjologia",
    fieldSoftwareEngineering: "inżynieria oprogramowania",
    fieldTheology: "teologia",
  },

  // The 30 major styles' hero taglines (`STYLE_LANDING_PAGES[].tagline`), keyed by
  // slug.
  //
  // Per-page hand-written copy, not a template — which is why they outlived the
  // extraction pass in `src/data/style-pages.ts`. Three page types print them: the
  // style landing page's hero, the card for each recommended style on a field
  // taxonomy page, and the lower-cased clause inside a comparison page's opening
  // sentence ("APA (…) is the most widely used citation style in the social
  // sciences"). Leaving them in the data means an English sentence in the first
  // paragraph of an otherwise translated page. `styleTagline()`
  // (src/lib/i18n/data-labels.ts) falls back to the data file's own value.
  styleTaglines: {
    apa: "Najczęściej stosowany styl cytowania w naukach społecznych",
    mla: "Standardowy styl cytowania w naukach humanistycznych",
    chicago:
      "Najbardziej zaufany przewodnik stylistyczny w Ameryce dla autorów, redaktorów i wydawców",
    harvard:
      "Najpopularniejszy styl cytowania na uniwersytetach w Wielkiej Brytanii i Australii",
    vancouver:
      "Standardowy styl cytowania w czasopismach medycznych i biomedycznych",
    ieee: "Podstawowy styl cytowania w inżynierii i informatyce",
    ama: "Standard cytowania w amerykańskich czasopismach medycznych",
    turabian: "Przyjazna dla studentów wersja stylu Chicago",
    cse: "Preferowany styl cytowania w naukach przyrodniczych i ścisłych",
    bibtex:
      "Format bibliografii dla użytkowników LaTeksa i składu akademickiego",
    nature:
      "Styl cytowania stosowany przez wiodące na świecie czasopismo multidyscyplinarne",
    acs: "Standard cytowania w chemii i naukach chemicznych",
    oscola:
      "Standardowy prawniczy styl cytowania na brytyjskich wydziałach prawa i w czasopismach prawniczych",
    bluebook:
      "Podstawowy prawniczy system cytowania w sądach i czasopismach prawniczych w USA",
    aglc: "Standardowy prawniczy styl cytowania na australijskich wydziałach prawa i w sądach",
    asa: "Standardowy styl cytowania w socjologii i badaniach społecznych",
    apsa: "Styl cytowania stosowany w badaniach i czasopismach z zakresu nauk politycznych",
    aaa: "Standardowy styl cytowania w badaniach antropologicznych",
    nlm: "Standard cytowania stosowany przez PubMed i amerykańską National Library of Medicine",
    acm: "Styl cytowania na potrzeby konferencji ACM i badań informatycznych",
    aps: "Styl cytowania stosowany w Physical Review i czasopismach APS",
    aip: "Styl cytowania stosowany w czasopismach AIP i fizycznych",
    cell: "Styl cytowania stosowany przez Cell Press i czołowe czasopisma biologiczne",
    science: "Styl cytowania czasopisma Science i czasopism AAAS",
    plos: "Styl cytowania stosowany w czasopismach open access wydawnictwa PLOS",
    bmj: "Styl cytowania stosowany przez BMJ i czołowe brytyjskie czasopisma medyczne",
    lancet: "Styl cytowania stosowany w rodzinie czasopism The Lancet",
    jama: "Styl cytowania stosowany przez JAMA i czasopisma sieci JAMA Network",
    elsevierHarvard:
      "Wariant stylu Harvard stosowany w czasopismach wydawnictwa Elsevier",
    springer:
      "Styl cytowania stosowany w czasopismach i książkach Springer Nature",
  },

  // The 105 style-versus-style pages at `/<locale>/compare/<slug>`.
  //
  // The two style names arrive as placeholder values and are never translated. The
  // facts in the table come from `styleFacts` above and the taglines from
  // `styleTaglines`; only `fullName` stays in `src/data/style-pages.ts`, because an
  // official name is the same in every language.
  comparePage: {
    notFoundTitle: "Nie znaleziono",
    metaTitle: "{a} vs {b} - najważniejsze różnice [2026]",
    metaDescription:
      "Porównaj style cytowania {a} i {b} obok siebie. Poznaj najważniejsze różnice w formatowaniu, cytowaniu w tekście i wykazach literatury, aby wybrać właściwy styl dla swojej pracy.",
    ogTitle: "{a} vs {b}",
    ogSubtitle:
      "Format cytowania w tekście, wpisy w wykazie literatury, wielkość liter oraz dziedziny, w których wymagany jest każdy z nich.",
    ogKind: "Porównanie stylów",
    keywordVs: "{a} vs {b}",
    keywordVersus: "{a} kontra {b}",
    keywordDifference: "różnica między {a} a {b}",
    keywordOr: "{a} czy {b}",
    keywordComparison: "porównanie stylów cytowania",
    breadcrumbCompare: "Porównaj style",
    breadcrumbCurrent: "{a} vs {b}",
    backLink: "← Wróć do narzędzia porównania",
    heading: "{a} vs {b}: najważniejsze różnice",
    intro:
      "{a} i {b} to dwa z najczęściej stosowanych stylów cytowania w środowisku akademickim, ale różnią się pod ważnymi względami. {introA} {introB} Zrozumienie tych różnic pomoże Ci wybrać właściwy format dla Twojej pracy.",
    styleIntro: "{style} ({fullName}) {tagline}.",
    styleIntroFallback:
      "{style} to popularny styl cytowania stosowany w wielu dziedzinach naukowych.",
    tableHeading: "Porównanie obok siebie",
    tableFeature: "Cecha",
    tableCitationSystem: "System cytowania",
    tableInText: "Format w tekście",
    tableReferenceList: "Nazwa wykazu",
    tableEdition: "Wydanie",
    tableCommonFields: "Popularne dziedziny",
    // Title case, for the table cell. `styleLanding.system*` says "Author–date" for the
    // fact list on the style landing pages; both spellings are deliberate.
    systemAuthorDate: "Autor–data",
    systemNumbered: "Numeryczny",
    systemFootnotes: "Przypisy dolne",
    // The same three systems inside a sentence ("uses a numbered citation system").
    describeAuthorDate: "nawiasowy autor–data",
    describeNumbered: "numeryczny",
    describeFootnotes: "oparty na przypisach dolnych",
    whenToUseHeading: "Kiedy stosować {style}",
    whenToUseBody:
      "{style} ({fullName}) wykorzystuje system cytowania: {system}, z cytowaniem w tekście w formacie: {inText}, oraz „{list}” na końcu pracy. Jest najczęściej stosowany w: {fields}{more}.",
    whenToUseMoreFields: ", oraz pokrewnych dziedzinach",
    whenToUseFallback:
      "{style} to powszechnie uznawany styl cytowania. Sprawdź wytyczne swojego zadania lub wymagania czasopisma docelowego, aby potwierdzić, czy {style} jest wymaganym formatem.",
    ctaHeading: "Zobacz różnicę w praktyce",
    ctaBodyBefore: "Wypróbuj nasze",
    ctaBodyLink: "interaktywne narzędzie do porównywania",
    ctaBodyAfter:
      ", aby porównać cytowania {a} i {b} obok siebie za pomocą własnych źródeł.",
    ctaCiteIn: "Cytuj w stylu {style} →",
    faqDifferenceQ: "Jaka jest różnica między {a} a {b}?",
    faqDifferenceA:
      "{a} i {b} różnią się formatem cytowania w tekście, strukturą wykazu literatury oraz dziedzinami naukowymi, w których są stosowane. {detail}",
    faqDifferenceDetail:
      "{a} stosuje cytowania w tekście w formacie {inTextA} oraz „{listA}” jako wykaz literatury, natomiast {b} stosuje format {inTextB} oraz „{listB}”.",
    faqDifferenceDetailFallback:
      "Każdy styl ma odrębne zasady formatowania cytowań, organizowania bibliografii i obsługi różnych typów źródeł.",
    faqBetterQ: "Który styl jest lepszy: {a} czy {b}?",
    faqBetterA:
      "Ani {a}, ani {b} nie jest z natury lepszy. Właściwy wybór zależy od Twojej dziedziny naukowej, wymagań prowadzącego zajęcia lub czasopisma, do którego się zgłaszasz. Sprawdź wytyczne swojego zadania lub publikacji docelowej, aby ustalić, którego stylu użyć.",
    faqSwitchQ: "Czy mogę przełączać się między {a} a {b}?",
    faqSwitchA:
      "Tak, możesz przełączać się między {a} a {b}, korzystając z darmowego generatora przypisów CitationEasy. Po prostu wybierz żądany styl, a Twoje cytowania zostaną automatycznie przeformatowane. Pamiętaj jednak, aby w jednej pracy stosować tylko jeden styl, chyba że prowadzący zajęcia zaleci inaczej.",
  },

  // The ~21 converter-pair pages at `/<locale>/convert/<slug>`.
  //
  // Only the shell is here; each pair's own four strings are in `converterCopy` below.
  // The format names (DOI, ISBN, BibTeX, RIS, CSL-JSON, PubMed ID, arXiv ID, Word) are
  // identifiers, never translated.
  converterPage: {
    notFoundTitle: "Nie znaleziono konwertera",
    metaTitle: "{title} - za darmo i błyskawicznie",
    ogTitle: "{title}",
    ogKind: "Konwerter",
    breadcrumbConverters: "Konwertery",
    breadcrumbLabel: "Ścieżka nawigacji",
    whenHeading: "Kiedy tego potrzebujesz",
    relatedHeading: "Powiązane konwertery",
    allConverters: "Wszystkie konwertery",
    formatConverterTool: "Konwerter formatów cytowań",
    faqHowQ: "Jak przekonwertować {input} na {output}?",
    faqHowA: "{intro} Wszystko jest darmowe, bez konta i bez limitu konwersji.",
    faqPrivacyQ: "Czy moje dane są gdzieś przesyłane?",
    faqPrivacyIdentifier:
      "Każdy identyfikator {input} jest wyszukiwany w odpowiedniej publicznej bazie metadanych (Crossref dla DOI, PubMed dla PMID, katalogi biblioteczne dla ISBN), a wysyłany jest wyłącznie sam identyfikator — nigdy Twoje dokumenty. Sformatowane wyniki możesz kopiować lub pobierać; nic nie jest przechowywane.",
    faqPrivacyLocal:
      "Nie — {input}, który wklejasz lub przesyłasz, jest analizowany w całości w Twojej przeglądarce. {detail}",
    faqPrivacyDetailStyle:
      "Do naszego formatera wysyłane są wyłącznie odczytane pola opisu bibliograficznego (autor, tytuł, rok) potrzebne do wygenerowania cytowań; sam plik nigdy nie opuszcza Twojego urządzenia.",
    faqPrivacyDetailOffline:
      "Konwersja odbywa się całkowicie offline, bezpośrednio na stronie — nic nie jest wysyłane na żaden serwer.",
    faqUsefulQ: "Kiedy przydaje się konwersja {input} na {output}?",
    faqOtherQ: "Czy mogę konwertować także do innych stylów i formatów?",
    faqOtherA:
      "Tak. Generator CitationEasy formatuje dowolne źródło w {count} stylach cytowania, bibliografię można wyeksportować do Worda, RTF, BibTeX, RIS i CSL-JSON, a centrum konwerterów zawiera listę wszystkich bezpośrednich par konwersji. Jeśli potrzebujesz przepisania już sformatowanego tekstu z jednego stylu na inny, skorzystaj zamiast tego z narzędzia Konwerter formatów cytowań.",
  },

  // The 21 converter pairs' own copy (`CONVERTER_PAIRS` in src/data/converters.ts),
  // keyed by slug: title, meta description, the intro paragraph under the H1, and the
  // "when you need this" paragraph.
  //
  // Four hand-written strings per pair, and `src/data/converters.ts` has a quality rule
  // saying they must stay hand-written — no mail-merged sentences, because mass-templated
  // pages are what earned the site a scaled-content penalty. That rule is about how the
  // copy is authored; it says nothing about which language a reader gets it in. Left in
  // the data file they are the entire body of an otherwise translated page.
  // `converterPairCopy()` (src/lib/i18n/data-labels.ts) returns all four at once and
  // falls back to the data file per field, so a converter added upstream ships English
  // copy rather than a blank page.
  converterCopy: {
    doiToApaTitle: "Konwerter cytowań DOI na APA",
    doiToApaMetaDescription:
      "Wklej DOI (po jednym w wierszu) i błyskawicznie otrzymaj opisy bibliograficzne w stylu APA 7, pobrane z oficjalnych metadanych Crossref wydawcy. Za darmo, bez konta.",
    doiToApaIntro:
      "DOI już wskazuje na autorytatywne metadane wydawcy, więc nie ma powodu, aby ręcznie przepisywać opis bibliograficzny w stylu APA. Wklej po jednym DOI w wierszu, a każdy zostanie przekształcony w pełny opis APA 7 — nazwiska autorów w odwróconej kolejności, tytuł zapisany zdaniowo, tytuł czasopisma kursywą oraz wymagany przez APA link https://doi.org/.",
    doiToApaUseCase:
      "Typowa sytuacja: prowadzący wymaga bibliografii w stylu APA, a Ty masz tylko stertę numerów DOI zebranych podczas czytania. Wklej całość, skopiuj gotową listę.",
    doiToMlaTitle: "Konwerter cytowań DOI na MLA",
    doiToMlaMetaDescription:
      "Automatycznie zamień DOI na wpisy do wykazu literatury w stylu MLA 9, wykorzystując metadane Crossref. Wklej po jednym DOI w wierszu — za darmo, bez instalacji.",
    doiToMlaIntro:
      "MLA 9 traktuje artykuł z czasopisma jako łańcuch elementów — tytuł artykułu w cudzysłowie, tytuł czasopisma kursywą, rocznik, numer, rok, strony — co ręcznie trudno poprawnie ułożyć. Wyszukiwanie po DOI wypełnia każde pole na podstawie rekordu wydawcy, dzięki czemu wpis od razu wychodzi poprawnie.",
    doiToMlaUseCase:
      "Przydatne, gdy zajęcia humanistyczne wymagają stylu MLA, a Twoje źródła pochodzą z baz nastawionych na nauki ścisłe, gdzie dostajesz jedynie numery DOI.",
    doiToBibtexTitle: "Konwerter DOI na BibTeX",
    doiToBibtexMetaDescription:
      "Zamień DOI na wpisy BibTeX dla LaTeksa i Overleafa. Wklej po jednym DOI w wierszu, pobierz gotowy plik .bib — za darmo i bez limitu.",
    doiToBibtexIntro:
      "Każda praca w LaTeksie prędzej czy później potrzebuje pliku .bib. Wklej numery DOI wiersz po wierszu, a otrzymasz czyste wpisy @article z wygenerowanymi kluczami cytowania, gotowe dla Overleafa, natbib czy biblatex — bez ręcznego przepisywania pól ze stron wydawców.",
    doiToBibtexUseCase:
      "Klasyczny scenariusz: recenzent przesyła Ci trzy prace do zacytowania, masz ich numery DOI, a termin mija dziś wieczorem. Wklej, pobierz, użyj \\cite.",
    doiToRisTitle: "Konwerter DOI na RIS",
    doiToRisMetaDescription:
      "Zamień DOI na plik RIS, który Zotero, Mendeley i EndNote importują bezpośrednio. Wklej numery DOI wiersz po wierszu — za darmo, bez rejestracji.",
    doiToRisIntro:
      "RIS to format wymiany, który importuje każdy menedżer bibliografii. Wklej numery DOI i pobierz plik .ris, którego pola TY/AU/TI/T2 pochodzą wprost z Crossref — następnie zaimportuj go poleceniem Plik → Importuj do Zotero, Mendeley lub EndNote, a wpisy pojawią się w pełni ustrukturyzowane.",
    doiToRisUseCase:
      "Idealne rozwiązanie, aby przenieść ręcznie zebraną listę DOI do prawdziwego menedżera bibliografii bez ponownego wpisywania choćby jednego nazwiska autora.",
    isbnToApaTitle: "Konwerter cytowań ISBN na APA",
    isbnToApaMetaDescription:
      "Automatycznie zamień numery ISBN na opisy książek w stylu APA 7. Wklej po jednym ISBN w wierszu i skopiuj gotową listę — za darmo, bez konta.",
    isbnToApaIntro:
      "ISBN znajdujący się na stronie redakcyjnej książki to wszystko, czego potrzeba do jej opisu w stylu APA. Każdy numer ISBN jest wyszukiwany w metadanych bibliotecznych i formatowany zgodnie ze stylem APA 7 — autor, rok, tytuł kursywą i wydawca — łącznie z informacją o wydaniu, jeśli znajduje się w rekordzie.",
    isbnToApaUseCase:
      "Najszybszy sposób na zacytowanie stosu papierowych książek z biblioteki: otwórz każdą na stronie redakcyjnej, wpisz numery ISBN, wklej listę tutaj.",
    isbnToMlaTitle: "Konwerter cytowań ISBN na MLA",
    isbnToMlaMetaDescription:
      "Zamień numery ISBN na wpisy do wykazu literatury w stylu MLA 9 za jednym razem. Darmowe wyszukiwanie ISBN z gotowym formatowaniem — bez rejestracji.",
    isbnToMlaIntro:
      "Wpisy książkowe w stylu MLA 9 są krótkie — autor, tytuł kursywą, wydawca, rok — ale poprawne odwrócenie nazwiska autora i interpunkcja wciąż sprawiają trudność. Wyszukiwanie po ISBN zwraca rzeczywisty rekord katalogowy książki i formatuje go zgodnie z szablonem podstawowych elementów podręcznika MLA.",
    isbnToMlaUseCase:
      "Idealne do prac z literatury: zacytuj każdą powieść i monografię krytyczną leżącą na biurku, wpisując wyłącznie numery z tylnej okładki.",
    isbnToBibtexTitle: "Konwerter ISBN na BibTeX",
    isbnToBibtexMetaDescription:
      "Zamień numery ISBN na wpisy BibTeX typu @book dla LaTeksa. Wklej po jednym ISBN w wierszu, pobierz plik .bib — za darmo i natychmiast.",
    isbnToBibtexIntro:
      "Książki to niewygodny kącik BibTeksa — nie ma DOI do wyszukania, a strony wydawców rzadko oferują eksport do .bib. Ten konwerter dopasowuje każdy numer ISBN do metadanych bibliotecznych i tworzy wpisy @book z wypełnionymi polami autora, tytułu, wydawcy i roku.",
    isbnToBibtexUseCase:
      "Dla piszących prace dyplomowe: rozdziały metodologiczne cytują numery DOI artykułów, ale rozdział teoretyczny cytuje dwanaście książek. Te dwanaście książek załatwia właśnie ten konwerter.",
    pmidToApaTitle: "Konwerter cytowań PMID na APA",
    pmidToApaMetaDescription:
      "Automatycznie zamień identyfikatory PubMed na opisy bibliograficzne w stylu APA 7. Wklej numery PMID wiersz po wierszu i otrzymaj gotową listę — za darmo.",
    pmidToApaIntro:
      "Każdy rekord PubMed ma swój numer PMID, a kierunki psychologii i pielęgniarstwa niemal zawsze wymagają stylu APA. Wklej numery PMID wiersz po wierszu, a każdy zostanie przekształcony — na podstawie własnych metadanych PubMed — w pełny opis czasopisma w stylu APA 7, wraz z linkiem DOI, jeśli rekord go zawiera.",
    pmidToApaUseCase:
      "Stworzone z myślą o pracach opartych na praktyce opartej na dowodach: Twoja strategia wyszukiwania kończy się listą numerów PMID, a praca wymaga ich w stylu APA.",
    pmidToRisTitle: "Konwerter PMID na RIS",
    pmidToRisMetaDescription:
      "Zamień identyfikatory PubMed na plik RIS dla Zotero, Mendeley lub EndNote. Wklej numery PMID wiersz po wierszu, pobierz plik .ris — za darmo.",
    pmidToRisIntro:
      "Przeglądy systematyczne opierają się na plikach RIS. Wklej numery PMID ze swojego wyszukiwania w PubMed i pobierz plik .ris gotowy dla narzędzia do selekcji lub menedżera bibliografii — każdy rekord zbudowany na podstawie kanonicznych metadanych PubMed, a nie zeskrobanego tekstu.",
    pmidToRisUseCase:
      "Przydaje się w trakcie przeglądu, gdy współpracownik przesyła Ci mailem pięć dodatkowych numerów PMID z prośbą „dołącz też te badania”, a Twoja biblioteka działa w EndNote.",
    arxivToBibtexTitle: "Konwerter arXiv na BibTeX",
    arxivToBibtexMetaDescription:
      "Zamień identyfikatory arXiv na wpisy BibTeX dla prac w LaTeksie. Wklej identyfikatory takie jak 2301.12345, po jednym w wierszu, i pobierz plik .bib — za darmo.",
    arxivToBibtexIntro:
      "W szybko rozwijających się dziedzinach preprinty są cytowane bez przerwy, a identyfikatory arXiv (takie jak 2301.12345) to sposób, w jaki krążą. Wklej identyfikatory, a otrzymasz wpisy BibTeX z autorami, tytułem, rokiem i linkiem arXiv preprintu — gotowe do pliku .bib Twojej pracy.",
    arxivToBibtexUseCase:
      "Dla osób piszących w dziedzinie ML i fizyki, u których sekcja przeglądu literatury w 80% składa się z arXiv: zbieraj identyfikatory podczas czytania, a podczas pisania zamień je wszystkie za jednym razem.",
    bibtexToApaTitle: "Konwerter BibTeX na APA",
    bibtexToApaMetaDescription:
      "Wklej lub prześlij plik .bib i otrzymaj listę literatury w stylu APA 7. Obsługuje pliki z wieloma wpisami — za darmo, analiza odbywa się w Twojej przeglądarce.",
    bibtexToApaIntro:
      "Czasem praca opuszcza LaTeksa: czasopismo chce zgłoszenia w Wordzie albo komisja chce listy literatury jako zwykłego tekstu. Wklej swój kod BibTeX (lub prześlij plik .bib), a każdy wpis zostanie przeanalizowany w Twojej przeglądarce i sformatowany jako lista literatury w stylu APA 7, którą wkleisz do dowolnego dokumentu.",
    bibtexToApaUseCase:
      "Klasyczny przypadek wniosków grantowych: Twoja lista publikacji znajduje się w pliku .bib, a formularz grantodawcy wymaga opisów bibliograficznych w stylu APA wpisanych w pole tekstowe.",
    bibtexToMlaTitle: "Konwerter BibTeX na MLA",
    bibtexToMlaMetaDescription:
      "Zamień BibTeX na wpisy do wykazu literatury w stylu MLA 9. Wklej lub prześlij plik .bib i skopiuj gotową listę — za darmo, bez konta.",
    bibtexToMlaIntro:
      "BibTeX przechowuje surowe pola; MLA precyzyjnie określa sposób ich rozmieszczenia. Ten konwerter analizuje wpisy z pliku .bib lokalnie i przekształca każdy z nich zgodnie z szablonem MLA 9 — odwrócona kolejność nazwiska autora, tytuły artykułów w cudzysłowie, kursywą zapisane kontenery oraz poprawna interpunkcja między elementami.",
    bibtexToMlaUseCase:
      "Dla badaczy łączących dziedziny: Twoje odniesienia znajdują się w BibTeksie z wcześniejszej pracy w LaTeksie, a czasopismo humanistyczne, do którego się zgłaszasz, wymaga stylu MLA.",
    bibtexToRisTitle: "Konwerter BibTeX na RIS",
    bibtexToRisMetaDescription:
      "Zamień plik .bib na RIS dla Zotero, Mendeley lub EndNote. Wklej lub prześlij BibTeX, pobierz plik .ris — za darmo i offline.",
    bibtexToRisIntro:
      "Przejście z narzędzi LaTeksowych do menedżera bibliografii oznacza przetłumaczenie wpisów @article/@book z BibTeksa na znaczniki TY/AU/TI formatu RIS. Konwersja odbywa się w całości w Twojej przeglądarce — łącznie z mapowaniem pól — i daje w efekcie plik .ris, który zaimportuje dowolny menedżer.",
    bibtexToRisUseCase:
      "Typowy powód: nowy współautor pracuje w Zotero, wasze wspólne odniesienia to plik .bib w repozytorium, a ktoś musi połączyć te dwa światy.",
    bibtexToCslJsonTitle: "Konwerter BibTeX na CSL-JSON",
    bibtexToCslJsonMetaDescription:
      "Zamień BibTeX na CSL-JSON dla Pandoc i Quarto. Wklej lub prześlij plik .bib, pobierz references.json — za darmo, bezpośrednio w przeglądarce.",
    bibtexToCslJsonIntro:
      "Pandoc i Quarto natywnie cytują z CSL-JSON, a konwersja istniejącego pliku .bib usuwa jeden z ruchomych elementów procesu budowania. Wpisy są analizowane w Twojej przeglądarce i wychodzą jako czysta tablica CSL-JSON — dokładnie w formie, jakiej oczekuje --bibliography=references.json.",
    bibtexToCslJsonUseCase:
      "Dla naukowców piszących w Markdown, którzy przenoszą stary projekt z LaTeksa do Quarto: przenieś bibliografię bez ręcznej edycji JSON.",
    bibtexToWordTitle: "Konwerter BibTeX na Word",
    bibtexToWordMetaDescription:
      "Zamień plik .bib na dokument Word z listą literatury sformatowaną w stylu APA, z wcięciem wysuniętym. Za darmo — analiza odbywa się w Twojej przeglądarce.",
    bibtexToWordIntro:
      "Kiedy plik .bib musi stać się dokumentem — a nie kolejnym formatem danych — ten konwerter analizuje Twój kod BibTeX lokalnie, formatuje każdy wpis w stylu APA 7 i pobiera plik Word z listą literatury już posortowaną alfabetycznie i z wcięciem wysuniętym.",
    bibtexToWordUseCase:
      "Ruch na końcu procesu: czasopismo przyjęło pracę, ale chce ostatecznej listy literatury jako edytowalnego pliku Word, a Twoim źródłem prawdy jest BibTeX.",
    risToApaTitle: "Konwerter RIS na APA",
    risToApaMetaDescription:
      "Wklej lub prześlij eksport RIS i otrzymaj listę literatury w stylu APA 7. Działa z eksportami z Zotero, Mendeley, EndNote i baz danych — za darmo.",
    risToApaIntro:
      "Przycisk eksportu każdej bazy danych generuje RIS; zadania wymagają stylu APA. Wklej eksport (lub prześlij plik .ris), a każdy rekord TY/AU/TI zostanie przeanalizowany w Twojej przeglądarce i wyrenderowany jako opis w stylu APA 7 — bez potrzeby instalowania menedżera bibliografii.",
    risToApaUseCase:
      "Skrót dla baz bibliotecznych: wyeksportuj wyniki wyszukiwania jako RIS, przekonwertuj je tutaj i pomiń konfigurowanie Zotero dla jednorazowej pracy.",
    risToMlaTitle: "Konwerter RIS na MLA",
    risToMlaMetaDescription:
      "Zamień eksporty RIS z baz danych lub menedżerów bibliografii na wpisy do wykazu literatury w stylu MLA 9. Wklej lub prześlij — za darmo, bez rejestracji.",
    risToMlaIntro:
      "JSTOR, ProQuest i EBSCO eksportują dane w formacie RIS, a wydziały anglistyki wymagają stylu MLA. Ta strona zamyka tę lukę: rekordy są analizowane lokalnie i renderowane zgodnie z szablonem podstawowych elementów MLA 9, gotowe do wklejenia na stronę wykazu literatury.",
    risToMlaUseCase:
      "Stworzone na noc przed oddaniem eseju: dziesięć źródeł wyeksportowanych z JSTOR jako citations.ris i zero ochoty na ręczne formatowanie.",
    risToBibtexTitle: "Konwerter RIS na BibTeX",
    risToBibtexMetaDescription:
      "Zamień RIS na BibTeX dla LaTeksa i Overleafa. Wklej lub prześlij eksport .ris, pobierz czysty plik .bib — za darmo, bezpośrednio w przeglądarce.",
    risToBibtexIntro:
      "W kierunku LaTeksa: menedżery bibliografii i bazy danych mówią w formacie RIS, a budowanie Twojej pracy wymaga pliku .bib. Rekordy są w całości konwertowane w Twojej przeglądarce — typy mapowane ze znaczników TY, generowane klucze cytowania — do pliku, który Overleaf akceptuje bez zmian.",
    risToBibtexUseCase:
      "Częste we współpracy: użytkownik Zotero eksportuje RIS, użytkownik LaTeksa przepuszcza to przez tę stronę, a obie strony zachowują swoje narzędzia.",
    risToCslJsonTitle: "Konwerter RIS na CSL-JSON",
    risToCslJsonMetaDescription:
      "Zamień eksporty RIS na CSL-JSON dla procesów Pandoc i Quarto. Wklej lub prześlij plik .ris, pobierz references.json — za darmo.",
    risToCslJsonIntro:
      "Dla użytkowników Pandoc i Quarto CSL-JSON to natywny format bibliografii. Podaj tej stronie plik RIS wyeksportowany z Twojej bazy danych lub menedżera, a otrzymasz w zamian ustrukturyzowaną tablicę JSON — każdy rekord analizowany lokalnie, nic nigdzie nie jest przesyłane.",
    risToCslJsonUseCase:
      "Wpasowuje się w przepływy pracy typu docs-as-code: recenzenci przysyłają załączniki RIS, plik cytowań w Twoim repozytorium to references.json, a ta strona jest łącznikiem między nimi.",
    cslJsonToBibtexTitle: "Konwerter CSL-JSON na BibTeX",
    cslJsonToBibtexMetaDescription:
      "Zamień CSL-JSON (eksporty z Pandoc/Quarto/Zotero) na BibTeX. Wklej lub prześlij plik .json, pobierz plik .bib — za darmo, bezpośrednio w przeglądarce.",
    cslJsonToBibtexIntro:
      "Czasem przepływ odwraca się: bibliografia powstała w procesie Pandoc lub Zotero musi zasilić budowanie dokumentu w LaTeksie. Ten konwerter odczytuje tablicę CSL-JSON w Twojej przeglądarce i tworzy wpisy BibTeX, których typy i pola są odwzorowywane z powrotem na podstawie modelu CSL.",
    cslJsonToBibtexUseCase:
      "Dla autora piszącego w Quarto, którego współautor upiera się przy Overleafie: zachowaj references.json jako źródło kanoniczne i generuj plik .bib na żądanie.",
    cslJsonToRisTitle: "Konwerter CSL-JSON na RIS",
    cslJsonToRisMetaDescription:
      "Zamień CSL-JSON na RIS, aby Zotero, Mendeley lub EndNote mogły to zaimportować. Wklej lub prześlij plik .json, pobierz plik .ris — za darmo.",
    cslJsonToRisIntro:
      "CSL-JSON świetnie sprawdza się w procesach Pandoc, ale jest nieczytelny dla okien importu większości menedżerów bibliografii. Konwersja do RIS sprawia, że te same rekordy stają się uniwersalnie importowalne — każda pozycja jest mapowana na znaczniki TY/AU/TI w Twojej przeglądarce, nic nie jest wysyłane na żaden serwer.",
    cslJsonToRisUseCase:
      "Problem przekazania pracy dalej: Twoja bibliografia to plik references.json w repozytorium git, a promotor chce ją mieć „w EndNote” do piątku.",
  },

  // The infinite-scroll style list shared by the country and subject pages and by the
  // /citation-styles hub. It is a client component, so these arrive as a prop rather
  // than through `getDictionary` — pulling all 17 dictionaries into the browser bundle
  // to label a search box is the thing `link-path.ts` exists to avoid.
  stylesBrowser: {
    defaultTitle: "Wszystkie style cytowania",
    styleSingular: "styl",
    stylePlural: "stylów",
    found: "znaleziono",
    filterPlaceholder: "Filtruj style...",
    noMatches: "Żaden styl nie pasuje do wyszukiwania.",
    loadingMore: "Wczytywanie kolejnych stylów...",
    loadMore: "Wczytaj więcej (pozostało {count})",
    showingAll: "Wyświetlono wszystkie {count} stylów",
    internationalLabel: "Międzynarodowy",
  },

  footer: {
    tagline:
      "Darmowy generator przypisów z {count} stylami. Bez konta, bez płatnej subskrypcji i bez limitów.",
    freeTools: "Darmowe narzędzia",
    resources: "Materiały",
    legal: "Informacje prawne",
    language: "Język",
    languageLabel: "Wybierz język",
    rights:
      "Opisy bibliograficzne są formatowane zgodnie z oficjalnymi definicjami Citation Style Language.",
    popularStyles: "Popularne style",
    about: "O serwisie",
    privacy: "Prywatność",
    terms: "Regulamin",
    contact: "Kontakt",
    copyright: "© {year} CitationEasy. Korzystanie jest bezpłatne.",
    poweredBy: "Działa dzięki",
    allTools: "Wszystkie narzędzia pisarskie",
    citationGuides: "Poradniki cytowania",
    allStyles: "Wszystkie style cytowania",
    citationGlossary: "Słownik cytowania",
    howToCiteAny: "Jak zacytować dowolne źródło",
  },

  faq: {
    heading: "Najczęstsze pytania",
    homeQ1: "Czy CitationEasy jest naprawdę darmowy?",
    homeA1:
      "Tak. CitationEasy jest w pełni bezpłatny: bez rejestracji, bez limitów i bez wersji płatnej. Wszystkie {count} stylów cytowania są dostępne dla każdego.",
    homeQ2: "Jakie style cytowania są obsługiwane?",
    homeA2:
      "Wszystkie {count} stylów z projektu Citation Style Language, w tym APA wyd. 7, MLA wyd. 9, Chicago, Harvard, Vancouver, IEEE, AMA i Turabian.",
    homeQ3: "Czy potrzebuję konta?",
    homeA3:
      "Nie. CitationEasy działa w całości w przeglądarce, a bibliografia zapisuje się na Twoim urządzeniu. Nic nie jest wysyłane na serwer i nie ma się gdzie rejestrować.",
    homeQ4: "Czy mogę tworzyć przypisy w swoim języku?",
    homeA4:
      "Tak. Język przypisów to ustawienie niezależne od języka serwisu, więc możesz pracować po polsku, a przypisy generować w języku, w którym piszesz pracę.",
    styleQ1: "Czy generator przypisów {style} jest darmowy?",
    styleA1:
      "Tak. Tworzenie przypisów w stylu {style} jest bezpłatne i bez limitu, bez zakładania konta. Wklej DOI, adres URL, ISBN lub wpis BibTeX i skopiuj gotowy opis.",
    styleQ2: "Jak zacytować źródło w stylu {style}?",
    styleA2:
      "Wklej DOI, adres URL, ISBN lub wpis BibTeX źródła do generatora na tej stronie. Styl {style} jest już wybrany, więc opis bibliograficzny i przypis w tekście pojawiają się od razu.",
    styleQ3: "Na ile dokładne jest formatowanie {style}?",
    styleA3:
      "Każdy opis powstaje na podstawie oficjalnej definicji stylu {style} z projektu Citation Style Language — tego samego pliku, którego używają Zotero i Mendeley — a nie z przybliżenia zasad.",
  },

  tool: {
    modeLabel: "Tryb wprowadzania cytowania",
    modeAuto: "URL / DOI / ISBN",
    modeBook: "Szukaj książek",
    modeArticles: "Szukaj artykułów",
    modeManual: "Wprowadzanie ręczne",
    errorEnterManually: "Wprowadź dane ręcznie",
    autoLabel:
      "Wklej adres URL, DOI, PMID, identyfikator arXiv, ISBN lub BibTeX",
    autoHint:
      "Automatycznie rozpoznajemy typ i pobieramy metadane. Wklej po jednym identyfikatorze w wierszu, aby zacytować całą listę naraz.",
    generate: "Generuj cytowanie",
    generating: "Generowanie…",
    bookSearchLabel: "Szukaj po tytule, autorze lub numerze ISBN",
    bookSearchEmpty: "Brak wyników. Kliknij Szukaj, aby znaleźć książki.",
    bookSearchSource: "Przeszukuje katalog Open Library z milionami książek",
    worksSearchLabel: "Szukaj po tytule artykułu lub autorach",
    worksSearchEmpty: "Brak wyników. Kliknij Szukaj, aby znaleźć artykuły.",
    worksSearchSource:
      "Przeszukuje katalog Crossref: artykuły z czasopism, referaty konferencyjne i rozdziały książek",
    showingResults: "Wyświetlono {shown} z {total} wyników",
    search: "Szukaj",
    searching: "Szukanie…",
    bulkResults: "Wyniki cytowania zbiorczego",
    copy: "Kopiuj",
    copied: "Skopiowano!",
    copyHint: "Skopiuj i wklej do swojej pracy",
    resultTitle: "Sformatowane cytowanie",
    edit: "Edytuj",
    completeFields: "Uzupełnij",
    fieldsIncomplete:
      "one:{count} pole niekompletne|few:{count} pola niekompletne|many:{count} pól niekompletnych|other:{count} pola niekompletnego",
    outputLanguage: "Język",
    sourceType: "Typ źródła",
    fieldAuthors: "Autor(zy)",
    fieldAuthorsHint: "Kowalski, Jan lub Jan Kowalski",
    fieldTitle: "Tytuł artykułu lub książki",
    fieldBookTitle: "Tytuł książki",
    fieldBookTitleHint: "Tytuł książki lub antologii",
    fieldEditors: "Redaktor(zy)",
    fieldJournal: "Czasopismo / publikacja",
    fieldJournalHint: "Nazwa czasopisma lub publikacji",
    fieldPublisher: "Wydawca / witryna",
    fieldPublisherHint: "Nazwa wydawcy lub witryny",
    fieldDate: "Data / rok",
    fieldVolume: "Tom",
    fieldIssue: "Numer",
    fieldPages: "Strona(y)",
    fieldFormat: "Format / nośnik",
    fieldAuthorsGroup: "Autor zbiorowy lub organizacja",
    fieldAuthorsGroupHint:
      "Aby podać grupę razem z osobami, ujmij ją w nawiasy klamrowe: {R Core Team}, Jan Kowalski",
    fieldTranslators: "Tłumacz(e)",
    fieldInterviewers: "Prowadzący wywiad",
    fieldVersion: "Wersja",
    fieldCourt: "Sąd",
    fieldIssuingAuthority: "Organ wydający",
    fieldPatentNumber: "Numer patentu",
    fieldEpisodeNumber: "Numer odcinka",
    fieldLawNumber: "Numer ustawy lub projektu ustawy",
    fieldReportNumber: "Numer raportu",
    fieldReviewedTitle: "Tytuł recenzowanego dzieła",
    fieldReviewedAuthors: "Autor(zy) recenzowanego dzieła",
    inTextCitation: "Cytowanie w tekście",
    quickEdit: "Szybka edycja",
    quickEditHint: "Zaktualizuj metadane i wygeneruj cytowanie ponownie.",
    update: "Aktualizuj",
    saving: "Zapisywanie…",
    fieldAuthor: "Autor",
    fieldDateShort: "Data",
    fieldTitleShort: "Tytuł",
  },

  toolCollections: {
    "citation-generators": "Generatory cytowań",
    "citation-tools": "Narzędzia do cytowań i bibliografii",
    "paper-formatting": "Formatowanie prac",
    "essay-writing": "Pisanie esejów i prac",
    "writing-analysis": "Analiza i redakcja tekstu",
    "word-counters": "Liczniki i czytelność",
    vocabulary: "Słownictwo i wyszukiwanie słów",
    "research-tools": "Badania i publikacje",
    statistics: "Kalkulatory statystyczne",
    math: "Kalkulatory matematyczne",
    science: "Kalkulatory naukowe i laboratoryjne",
    charts: "Wykresy i diagramy",
    economics: "Ekonomia, biznes i finanse",
    grades: "Kalkulatory GPA i ocen",
    study: "Nauka i produktywność",
    classroom: "Klasa i materiały do druku",
    random: "Generatory losowe i losowanie",
    "text-tools": "Czyszczenie i formatowanie tekstu",
    "fancy-text": "Ozdobny tekst i symbole",
    language: "Język i transliteracja",
    ciphers: "Kody i szyfry",
    converters: "Konwertery jednostek, dat i liczb",
    developer: "Dane, znaczniki i kod",
  },
  bib: {
    title: "Moje bibliografie",
    studioTitle: "Studio bibliografii",
    studioProjects: "Projekty",
    studioExplore: "Odkrywaj",
    studioExploreIntro:
      "Poradniki, narzędzia i wszystkie style cytowania w jednym kliknięciu.",
    studioStyleGuide: "Przewodnik po stylu {style}",
    studioStyleGuideHint: "Zasady, przykłady i format cytowania w tekście",
    studioGenerator: "Generator cytowań",
    studioNewProject: "Nowy projekt",
    studioSwitchProject: "Zmień projekt",
    studioAddSource: "Dodaj źródło",
    studioAddSourceHint:
      "Wklej DOI, URL lub ISBN, wyszukaj książki i artykuły albo wpisz dane ręcznie. Wszystko, co zapiszesz, trafia do tego projektu.",
    studioDoneAdding: "Gotowe",
    studioReferences: "Bibliografia",
    studioReferenceCount: "Pozycje: {count}",
    studioInspectorTitle: "Szczegóły pozycji",
    studioInspectorEmpty:
      "Wybierz pozycję, aby zobaczyć cytowanie w tekście, notatki i szczegóły źródła.",
    studioSavedLocally: "Zapisane w tej przeglądarce",
    studioOpen: "Otwórz Studio bibliografii",
    studioViewInStudio: "Zobacz w Studiu",
    studioFooterSaved: "Zapisane w Studiu bibliografii: {count}",
    studioFooterEmpty: "Zapisane cytowania tworzą w Studiu pełną bibliografię",
    studioClearSelection: "Wyczyść zaznaczenie",
    studioDeleteSelected: "Usuń zaznaczone",
    studioDeleteSelectedBody:
      "Usunąć {count} cytowań z „{name}”? Tej operacji nie można cofnąć.",
    studioDeletedMany: "Usunięto cytowań: {count}",
    studioMoveTo: "Przenieś do",
    studioCopyTo: "Kopiuj do",
    studioSearchShortcut: "Naciśnij /, aby wyszukać",
    studioStyle: "Styl",
    studioCopyEntry: "Kopiuj pozycję",
    studioEntryCopied: "Pozycja skopiowana",
    studioSourceDetails: "Szczegóły źródła",
    studioEmptyTitle: "Ten projekt jest pusty",
    studioEmptyBody:
      "Dodaj pierwsze źródło powyżej lub zaimportuj istniejącą bibliotekę BibTeX, RIS lub CSL-JSON.",
    studioBackup: "Kopia zapasowa",
    sharedTitle: "Udostępniona bibliografia",
    save: "Zapisz",
    saving: "Zapisywanie…",
    saved: "Zapisano",
    searchPlaceholder: "Szukaj w cytowaniach…",
    empty: "Nie zapisano jeszcze żadnych cytowań",
    emptySearch: "Żadne cytowanie nie pasuje do wyszukiwania.",
    countIn: "Cytowania w {name}: {count}",
    savedOn: "Zapisano {date}",
    emptyInBib:
      "W tej bibliografii nie ma jeszcze cytowań. Wygeneruj i zapisz cytowania albo zaimportuj bibliotekę BibTeX, RIS lub CSL-JSON.",
    savedToast: "Zapisano cytowanie w bibliografii",
    copyAll: "Kopiuj wszystko",
    copyAllTitle: "Kopiuj wszystkie cytowania",
    export: "Eksportuj",
    exportTitle: "Eksportuj bibliografię",
    import: "Importuj",
    importTitle: "Importuj pozycje",
    importLabel: "Importuj pozycje (BibTeX, RIS lub CSL-JSON)",
    importing: "Importowanie…",
    importFailed: "Import nie powiódł się. Spróbuj ponownie.",
    importSummary:
      "Zaimportowano: {added} · Pominięte duplikaty: {duplicates} · Ponad limit: {overLimit} · Błędy: {failed}",
    importUnreadable: "Nie udało się odczytać pliku.",
    importUnparseable: "Nie udało się zaimportować pozycji.",
    importReviewTitle: "Przejrzyj import",
    importReviewIntro:
      "Przejrzyj {total} pozycji {format} przed ich sformatowaniem i zapisaniem.",
    importReviewCount: "Uwzględniono {included} z {total}",
    importSelectAll: "Uwzględnij wszystkie",
    importExcludeAll: "Wyklucz wszystkie",
    importLimitNotice:
      "{count} pozycji ponad limit 200 rekordów nie zostanie zaimportowanych.",
    importDuplicateExisting: "Możliwy duplikat zapisanej pozycji „{title}”",
    importDuplicateBatch: "Możliwy duplikat pozycji „{title}” w tym imporcie",
    importMissingField: "Brak pola: {field}",
    importUntitled: "Pozycja bez tytułu",
    importReview: "Przejrzyj pozycje",
    importCommit: "Sformatuj i importuj",
    importBack: "Wstecz",
    importOutcomeTitle: "Import zakończony",
    importOutcomeSummary:
      "Dodano: {added} · Pominięte duplikaty: {duplicates} · Wykluczono: {excluded} · Ponad limit: {overLimit} · Błędy: {failed}",
    sortBy: "Sortuj według",
    sortTitle: "Sortuj bibliografię",
    sortAuthor: "Autor (A–Z)",
    sortNewest: "Data dodania (najnowsze)",
    sortOldest: "Rok (od najstarszych)",
    sortManual: "Kolejność ręczna",
    backupAll: "Pełna kopia projektów (.json)",
    backupDownloaded: "Pobrano pełną kopię projektów",
    backupUnreadable: "Nie udało się odczytać pliku kopii.",
    restore: "Przywróć",
    restoreTitle: "Przywróć wszystkie projekty bibliografii",
    restoreWarning:
      "Kopia zostanie najpierw sprawdzona, a następnie zastąpi wszystkie bibliografie zapisane w tej przeglądarce. Tej operacji nie można cofnąć.",
    restoreChoose: "Wybierz kopię CitationEasy (.json)",
    replaceAndRestore: "Zastąp i przywróć",
    restoreComplete: "Przywrócono wszystkie projekty bibliografii",
    restoreInvalid: "To nie jest prawidłowa kopia projektu CitationEasy.",
    selectAllVisible: "Zaznacz wszystkie widoczne",
    selectedCount: "Wybrano: {count}",
    clusterOpen: "Cytuj razem",
    clusterTitle: "Złożone cytowanie w tekście",
    clusterDescription:
      "Utwórz jeden klaster cytowań z wybranych źródeł. Wybrany styl określa kolejność, interpunkcję i numerację.",
    clusterTarget: "Wynik",
    clusterLocatorOptional: "Opcjonalny lokalizator",
    clusterBuildCopy: "Utwórz i skopiuj cytowanie",
    clusterBuilding: "Tworzenie cytowania…",
    clusterCopied: "Skopiowano złożone cytowanie",
    clusterFailed:
      "Nie udało się utworzyć złożonego cytowania. Spróbuj ponownie.",
    destination: "Bibliografia docelowa",
    chooseDestination: "Wybierz bibliografię…",
    copySelected: "Kopiuj",
    moveSelected: "Przenieś",
    copyComplete: "Skopiowano {count} cytowań. Pominięto {skipped} duplikatów.",
    moveComplete:
      "Przeniesiono {count} cytowań. {skipped} duplikatów pozostało w źródle.",
    selectCitation: "Wybierz {title}",
    moveUp: "Przenieś wyżej",
    moveDown: "Przenieś niżej",
    deleteTitle: "Usuń cytowanie",
    deleteConfirm: "Usunąć cytowanie?",
    deleted: "Cytowanie usunięte",
    editTitle: "Edytuj cytowanie",
    close: "Zamknij",
    copiedAll: "Skopiowano wszystkie cytowania!",
    copiedAnnotated: "Skopiowano bibliografię adnotowaną!",
    copiedBibtex: "Skopiowano BibTeX!",
    copiedBulleted: "Skopiowano listę punktowaną!",
    copiedNumbered: "Skopiowano listę numerowaną!",
    copiedHtml: "Skopiowano fragment HTML!",
    downloadedWord: "Pobrano dokument Word",
    downloadedRtf: "Pobrano plik RTF",
    downloadedRis: "Pobrano plik RIS",
    downloadedCsl: "Pobrano plik CSL-JSON",
    downloadedAnnotated: "Pobrano bibliografię adnotowaną",
    copyFailed: "Nie udało się skopiować do schowka",
    shareCopied:
      "Skopiowano link! Każdy, kto go ma, może zobaczyć i zaimportować tę listę.",
    shareFailed: "Nie udało się utworzyć linku do udostępnienia",
    regenerateFailed: "Nie udało się wygenerować cytowania ponownie",
    updateFailed: "Nie udało się zaktualizować cytowania",
    fieldAuthor: "Autor",
    fieldTitle: "Tytuł",
    fieldDate: "Data",
    fieldPublisher: "Wydawca",
    fieldVolume: "Tom",
    fieldIssue: "Numer",
    fieldPages: "Strona(y)",
    fieldUrl: "URL",
    fieldAccessed: "Data dostępu",
    fieldEditor: "Redaktor",
    fieldEvent: "Miejsce wydarzenia",
    noteLabel: "Adnotacja do tego źródła",
    noteEdit: "Edytuj tę notatkę",
    notePlaceholder:
      "Streść źródło, oceń je i napisz, jak pasuje do Twojej pracy…",
    noteRemoved: "Notatka usunięta",
    noteSave: "Zapisz notatkę",
    noteCancel: "Anuluj",
    noteAdd: "Dodaj notatkę",
    noteWords: "słowa: {count}",
    noteSaved: "Notatka zapisana (słowa: {count})",
    noteClickToEdit: "kliknij, aby edytować",
    inTextCopy: "Skopiuj cytowanie w tekście dla tego źródła",
    inTextSelect: "Zaznacz cytowanie poniżej, aby je skopiować.",
    inTextFailed:
      "Nie udało się zbudować cytowania w tekście. Spróbuj ponownie.",
    locator: "Lokalizator",
    locatorType: "Typ lokalizatora",
    locatorPage: "Strona",
    locatorChapter: "Rozdział",
    locatorSection: "Sekcja",
    locatorParagraph: "Akapit",
    locatorLine: "Wers",
    locatorVerse: "Werset",
    reformat: "Przeformatuj",
    reformatTitle: "Przeformatuj wszystkie cytowania w innym stylu",
    reformatHeading: "Przeformatuj wszystko w jednym stylu",
    reformatChoose: "Wybierz styl…",
    reformatFailed:
      "Przeformatowanie nie powiodło się. Bibliografia pozostała bez zmian.",
    sortOrder: "Kryterium sortowania",
    copyToClipboard: "Kopiuj do schowka",
    numberedList: "Lista numerowana",
    bulletedList: "Lista punktowana",
    htmlSnippet: "Fragment HTML",
    copyWithAnnotations: "Kopiuj z adnotacjami",
    wordAnnotated: "Dokument Word z adnotacjami (.doc)",
    downloadFile: "Pobierz plik",
    wordDocument: "Dokument Word (.doc)",
    copyShareLink: "Kopiuj link do udostępnienia",
    print: "Drukuj…",
    printFailed: "Wyskakujące okno zablokowane — zezwól na nie, aby drukować",
    font: "Czcionka",
    sitePublication: "Witryna / nazwa publikacji",
    importIntro:
      "Wklej lub prześlij plik BibTeX (.bib), RIS (.ris) albo CSL-JSON (.json)",
    importUpload: "Prześlij plik .bib, .ris lub .json",
    importPaste: "Albo wklej BibTeX, RIS lub CSL-JSON",
    cancel: "Anuluj",
    done: "Gotowe",
    delete: "Usuń",
    deleteBody: "Cytowanie zostanie trwale usunięte z Twojej bibliografii.",
    editBody:
      "Zaktualizuj metadane i zapisz, aby wygenerować cytowanie ponownie.",
    reformatExplain:
      "Odtwarza wszystkie pozycje ({count}) z zapisanych danych źródłowych — nic nie jest pobierane ponownie i żadne źródło nie ginie.",
    inTextHeading: "Cytowanie w tekście",
    inTextLocatorHint:
      "Dodaj stronę lub inny lokalizator, aby wskazać konkretne miejsce w źródle — większość stylów wymaga tego przy cytatach dosłownych. Zostaw puste, aby uzyskać formę prostą.",
    inTextCopyButton: "Kopiuj cytowanie w tekście",
    mixedStyles: "Ta bibliografia miesza style cytowania: {count} ({styles}).",
    mixedStylesAction:
      "Użyj {action}, aby ujednolicić wszystko w jednym stylu przed oddaniem pracy.",
    selectBibliography: "Wybierz bibliografię",
    newBibliography: "Nowa bibliografia",
    moreOptions: "Więcej opcji",
    rename: "Zmień nazwę",
    removeDuplicates: "Usuń duplikaty",
    cannotDeleteOnly: "Nie można usunąć jedynej bibliografii",
    newBibliographyBody: "Utwórz bibliografię dla innej pracy lub projektu.",
    bibliographyName: "Nazwa bibliografii",
    create: "Utwórz",
    renameBibliography: "Zmień nazwę bibliografii",
    renameBibliographyBody: "Wpisz nową nazwę dla „{name}”.",
    newName: "Nowa nazwa",
    duplicateRemovedOne: "Usunięto {count} duplikat",
    duplicateRemovedMany: "Usunięto {count} duplikaty",
    noDuplicates: "Nie znaleziono zduplikowanych źródeł",
    removeDuplicatesConfirm: "Usunąć zduplikowane źródła?",
    removeDuplicatesBody:
      "Opcja wyszukuje w „{name}” te same źródła (według DOI, ISBN albo tytułu, roku i autora) i zachowuje jedną kopię. Źródła, których nie da się porównać, pozostaną bez zmian.",
    deleteBibliographyConfirm: "Usunąć bibliografię?",
    deleteBibliographyBody:
      "Spowoduje to trwałe usunięcie „{name}” i wszystkich {count} cytowań.",
  },

  bibliographyPage: {
    metaTitle: "Studio bibliografii - porządkuj, opisuj i eksportuj cytowania",
    metaDescription:
      "Twórz prywatne projekty bibliograficzne w przeglądarce. Wyszukuj, sortuj, opisuj, edytuj, formatuj, importuj, eksportuj i udostępniaj bez konta.",
    keyword1: "generator bibliografii",
    keyword2: "menedżer cytowań",
    keyword3: "bibliografia adnotowana",
    ogTitle: "Studio bibliografii",
    ogDescription:
      "Prywatny obszar do porządkowania, formatowania, opisywania, importowania i eksportowania cytowań.",
    ogImageTitle: "Studio bibliografii",
    ogImageSubtitle:
      "Porządkuj, opisuj, formatuj, eksportuj i udostępniaj źródła.",
    ogKind: "Obszar cytowań",
    breadcrumb: "Studio bibliografii",
    eyebrow: "Prywatny obszar w przeglądarce",
    lead: "Zarządzaj wszystkimi źródłami pracy w jednym miejscu. Projekty pozostają w tej przeglądarce, dopóki świadomie ich nie wyeksportujesz lub udostępnisz.",
    privacyTitle: "Domyślnie prywatne",
    privacyBody:
      "Projekty i adnotacje korzystają z lokalnej pamięci przeglądarki. Łącza udostępniają cytowania, ale celowo pomijają prywatne notatki.",
    workflowTitle: "Od listy źródeł do gotowej pracy",
    workflowBody:
      "Przełączaj projekty, wyszukuj i sortuj źródła, dodawaj adnotacje lub lokalizatory, poprawiaj metadane i formatuj całą listę w jednym stylu.",
    formatsTitle: "Importuj źródła i zabierz je wszędzie",
    formatsBody:
      "Importuj BibTeX, RIS lub CSL-JSON. Kopiuj sformatowane listy albo eksportuj Word, RTF, RIS, CSL-JSON, HTML, BibTeX i wersje z adnotacjami.",
  },

  // The 95-term glossary: /glossary and /glossary/[slug].
  //
  // The chrome only. Each term's own prose — `short`, the `body` paragraphs, the
  // example — is ~10,600 words that cannot live in a flat string map and must not be
  // copied verbatim into sixteen files; it lives in `src/content/glossary/<locale>.json`
  // and is read through `lib/localized-content.ts`.
  glossaryPage: {
    metaTitle: "{term} - definicja i przykłady",
    notFoundTitle: "Nie znaleziono terminu",
    keywordDefinition: "definicja {term}",
    keywordWhatIs: "co to jest {term}",
    ogTitle: "{term} - słowniczek CitationEasy",
    ogKind: "Słowniczek cytowania",
    breadcrumb: "Słowniczek",
    alsoCalled: "Znany też jako: {aliases}",
    doItHeading: "Zrób to w CitationEasy",
    seeAlsoHeading: "Zobacz też",
    moreInHeading: "Więcej w kategorii {category}",
    navLabel: "Nawigacja słowniczka",
    allTermsLink: "Wszystkie {count} terminów słowniczka",
    generatorLink: "Darmowy generator przypisów",
    termSetName: "Słowniczek cytowania CitationEasy",
    hubMetaTitle: "Słowniczek cytowania - {count} wyjaśnionych terminów",
    hubMetaDescription:
      "Proste definicje {count} terminów z zakresu cytowania i pisania akademickiego: et al., ibid., DOI, wcięcie wysunięte, patchwriting, wersja ostateczna publikacji i więcej — każdy z przykładami.",
    hubKeyword1: "słowniczek cytowania",
    hubKeyword2: "terminy cytowania",
    hubKeyword3: "słowniczek pisania akademickiego",
    hubKeyword4: "co znaczy et al",
    hubKeyword5: "co to jest DOI",
    hubKeyword6: "terminologia cytowania",
    hubOgTitle: "Słowniczek cytowania",
    hubOgDescription:
      "Definicje {count} terminów z zakresu cytowania i pisania akademickiego, z przykładami.",
    hubOgImageTitle: "Słowniczek cytowania",
    hubOgImageSubtitle:
      "{count} terminów z zakresu cytowania i pisania akademickiego, wyjaśnionych prostym językiem, z przykładami.",
    hubOgKind: "Materiał referencyjny",
    hubTermSetDescription:
      "Definicje {count} terminów z zakresu cytowania, opisów bibliograficznych i pisania akademickiego.",
    hubCollectionName: "Słowniczek cytowania",
    hubCollectionDescription:
      "Proste definicje {count} terminów z zakresu cytowania i pisania akademickiego.",
    hubHeading: "Słowniczek cytowania",
    hubIntro:
      "{count} terminów z zakresu cytowania i pisania akademickiego, wyjaśnionych prostym językiem, z przykładami — skróty pojawiające się w przewodnikach stylów, elementy, z których zbudowany jest opis bibliograficzny, identyfikatory precyzujące źródło oraz słownictwo wydawnictwa naukowego.",
    hubJumpLabel: "Przejdź do litery",
    hubBrowseHeading: "Przeglądaj według tematu",
    hubAllHeading: "Wszystkie terminy A–Z",
    hubWorkHeading: "Zastosuj te terminy w praktyce",
    hubWorkGenerator: "Darmowy generator przypisów",
    hubWorkStyles: "Poradniki stylów cytowania",
    hubWorkHowTo: "Jak zacytować dowolne źródło",
    hubWorkCompare: "Porównaj style cytowania",
    hubWorkTools: "Narzędzia do pisania i cytowania",
    hubWorkFaq: "FAQ o cytowaniu",
  },

  // /faq — the 17-question hub. The questions and answers themselves are in
  // `src/data/faq.ts` (the one source the API, the MCP tool and /md also read); this is
  // the page around them.
  faqPage: {
    metaTitle: "FAQ o cytowaniu - szybkie odpowiedzi na częste pytania",
    metaDescription:
      "Szybkie, rzetelne odpowiedzi na pytania o cytowanie, które naprawdę zadają studenci: DOI, źródła bez autora, et al., wcięcia wiszące, cytowanie AI, zasady dotyczące plagiatu, APA a MLA i więcej — z linkami do pełnych poradników.",
    ogTitle: "FAQ o cytowaniu",
    ogDescription:
      "Szybkie odpowiedzi na najczęstsze pytania o cytowanie — od DOI i et al. po cytowanie ChatGPT.",
    ogImageTitle: "Pytania i odpowiedzi o cytowaniu",
    ogImageSubtitle:
      "Krótkie, rzetelne odpowiedzi na pytania, które naprawdę zadają studenci w sprawie cytowania.",
    ogKind: "FAQ",
    breadcrumbLabel: "Okruszki nawigacyjne",
    breadcrumbHome: "Strona główna",
    breadcrumbCurrent: "FAQ o cytowaniu",
    heading: "FAQ o cytowaniu",
    intro:
      "Szybkie, rzetelne odpowiedzi na pytania o cytowanie, które naprawdę zadają studenci — z linkami do pełnego poradnika lub narzędzia, gdy potrzebujesz więcej szczegółów.",
    contentsLabel: "Spis treści FAQ",
    stillStuckHeading: "Nadal masz wątpliwości?",
    stillStuckBody:
      "Przejrzyj [pełną bibliotekę poradników](/guides), sprawdź [ściągawki stylów](/cheat-sheets), wyszukaj termin w [słowniczku cytowania](/glossary), [przeszukaj całą witrynę](/search) albo po prostu [wygeneruj cytowanie](/) i pozwól generatorowi zastosować zasady za Ciebie.",
  },

  // /cheat-sheets and its three style sheets. The citation FORMATS in them
  // ("Author, A. A. (Year)…") are the styles' own templates and stay as they are in
  // every language, exactly as the per-style examples do; the labels around them do not.
  cheatSheets: {
    hubMetaTitle:
      "Ściągawki stylów cytowania - szybkie przewodniki referencyjne",
    hubMetaDescription:
      "Ściągawki referencyjne dla stylów cytowania APA, MLA i Chicago. Poradniki gotowe do druku z przykładami popularnych rodzajów źródeł.",
    hubBreadcrumbHome: "Strona główna",
    hubBreadcrumbCurrent: "Ściągawki stylów cytowania",
    hubBackLink: "← Powrót do generatora",
    hubHeading: "Ściągawki stylów cytowania",
    hubIntro:
      "Szybkie przewodniki referencyjne dla najpopularniejszych stylów cytowania. Gotowe do druku i zawsze aktualne.",
    hubApaTitle: "Ściągawka APA (7. wydanie)",
    hubApaDesc: "Psychologia, nauki społeczne, edukacja, pielęgniarstwo",
    hubMlaTitle: "Ściągawka MLA (9. wydanie)",
    hubMlaDesc:
      "Literaturoznawstwo, językoznawstwo, nauki humanistyczne, studia kulturowe",
    hubChicagoTitle: "Ściągawka stylu Chicago",
    hubChicagoDesc: "Historia, historia sztuki, filozofia, religioznawstwo",
    backToSheets: "← Powrót do ściągawek",
    generalRules: "Ogólne zasady",
    inTextCitations: "Cytowania w tekście",
    colSituation: "Sytuacja",
    colFormat: "Format",
    colExample: "Przykład",
    book: "Książka",
    journalArticle: "Artykuł naukowy",
    website: "Strona internetowa",
    apaMetaTitle: "Ściągawka APA (7. wydanie) - szybki przewodnik referencyjny",
    apaMetaDescription:
      "Ściągawka cytowań APA (7. wydanie) z przykładami dla książek, czasopism, stron internetowych i innych źródeł. Szybkie odniesienie gotowe do druku.",
    apaHeading: "Ściągawka APA (7. wydanie)",
    apaLead: "Szybkie odniesienie dla najczęstszych formatów cytowań APA.",
    apaRule1:
      "Stosuj **wcięcie wysunięte** (pierwszy wiersz od lewego marginesu, kolejne wiersze wcięte o 1,27 cm)",
    apaRule2: "Stosuj podwójną interlinię we wszystkich pozycjach",
    apaRule3: "Uszereguj alfabetycznie według nazwiska autora",
    apaRule4: "Zapisuj kursywą tytuły książek, czasopism i tomów",
    apaRule5: "Podawaj DOI, jeśli jest dostępny",
    apaRow1Situation: "1 autor",
    apaRow1Format: "(Author, Year)",
    apaRow1Example: "(Smith, 2024)",
    apaRow2Situation: "2 autorów",
    apaRow2Format: "(Author & Author, Year)",
    apaRow2Example: "(Smith & Jones, 2024)",
    apaRow3Situation: "3 i więcej autorów",
    apaRow3Format: "(First Author et al., Year)",
    apaRow3Example: "(Smith et al., 2024)",
    apaRow4Situation: "Cytat bezpośredni",
    apaRow4Format: "(Author, Year, p. #)",
    apaRow4Example: "(Smith, 2024, p. 45)",
    apaRow5Situation: "Brak autora",
    apaRow5Format: '("Title," Year)',
    apaRow5Example: '("Study Results," 2024)',
    apaReferenceHeading: "Przykłady wykazu literatury",
    apaBookExample:
      "Author, A. A. (Year). *Title of work: Capital letter also for subtitle*. Publisher. https://doi.org/xxxxx",
    apaJournalExample:
      "Author, A. A., & Author, B. B. (Year). Title of article. *Title of Periodical, Volume*(Issue), Page–Page. https://doi.org/xxxxx",
    apaWebsiteExample:
      "Author, A. A. (Year, Month Day). *Title of page*. Site Name. https://www.example.com/page",
    apaChapterLabel: "Rozdział w pracy zbiorowej",
    apaChapterExample:
      "Author, A. A. (Year). Title of chapter. In E. E. Editor (Ed.), *Title of book* (pp. #–#). Publisher.",
    apaConferenceLabel: "Referat konferencyjny",
    apaConferenceExample:
      "Author, A. A. (Year, Month Days). *Title of paper* [Paper presentation]. Conference Name, Location.",
    apaDifferencesHeading: "Najważniejsze różnice względem APA 6",
    apaDifference1: "Brak wyrażenia „Retrieved from” przed adresami URL",
    apaDifference2: "Podawaj DOI w formacie linku https://doi.org/",
    apaDifference3: "Wymień do 20 autorów, zanim użyjesz wielokropka",
    apaDifference4: "Miejsce wydania nie jest już wymagane",
    apaDifference5:
      "Używaj liczby pojedynczej zaimka „they” dla języka neutralnego płciowo",
    apaCtaText: "Generuj bezbłędne cytowania APA automatycznie",
    apaCtaButton: "Generator przypisów APA →",
    mlaMetaTitle: "Ściągawka MLA (9. wydanie) - szybki przewodnik referencyjny",
    mlaMetaDescription:
      "Ściągawka cytowań MLA (9. wydanie) z przykładami dla książek, artykułów, stron internetowych i innych źródeł. Szybkie odniesienie gotowe do druku.",
    mlaHeading: "Ściągawka MLA (9. wydanie)",
    mlaLead: "Szybkie odniesienie dla najczęstszych formatów cytowań MLA.",
    mlaRule1: "Stosuj **wcięcie wysunięte**",
    mlaRule2: "Stosuj podwójną interlinię we wszystkich pozycjach",
    mlaRule3: "Uszereguj alfabetycznie według nazwiska autora",
    mlaRule4: "Zatytułuj stronę „Prace cytowane”",
    mlaRule5:
      "Zapisuj kursywą tytuły kontenerów (książek, czasopism, stron internetowych)",
    mlaRow1Situation: "1 autor",
    mlaRow1Format: "(Author Page)",
    mlaRow1Example: "(Smith 45)",
    mlaRow2Situation: "2 autorów",
    mlaRow2Format: "(Author and Author Page)",
    mlaRow2Example: "(Smith and Jones 45)",
    mlaRow3Situation: "3 i więcej autorów",
    mlaRow3Format: "(First Author et al. Page)",
    mlaRow3Example: "(Smith et al. 45)",
    mlaRow4Situation: "Brak autora",
    mlaRow4Format: '("Title" Page)',
    mlaRow4Example: '("Study Results" 45)',
    mlaRow5Situation: "Brak numeru strony",
    mlaRow5Format: "(Author)",
    mlaRow5Example: "(Smith)",
    mlaWorksCitedHeading: "Przykłady prac cytowanych",
    mlaBookExample: "Last, First. *Title of Book*. Publisher, Year.",
    mlaJournalExample:
      'Last, First. "Title of Article." *Journal Title*, vol. #, no. #, Year, pp. #–#.',
    mlaWebsiteExample:
      'Last, First. "Title of Page." *Website Name*, Day Month Year, URL.',
    mlaAnthologyLabel: "Antologia / praca zbiorowa pod redakcją",
    mlaAnthologyExample:
      'Last, First. "Title of Essay." *Title of Collection*, edited by First Last, Publisher, Year, pp. #–#.',
    mlaCoreHeading: "Podstawowe elementy MLA (w kolejności)",
    mlaCore1: "Author.",
    mlaCore2: '"Title of Source."',
    mlaCore3: "*Title of Container*,",
    mlaCore4: "Contributors,",
    mlaCore5: "Version,",
    mlaCore6: "Number,",
    mlaCore7: "Publisher,",
    mlaCore8: "Publication date,",
    mlaCore9: "Location (pages, URL, DOI).",
    mlaCtaText: "Generuj bezbłędne cytowania MLA automatycznie",
    mlaCtaButton: "Generator przypisów MLA →",
    chicagoMetaTitle:
      "Ściągawka stylu Chicago - szybki przewodnik referencyjny",
    chicagoMetaDescription:
      "Ściągawka cytowań Chicago Manual of Style z przykładami w systemie przypisów i bibliografii oraz autor-data. Szybkie odniesienie gotowe do druku.",
    chicagoHeading: "Ściągawka stylu Chicago",
    chicagoLead:
      "Szybkie odniesienie dla formatów cytowań Chicago Manual of Style (18. wydanie).",
    chicagoSystemsHeading: "Dwa systemy Chicago",
    chicagoColNb: "Przypisy i bibliografia (NB)",
    chicagoColAd: "Autor-data (AD)",
    chicagoRow1Nb: "Przypisy dolne/końcowe + bibliografia",
    chicagoRow1Ad: "Cytowania nawiasowe + wykaz literatury",
    chicagoRow2Nb: "Historia, sztuka, nauki humanistyczne",
    chicagoRow2Ad: "Nauki ścisłe, nauki społeczne",
    chicagoRow3Nb: "Bardziej szczegółowe pierwsze przypisy",
    chicagoRow3Ad: "Podobny do formatu APA",
    chicagoExamplesHeading: "Przykłady w systemie przypisów i bibliografii",
    chicagoNoteLabel: "Przypis:",
    chicagoBibliographyLabel: "Bibliografia:",
    chicagoBookLabel: "Książka (przypis)",
    chicagoBookNote: "1. First Last, *Title of Book* (Publisher, Year), page.",
    chicagoBookBibliography: "Last, First. *Title of Book*. Publisher, Year.",
    chicagoJournalLabel: "Artykuł naukowy (przypis)",
    chicagoJournalNote:
      '1. First Last, "Title of Article," *Journal Title* Vol, no. Issue (Year): pages.',
    chicagoJournalBibliography:
      'Last, First. "Title of Article." *Journal Title* Vol, no. Issue (Year): pages.',
    chicagoWebsiteLabel: "Strona internetowa (przypis)",
    chicagoWebsiteNote:
      '1. First Last, "Title of Page," Site Name, Month Day, Year, URL.',
    chicagoWebsiteBibliography:
      'Last, First. "Title of Page." Site Name. Month Day, Year. URL.',
    chicagoShortHeading: "Skrócone przypisy",
    chicagoShortIntro:
      "Po pierwszym pełnym cytowaniu stosuj skrócone przypisy:",
    chicagoShortExample: "1. Last, *Short Title*, page.",
    chicagoRulesHeading: "Najważniejsze zasady formatowania",
    chicagoRule1:
      "Używaj cyfr w indeksie górnym do odwołań do przypisów w tekście",
    chicagoRule2: "Pozycje bibliografii mają wcięcie wysunięte",
    chicagoRule3:
      "W kolejnych cytowaniach tego samego źródła stosuj skrócony przypis zamiast „Ibid.”",
    chicagoRule4:
      "Tytuły: książki i czasopisma kursywą, artykuły i rozdziały w cudzysłowie",
    chicagoRule5:
      "Podawaj daty dostępu dla źródeł internetowych, które mogą się zmieniać",
    chicagoCtaText: "Generuj bezbłędne cytowania w stylu Chicago automatycznie",
    chicagoCtaButton: "Generator przypisów Chicago →",
  },

  // The catalog's page-type labels (`CATALOG_TYPE_LABELS`), which the search page shows
  // as facet chips and beside every result. Layer 2: a fact from `src/lib/**` rather
  // than page chrome, and English until it is mapped through here.
  catalogTypes: {
    core: "Strony podstawowe",
    styleLanding: "Strony główne popularnych stylów cytowania",
    style: "Strony informacyjne o stylach cytowania",
    styleExamples: "Strony z przykładami cytowań",
    styleFormat: "Poradniki formatowania prac",
    styleInText: "Poradniki cytowania w tekście",
    styleAnnotatedBibliography: "Poradniki bibliografii adnotowanej",
    styleReferencePage: "Poradniki wykazu literatury / prac cytowanych",
    tool: "Darmowe narzędzia do pisania i cytowania",
    guide: "Poradniki edukacyjne",
    guideCategory: "Kategorie poradników",
    toolCollection: "Kolekcje narzędzi",
    howToCite: "Jak zacytować <źródło> w stylu <styl>",
    comparison: "Porównania stylów cytowania",
    converter: "Konwertery identyfikatorów i formatów",
    field: "Style cytowania według dziedziny naukowej",
    region: "Style cytowania według kraju/regionu",
    category: "Style cytowania według kategorii tematycznej",
    cheatSheet: "Jednostronicowe ściągawki",
    glossary: "Słowniczek terminów cytowania i pisania akademickiego",
  },

  // /about
  aboutPage: {
    metaTitle: "O CitationEasy - darmowy generator przypisów",
    metaDescription:
      "CitationEasy to darmowy generator przypisów obsługujący {count} stylów. Stworzony przez Samuela Sergiego przy użyciu narzędzi open source, takich jak Citation Style Language, Citation.js i Next.js.",
    backLink: "← Powrót do generatora",
    heading: "O CitationEasy",
    intro:
      "CitationEasy to darmowy, ogólnodostępny generator przypisów stworzony z myślą o studentach, badaczach i autorach tekstów akademickich. Obsługuje **{count} stylów cytowania** i oferuje stale rosnący zbiór narzędzi do pisania, poradników edukacyjnych i materiałów referencyjnych — wszystko bez konieczności rejestracji czy subskrypcji.",
    offerHeading: "Co oferujemy",
    offer1:
      "[Generator przypisów](/) z {count} stylami, w tym APA 7, MLA 9, Chicago 18, Harvard, Vancouver, IEEE i tysiące innych",
    offer2:
      "[40 darmowych narzędzi do pisania i cytowania](/tools) — licznik słów, sprawdzanie czytelności tekstu, walidator DOI, alfabetyzator bibliografii i więcej",
    offer3:
      "[750 poradników „jak zacytować”](/how-to-cite) obejmujących wszystkie główne rodzaje źródeł w 6 stylach cytowania",
    offer4:
      "[Ponad 100 poradników edukacyjnych](/guides) o najlepszych praktykach cytowania, pisaniu akademickim i umiejętnościach badawczych",
    offer5:
      "[Narzędzie do porównywania stylów](/compare), [quiz o stylach cytowania](/quiz) oraz [ściągawki](/cheat-sheets) do szybkiego sprawdzenia",
    offer6:
      "7 formatów eksportu: zwykły tekst, BibTeX, Word, lista numerowana, lista punktowana, RIS i CSV",
    openSourceHeading: "Zbudowane na oprogramowaniu open source",
    openSourceIntro:
      "CitationEasy powstało dzięki wielu doskonałym projektom i interfejsom API typu open source. Wierzymy w oddawanie zasług tam, gdzie się należą:",
    openSource1:
      "[Citation Style Language (CSL)](https://citationstyles.org/) — otwarty standard, na którym opierają się nasze {count} stylów cytowania. CSL jest utrzymywany przez społeczność wolontariuszy i wykorzystywany przez menedżery bibliografii, takie jak Zotero, Mendeley i Papers. Definicje stylów pochodzą z [repozytorium CSL Styles](https://github.com/citation-style-language/styles) na GitHubie.",
    openSource2:
      "[Citation.js](https://citation.js.org/) — biblioteka JavaScript, która przetwarza cytowania i formatuje je zgodnie ze stylami CSL. Stworzona przez Larsa Willighagena.",
    openSource3:
      "[Open Library API](https://openlibrary.org/developers/api) — darmowe API do wyszukiwania książek udostępniane przez Internet Archive, wykorzystywane do wyszukiwania metadanych książek po tytule lub numerze ISBN.",
    openSource4:
      "[DOI Foundation](https://www.doi.org/) — system Digital Object Identifier wykorzystywany do rozpoznawania i weryfikacji numerów DOI.",
    createdHeading: "Twórca",
    createdBody:
      "CitationEasy zostało stworzone i jest utrzymywane przez **Samuela Sergiego**. Cel jest prosty: dostarczyć naprawdę darmowe, wysokiej jakości narzędzie do cytowania, które nie ukrywa funkcji za murem płatności ani nie wymaga konta.",
    contactPrompt: "Masz pytania, uwagi lub sugestie? Skontaktuj się z nami:",
    contactEmail: "E-mail: [sam@sammysergi.com](mailto:sam@sammysergi.com)",
    missionHeading: "Nasza misja",
    mission1:
      "Dokładne cytowania nie powinny kosztować pieniędzy. Wiele narzędzi do cytowania reklamuje się jako darmowe, ale ogranicza formaty eksportu, liczbę cytowań lub nakłania użytkowników do wykupienia planu premium. CitationEasy jest w pełni darmowe — bez rejestracji, bez limitów, bez wersji premium.",
    mission2:
      "Każda funkcja na tej stronie — od generatora przypisów po narzędzia do pisania i poradniki edukacyjne — jest dostępna dla każdego bezpłatnie. Wierzymy, że narzędzia wspierające rzetelność akademicką powinny być dostępne dla wszystkich studentów i badaczy, niezależnie od budżetu.",
  },

  // /contact
  contactPage: {
    metaTitle: "Kontakt",
    metaDescription:
      "Skontaktuj się z CitationEasy. Masz pytania, uwagi lub sugestie dotyczące naszego darmowego generatora przypisów i narzędzi do pisania? Chętnie je poznamy.",
    backLink: "← Powrót do generatora",
    heading: "Kontakt",
    intro:
      "Masz pytania, uwagi lub sugestie dotyczące CitationEasy? Chętnie je poznamy. Niezależnie od tego, czy chodzi o zgłoszenie błędu, propozycję nowej funkcji, czy pomoc z cytowaniem — śmiało się z nami skontaktuj.",
    touchHeading: "Skontaktuj się z nami",
    touchBody:
      "Najlepszym sposobem kontaktu jest e-mail. Staramy się odpowiadać w ciągu 48 godzin.",
    emailLine: "**E-mail:** [sam@sammysergi.com](mailto:sam@sammysergi.com)",
    commonHeading: "Najczęstsze pytania",
    commonIntro:
      "Zanim się z nami skontaktujesz, sprawdź, czy odpowiedź na Twoje pytanie nie znajduje się już w jednym z tych materiałów:",
    resource1:
      "[Poradniki cytowania](/guides) — instrukcje krok po kroku dotyczące cytowania źródeł we wszystkich najważniejszych stylach",
    resource2:
      "[Poradniki „jak zacytować”](/how-to-cite) — 750 kombinacji rodzajów źródeł i stylów wraz z przykładami",
    resource3:
      "[Ściągawki](/cheat-sheets) — szybkie odniesienie do formatowania w stylach APA, MLA i Chicago",
    resource4:
      "[Narzędzia do pisania](/tools) — licznik słów, sprawdzanie czytelności tekstu, walidator DOI i więcej",
    issueHeading: "Zgłoś problem",
    issueIntro:
      "W przypadku błędu w formatowaniu cytowania, niedziałającej funkcji lub niepoprawnego stylu prosimy o podanie jak najwięcej szczegółów podczas kontaktu:",
    issue1: "Używany styl cytowania",
    issue2: "Rodzaj źródła (książka, strona internetowa, artykuł naukowy itd.)",
    issue3: "Czego oczekiwano, a co zostało wygenerowane",
    issue4: "Twoja przeglądarka i urządzenie (jeśli ma to znaczenie)",
    issueOutro: "Dzięki temu szybciej zidentyfikujemy i naprawimy problem.",
    aboutHeading: "O CitationEasy",
    aboutBody:
      "CitationEasy to darmowy generator przypisów obsługujący ponad 10 000 stylów cytowania. Został stworzony przez Samuela Sergiego z myślą o tym, by dokładne cytowania były dostępne dla każdego. Dowiedz się więcej na naszej [stronie O nas](/about).",
  },

  // /ai — the agent and developer docs.
  //
  // The code samples, endpoint paths and MCP tool NAMES are deliberately absent: they are
  // the API's identifiers, served in English by the API itself, and a translated one
  // would document an endpoint that does not exist.
  aiPage: {
    metaTitle:
      "CitationEasy dla asystentów i agentów AI - API, serwer MCP, llms.txt",
    metaDescription:
      "Korzystaj z CitationEasy programistycznie: darmowe, niewymagające uwierzytelnienia API JSON do cytowań w {count} stylach, serwer MCP dla agentów, llms.txt, specyfikację OpenAPI oraz widoki markdown każdej strony.",
    keyword1: "API cytowań",
    keyword2: "serwer MCP",
    keyword3: "API generatora przypisów",
    keyword4: "llms.txt",
    keyword5: "OpenAPI",
    keyword6: "cytowania dla agentów AI",
    keyword7: "darmowe API cytowań",
    webApiDescription:
      "Darmowe, niewymagające uwierzytelnienia API JSON, które formatuje cytowania w {count} stylach Citation Style Language na podstawie adresu URL, DOI, ISBN, identyfikatora PubMed, identyfikatora arXiv lub metadanych CSL-JSON.",
    breadcrumb: "Dla AI i agentów",
    heading: "CitationEasy dla asystentów i agentów AI",
    intro:
      "Wszystko na tej stronie jest dostępne zarówno dla oprogramowania, jak i dla ludzi: darmowe API JSON, serwer MCP, specyfikacja OpenAPI, indeks llms.txt oraz widok markdown wszystkich {count} stron. Bez klucza, bez konta, bez naszego własnego limitu zapytań.",
    whyHeading: "Dlaczego wywołać API zamiast samodzielnie pisać cytowanie",
    whyBody:
      "Formatowanie cytowań wygląda jak problem generowania tekstu, ale nim nie jest. Każdy styl koduje setki zasad dotyczących odwrócenia kolejności autorów, inicjałów, wielkości liter w tytułach, interpunkcji kontenera, oznaczeń wydania i umiejscowienia daty — a style różnią się w sposób, który łatwo subtelnie pomylić, pisząc z pamięci. CitationEasy uruchamia **citeproc-js** na oficjalnych definicjach Citation Style Language — tym samym silniku, którego używają Zotero i Mendeley — dzięki czemu wynik jest deterministyczny i zgodny z tym, czego oczekuje system zgłoszeń danego czasopisma. Metadane pochodzą z Crossref, Open Library i PubMed; nic nie jest wymyślane, a pole brakujące u źródła pozostaje puste zamiast być uzupełnione prawdopodobnym zgadywaniem.",
    generateHeading: "Wygeneruj cytowanie",
    generateBody:
      "Wyślij `inputs` zamiast `input`, aby obsłużyć do 10 źródeł w jednym wywołaniu, albo `entry` z posiadanymi już metadanymi CSL-JSON, aby całkowicie pominąć wyszukiwanie. Dodaj `note: true`, aby otrzymać formę przypisu. Błędy dotyczące pojedynczego źródła są zwracane przy tym źródle, więc cała partia nigdy nie zawodzi jako całość.",
    mcpHeading: "Połącz się przez MCP",
    mcpIntro:
      "Punkt końcowy Model Context Protocol pod adresem `/api/mcp` komunikuje się protokołem JSON-RPC 2.0 przez streamable HTTP i nie wymaga danych uwierzytelniających.",
    mcpToolsHeading: "Udostępniane narzędzia",
    endpointsHeading: "Punkty końcowe",
    colEndpoint: "Punkt końcowy",
    colWhat: "Co robi",
    endpointCite:
      "Formatuje do 10 źródeł naraz. Przyjmuje adres URL, DOI, ISBN, identyfikator PubMed, identyfikator arXiv, tekst BibTeX/RIS/CSL-JSON lub obiekt wpisu CSL-JSON. Zwraca pozycję bibliograficzną oraz opcjonalnie cytowanie w tekście i przypis.",
    endpointStyles:
      "Przeszukuje wszystkie {count} stylów według nazwy, klasy formatu cytowania, dziedziny lub regionu.",
    endpointStyleSlug:
      "Jeden styl w pełnej formie, z rzeczywistymi sformatowanymi przykładami wygenerowanymi na podstawie jego własnej definicji CSL.",
    endpointSearch:
      "Wyszukiwanie z rankingiem trafności obejmujące wszystkie strony witryny.",
    endpointPages:
      "Kompletny katalog witryny w postaci ustrukturyzowanych wpisów, filtrowalny według typu strony.",
    endpointHowToCite:
      "Każda strona z instrukcjami dla kombinacji rodzaj źródła × styl, filtrowalna według obu kryteriów.",
    endpointTools:
      "Każde darmowe narzędzie wraz z kategorią i słowami kluczowymi.",
    endpointGuides: "Każdy poradnik edukacyjny wraz z kategorią.",
    endpointConverters:
      "Każda konwersja identyfikatorów i formatów oferowana przez witrynę.",
    endpointComparisons:
      "Porównania stylów obok siebie, powiązane z rekordami obu stylów.",
    endpointFields:
      "Dziedziny naukowe, kategorie tematyczne i regiony — do odpowiedzi na pytanie „jakiego stylu użyć?”.",
    endpointFaq:
      "Zweryfikowane odpowiedzi na częste pytania o cytowanie, filtrowalne za pomocą q.",
    endpointGlossary:
      "Terminy z zakresu cytowania i pisania akademickiego wraz z pełnymi definicjami — odpowiedź zawiera cały tekst, więc nie trzeba pobierać żadnej dodatkowej strony.",
    endpointIndex:
      "Dokument umożliwiający odkrywanie punktów końcowych. Zacznij tutaj, jeśli dopiero się rozeznajesz.",
    discoveryHeading: "Pliki odkrywania",
    discoveryLlms:
      "Wyselekcjonowany indeks witryny napisany z myślą o modelach językowych.",
    discoveryLlmsFull:
      "Każda strona publikowana przez witrynę, pogrupowana według typu, po jednej linijce.",
    discoveryOpenapi: "Opis OpenAPI 3.1 całego publicznego API.",
    discoveryMcp:
      "Punkt końcowy MCP (streamable HTTP). Wykonaj GET w przeglądarce, aby zobaczyć opis.",
    discoveryWellKnownMcp:
      "Dokument odkrywania MCP dla agentów sprawdzających domenę.",
    discoveryAiPlugin:
      "Starszy manifest wtyczki, dla frameworków, które go jeszcze wyszukują.",
    discoveryMd: "Widok markdown dowolnej strony w witrynie.",
    discoverySitemap: "Każdy indeksowalny adres URL.",
    catalogHeading: "Co znajduje się w katalogu",
    catalogIntro:
      "Każda z poniższych stron jest dostępna jako HTML, jako markdown pod `/md/` oraz jako ustrukturyzowany wpis z `/api/v1/pages`.",
    catalogStyles:
      "**{count}** stylów cytowania, każdy z rzeczywistymi przykładami wygenerowanymi na podstawie jego własnej definicji CSL",
    catalogTools: "**{count}** darmowych narzędzi przeglądarkowych",
    catalogGuides: "**{count}** poradników edukacyjnych",
    catalogHowToCite: "**{count}** stron „jak zacytować”",
    catalogComparisons: "**{count}** porównań stylów",
    catalogConverters: "**{count}** konwerterów",
    catalogFields: "**{count}** dziedzin naukowych",
    catalogStyleLandings:
      "**{count}** stron głównych popularnych stylów z pełnymi zasadami formatowania",
    faqHeading: "Najczęściej zadawane pytania",
    faqFreeQ: "Czy API CitationEasy jest darmowe i czy potrzebuję klucza API?",
    faqFreeA:
      "Jest darmowe i nie wymaga klucza API. Każdy punkt końcowy pod /api/v1 nie wymaga uwierzytelnienia i jest otwarty na CORS, więc możesz go wywołać z przeglądarki, notebooka lub agenta bez rejestracji. Nie ma naszego własnego limitu zapytań, ale wyszukiwania identyfikatorów są przekazywane do Crossref, Open Library i PubMed, które stosują własne limity uczciwego użytku — grupuj żądania za pomocą `inputs` zamiast wysyłać wiele równoległych zapytań.",
    faqLlmQ: "Czy cytowania są generowane przez model językowy?",
    faqLlmA:
      "Nie. Formatowanie uruchamia citeproc-js na oficjalnych definicjach Citation Style Language — tym samym silniku, którego używają menedżery bibliografii. Te same dane wejściowe i ten sam styl zawsze dają ten sam ciąg znaków. Metadane bibliograficzne pochodzą z Crossref (DOI), Open Library (ISBN) i PubMed (PMID) — CitationEasy nie wymyśla pól, więc wszystko, czego brakuje u źródła, brakuje też w wyniku, zamiast być zgadywane.",
    faqMcpQ: "Jak połączyć agenta z CitationEasy przez MCP?",
    faqMcpA:
      "Skieruj dowolnego klienta Model Context Protocol na https://www.citationeasy.com/api/mcp, używając transportu streamable HTTP. Nie są potrzebne żadne dane uwierzytelniające. W Claude Code: `claude mcp add --transport http citationeasy https://www.citationeasy.com/api/mcp`. Serwer udostępnia narzędzia do generowania cytowań, przeszukiwania {count} stylów, instrukcji dla rodzajów źródeł, wyszukiwania po witrynie oraz odczytu dowolnej strony jako markdown.",
    faqStylesQ: "Jakie style cytowania może wygenerować API?",
    faqStylesA:
      "Wszystkie {count} stylów z repozytorium Citation Style Language, w tym APA 7, MLA 9, oba systemy Chicago, Harvard, Vancouver, IEEE, AMA oraz tysiące indywidualnych stylów czasopism. Przekaż slug stylu w polu `style`. Przyjazne slugi, takie jak „chicago” i „harvard”, rozpoznają właściwy wariant CSL, a /api/v1/styles?q= znajduje resztę.",
    faqLlmsTxtQ: "Czym jest llms.txt i gdzie znajduje się plik CitationEasy?",
    faqLlmsTxtA:
      "llms.txt to zwykły tekstowy indeks witryny napisany z myślą o modelach językowych, a nie przeglądarkach. Plik CitationEasy znajduje się pod /llms.txt; wyczerpująca wersja wymieniająca każdą stronę witryny znajduje się pod /llms-full.txt.",
    faqMarkdownQ:
      "Czy mogę odczytać strony CitationEasy jako markdown zamiast HTML?",
    faqMarkdownA:
      "Tak. Poprzedź dowolną ścieżkę witryny prefiksem /md/ — na przykład /md/citation-style/apa lub /md/tools/word-counter. Strony oparte na danych zwracają swoją pełną treść, w tym rzeczywiste sformatowane przykłady wygenerowane na podstawie własnej definicji CSL każdego stylu. Strony z ręcznie napisaną prozą (poradniki, ściągawki) zwracają kartę podsumowującą oraz kanoniczny adres URL HTML, ponieważ ich tekst znajduje się na samej stronie.",
    faqReuseQ: "Czy mogę wykorzystać wynik CitationEasy we własnym produkcie?",
    faqReuseA:
      "Tak. Sformatowane cytowanie jest faktem dotyczącym źródła — możesz go używać dowolnie. Same definicje stylów CSL pochodzą z projektu Citation Style Language na licencji CC BY-SA 3.0. Wskazanie CitationEasy jako źródła jest mile widziane, ale nie jest wymagane.",
    missingHeading: "Czegoś brakuje?",
    missingBody:
      "Jeśli Twój agent potrzebuje punktu końcowego, pola lub formatu, którego tu nie ma, [daj nam znać](/contact). Przeglądasz ręcznie? [Zacznij od generatora przypisów](/).",
  },

  // /quiz. The client component reads these as a prop rather than through a context:
  // it is one component, not the generator's nine, so there is nothing to drill through.
  quizPage: {
    metaTitle: "Jaki styl cytowania wybrać? - darmowy quiz o stylach",
    metaDescription:
      "Odpowiedz na kilka krótkich pytań o swojej dziedzinie, rodzaju pracy i preferencjach, aby znaleźć najlepszy styl cytowania dla swojej pracy. APA, MLA, Chicago, Vancouver i inne.",
    ogTitle: "Jaki styl cytowania wybrać?",
    ogDescription:
      "Rozwiąż nasz darmowy quiz, aby znaleźć najlepszy styl cytowania dla swojej pracy.",
    breadcrumbHome: "CitationEasy",
    breadcrumbCurrent: "Quiz o stylach",
    backLink: "← Powrót do generatora",
    heading: "Jaki styl cytowania wybrać?",
    intro:
      "Odpowiedz na kilka krótkich pytań, a polecimy Ci najlepszy styl cytowania dla Twojej pracy.",
    progress: "Pytanie {current} z {total}",
    qDiscipline: "Jaka jest Twoja dziedzina studiów?",
    optSocialScience: "Psychologia / nauki społeczne",
    optHumanities: "Literaturoznawstwo / nauki humanistyczne",
    optHistory: "Historia / historia sztuki",
    optMedical: "Medycyna / pielęgniarstwo / zdrowie",
    optEngineering: "Inżynieria / informatyka",
    optNaturalScience: "Nauki przyrodnicze (biologia, chemia)",
    optLaw: "Prawo",
    optBusiness: "Biznes / ekonomia",
    qPaperType: "Jaki rodzaj pracy piszesz?",
    optResearch: "Praca badawcza lub praca dyplomowa",
    optReview: "Przegląd literatury",
    optReport: "Sprawozdanie laboratoryjne lub raport techniczny",
    optEssay: "Esej lub zadanie na zajęcia",
    optJournal: "Zgłoszenie artykułu do czasopisma",
    qRegion: "Gdzie znajduje się Twoja uczelnia?",
    optUs: "Stany Zjednoczone",
    optUk: "Wielka Brytania / Australia",
    optCanada: "Kanada",
    optEurope: "Europa (poza Wielką Brytanią)",
    optOther: "Inne",
    qPreference: "Czy masz preferencje co do formatu cytowania?",
    optAuthorDate: "Cytowania w tekście (Autor, Rok)",
    optNumeric: "Numerowane odwołania [1]",
    optFootnotes: "Przypisy dolne",
    optNoPreference: "Bez preferencji",
    styleVancouver: "Vancouver",
    styleAma: "AMA (American Medical Association)",
    styleIeee: "IEEE",
    styleBluebook: "Bluebook",
    styleCse: "CSE (Council of Science Editors)",
    styleChicagoNotes: "Chicago (Notes & Bibliography)",
    styleMla: "MLA (9. wydanie)",
    styleApa: "APA (7. wydanie)",
    styleHarvard: "Harvard",
    reasonVancouverMedical:
      "Vancouver to standard w czasopismach medycznych i naukach o zdrowiu, wykorzystujący numerowane odwołania.",
    reasonAma:
      "AMA jest powszechnie stosowany w czasopismach medycznych i wykorzystuje cytowania numeryczne.",
    reasonIeee:
      "IEEE to standardowy styl cytowania w inżynierii, informatyce i dziedzinach IT.",
    reasonBluebook:
      "Bluebook to obowiązujący styl cytowania w pisarstwie prawniczym. Styl Chicago jest najbliższą uniwersalną alternatywą.",
    reasonCse: "CSE to standard w biologii i naukach przyrodniczych.",
    reasonChicagoHistory:
      "Chicago (Notes & Bibliography) to złoty standard w historii i historii sztuki, wykorzystujący przypisy dolne do cytowania.",
    reasonChicagoHumanities:
      "Chicago (Notes & Bibliography) dobrze sprawdza się w naukach humanistycznych dzięki podejściu opartemu na przypisach dolnych.",
    reasonMla:
      "MLA to standard w literaturoznawstwie, językoznawstwie i naukach humanistycznych.",
    reasonApaBusiness:
      "APA jest powszechnie stosowany w biznesie, ekonomii i zarządzaniu.",
    reasonHarvard:
      "Cytowanie w stylu Harvard jest najczęściej stosowane na uczelniach w Wielkiej Brytanii i Australii.",
    reasonChicagoFootnotes:
      "Chicago (Notes & Bibliography) wykorzystuje przypisy dolne, idealne do szczegółowych cytowań.",
    reasonVancouverNumeric:
      "Vancouver wykorzystuje cytowania numeryczne, dzięki czemu tekst pozostaje przejrzysty i czytelny.",
    reasonApaDefault:
      "APA to najpowszechniej stosowany styl cytowania w naukach społecznych, edukacji i wielu innych dziedzinach.",
    recommendLabel: "Polecamy",
    generateButton: "Generuj cytowania {style}",
    retakeButton: "Rozwiąż quiz ponownie",
    guidesLink:
      "Przeglądaj nasze poradniki cytowania, aby uzyskać więcej pomocy →",
    previousButton: "← Poprzednie pytanie",
  },

  // /search — the server-rendered site search.
  searchPage: {
    metaTitle: "Szukaj w CitationEasy",
    metaDescription:
      "Przeszukaj jednocześnie wszystkie strony CitationEasy: {count} stylów cytowania, ponad 250 darmowych narzędzi, poradniki, strony „jak zacytować”, porównania stylów, konwertery i słowniczek.",
    keyword1: "szukaj stylów cytowania",
    keyword2: "znajdź poradnik cytowania",
    keyword3: "wyszukiwarka narzędzi do cytowania",
    ogDescription:
      "Przeszukaj jednocześnie wszystkie strony witryny — style, narzędzia, poradniki, strony „jak zacytować”, porównania, konwertery i terminy słowniczka.",
    ogImageSubtitle:
      "Każdy styl cytowania, narzędzie, poradnik, strona „jak zacytować”, porównanie, konwerter i termin słowniczka — przeszukiwane razem.",
    ogKind: "Wyszukiwanie",
    breadcrumb: "Szukaj",
    heading: "Szukaj w CitationEasy",
    intro:
      "Każdy styl cytowania, narzędzie, poradnik, strona „jak zacytować”, porównanie, konwerter i termin słowniczka w tej witrynie — przeszukiwane razem.",
    inputLabel: "Zapytanie wyszukiwania",
    inputPlaceholder: "np. zacytuj podcast w APA, wcięcie wysunięte, DOI",
    submit: "Szukaj",
    browseHeading: "Albo przeglądaj według sekcji",
    browseStyles: "Style cytowania",
    browseStylesNote: "{count} stylów",
    browseTools: "Darmowe narzędzia",
    browseToolsNote: "{count} narzędzi",
    browseHowTo: "Jak zacytować dowolne źródło",
    browseHowToNote: "{count} stron",
    browseGuides: "Poradniki",
    browseGuidesNote: "{count} poradników",
    browseGlossary: "Słowniczek",
    browseGlossaryNote: "{count} terminów",
    browseComparisons: "Porównania stylów",
    browseComparisonsNote: "{count} porównań",
    browseConverters: "Konwertery",
    browseConvertersNote: "{count} konwerterów",
    browseCheatSheets: "Ściągawki",
    browseCheatSheetsNote: "{count} ściągawek",
    facetsLabel: "Filtruj według typu strony",
    facetAll: "Wszystkie ({count})",
    noMatches: "Żadna strona nie pasuje do zapytania „{query}”.",
    matchesOne: "{count} strona pasuje do zapytania „{query}”.",
    matchesMany: "{count} stron pasuje do zapytania „{query}”.",
    pagerLabel: "Strony wyników",
    pagerPrevious: "← Poprzednia",
    pagerNext: "Następna →",
    pagerPosition: "Strona {page} z {total}",
    paletteLoading: "Wyszukiwanie…",
    paletteError: "Wyszukiwanie jest teraz niedostępne. Spróbuj ponownie.",
    paletteViewAll: "Zobacz wszystkie wyniki dla „{query}”",
    apiNote:
      "Coś budujesz? Ten sam indeks jest dostępny jako JSON pod adresem [/api/v1/search](/api/v1/search?q=podcast) oraz przez MCP — zobacz [dokumentację dla agentów](/ai).",
  },

  // /cite-this-page. The six FAQ answers used to exist twice — once in the layout for the
  // FAQPage markup and once in the page for the visible list — which is exactly the drift
  // this dictionary removes: both now read the same keys.
  citeThisPage: {
    metaTitle:
      "Zacytuj tę stronę - cytowania jednym kliknięciem (bookmarklet i rozszerzenie Chrome)",
    metaDescription:
      "Zacytuj dowolną stronę internetową jednym kliknięciem. Przeciągnij darmowy bookmarklet „Zacytuj tę stronę” na pasek zakładek albo zainstaluj darmowe rozszerzenie Chrome z przyciskiem na pasku narzędzi i cytowaniem z menu kontekstowego. Działa też na Chromebookach i w zablokowanych przeglądarkach.",
    ogTitle: "Bookmarklet i rozszerzenie Chrome „Zacytuj tę stronę”",
    ogDescription:
      "Cytowania stron internetowych jednym kliknięciem z dowolnej strony — bookmarklet typu przeciągnij i upuść oraz darmowe rozszerzenie Chrome z cytowaniem z menu kontekstowego.",
    breadcrumbRoot: "CitationEasy",
    breadcrumbSchemaCurrent: "Bookmarklet „Zacytuj tę stronę”",
    appName: "Bookmarklet „Zacytuj tę stronę”",
    appDescription:
      "Darmowy bookmarklet, który cytuje czytaną przez Ciebie stronę internetową jednym kliknięciem — otwiera CitationEasy z wypełnionym adresem URL strony, a następnie formatuje cytowanie w stylu APA, MLA, Chicago i {count} innych.",
    breadcrumbLabel: "Okruszki nawigacyjne",
    breadcrumbHome: "Strona główna",
    breadcrumbCurrent: "Bookmarklet „Zacytuj tę stronę”",
    heading: "Zacytuj tę stronę: bookmarklet i rozszerzenie Chrome",
    intro:
      "Zacytuj dowolną stronę internetową jednym kliknięciem — bez rejestracji. Przeciągnij poniższy bookmarklet na pasek zakładek (bez żadnej instalacji) albo pobierz darmowe rozszerzenie Chrome z przyciskiem na pasku narzędzi i cytowaniem z menu kontekstowego.",
    dragPrompt: "Przeciągnij ten przycisk na pasek zakładek:",
    buttonTitle: "Przeciągnij mnie na pasek zakładek",
    buttonLabel: "📑 Zacytuj tę stronę",
    dontClick:
      "Nie klikaj go tutaj — najpierw przeciągnij go na pasek zakładek.",
    installHeading: "Jak go zainstalować",
    step1Title: "Pokaż pasek zakładek",
    step1Body:
      "W większości przeglądarek naciśnij Ctrl+Shift+B (Cmd+Shift+B na Macu), aby przełączyć widoczność paska zakładek i mieć gdzie upuścić przycisk.",
    step2Title: "Przeciągnij przycisk w górę",
    step2Body:
      "Kliknij i przytrzymaj poniższy przycisk „Zacytuj tę stronę”, a następnie przeciągnij go na pasek zakładek i puść. Stanie się zwykłą zakładką.",
    step3Title: "Kliknij go na dowolnej stronie",
    step3Body:
      "Podczas czytania artykułu, wiadomości lub strony czasopisma kliknij swoją nową zakładkę. CitationEasy otworzy się z wypełnionym adresem URL strony i cytowaniem gotowym do skopiowania.",
    manualHeading: "Nie możesz go przeciągnąć? Dodaj go ręcznie",
    manualBody:
      "Utwórz nową zakładkę, nazwij ją „Zacytuj tę stronę” i wklej poniższy tekst jako adres URL:",
    howHeading: "Jak to działa",
    howBody:
      "Bookmarklet nie uruchamia żadnego kodu na czytanej przez Ciebie stronie. Jedynie przekazuje adres tej strony do CitationEasy, gdzie nasz serwer pobiera i analizuje publiczne metadane strony — tą samą zaufaną ścieżką, jaką stosujesz, ręcznie wklejając adres URL do generatora. Dzięki temu rozwiązanie jest bezpieczne i unika ograniczeń cross-origin, które wyeliminowały starsze bookmarklety działające bezpośrednio na stronie.",
    extensionHeading: "Wolisz rozszerzenie Chrome?",
    extensionBody:
      "Darmowe rozszerzenie CitationEasy dodaje przycisk na pasku narzędzi, który cytuje bieżącą kartę, oraz opcje w menu kontekstowym pozwalające zacytować link — lub zaznaczony DOI czy ISBN — bez jego otwierania. Podobnie jak bookmarklet, nie uruchamia żadnego kodu na odwiedzanych stronach: jedynie przekazuje adres URL do CitationEasy. Wymaga tylko uprawnień `activeTab` i `contextMenus` i działa w Chrome, Edge, Brave i innych przeglądarkach opartych na Chromium.",
    downloadButton: "⬇ Pobierz rozszerzenie Chrome (.zip)",
    install1: "Pobierz i rozpakuj rozszerzenie.",
    install2:
      "Otwórz `chrome://extensions` i włącz **Tryb programisty** (prawy górny róg).",
    install3: "Kliknij **Wczytaj rozpakowane** i wybierz rozpakowany folder.",
    install4:
      "Przypnij przycisk CitationEasy, a następnie kliknij go na dowolnej stronie, aby ją zacytować.",
    faqHeading: "Najczęściej zadawane pytania",
    faqWhatQ: "Czym jest bookmarklet „Zacytuj tę stronę”?",
    faqWhatA:
      "To niewielka zakładka, którą przeciągasz na pasek zakładek przeglądarki. Gdy klikniesz ją na dowolnej stronie internetowej, otwiera CitationEasy w nowej karcie z już wypełnionym adresem URL tej strony, dzięki czemu otrzymujesz sformatowane cytowanie jednym kliknięciem — bez kopiowania i wklejania.",
    faqExtensionNeededQ: "Czy muszę zainstalować rozszerzenie?",
    faqExtensionNeededA:
      "Nie. Bookmarklet to zwykła zakładka, więc nie ma nic do zainstalowania ani żadnych uprawnień do przyznania. Działa na zablokowanych szkolnych Chromebookach oraz w większości przeglądarek mobilnych, gdzie rozszerzenia są zablokowane. Jeśli wolisz rozszerzenie, na tej stronie znajdziesz też darmowe rozszerzenie Chrome.",
    faqChromeQ: "Czy istnieje rozszerzenie Chrome?",
    faqChromeA:
      "Tak. Darmowe rozszerzenie CitationEasy do Chrome dodaje przycisk na pasku narzędzi, który cytuje bieżącą kartę, a także opcje w menu kontekstowym pozwalające zacytować link lub zaznaczony DOI/ISBN bez jego otwierania. Nie uruchamia żadnego kodu na odwiedzanych stronach i wymaga tylko uprawnień activeTab i contextMenus. Pobierz je z tej strony i wczytaj przez chrome://extensions — działa w Chrome, Edge, Brave i innych przeglądarkach opartych na Chromium.",
    faqAddQ: "Jak dodać bookmarklet?",
    faqAddA:
      "Upewnij się, że pasek zakładek jest widoczny, a następnie przeciągnij na niego przycisk „Zacytuj tę stronę” z tej strony. Jeśli przeciąganie nie jest możliwe (na przykład na urządzeniu mobilnym), utwórz nową zakładkę ręcznie i wklej kod bookmarkletu jako adres URL.",
    faqSafeQ:
      "Czy to bezpieczne? Czy odczytuje treść strony, na której jestem?",
    faqSafeA:
      "Tak, to bezpieczne. Bookmarklet nie uruchamia żadnego kodu na czytanej przez Ciebie stronie — jedynie wysyła jej adres do CitationEasy, gdzie nasz serwer pobiera i analizuje publiczne metadane strony, dokładnie tak samo jak wtedy, gdy ręcznie wklejasz adres URL.",
    faqOtherSourcesQ: "Czy działa dla źródeł innych niż strony internetowe?",
    faqOtherSourcesA:
      "Bookmarklet jest przeznaczony dla stron internetowych, ale ten sam link akceptuje też DOI, ISBN, PMID lub identyfikator arXiv poprzez parametr ?source= — dzięki temu link „zacytuj to” do udostępnienia działa również dla artykułów naukowych i książek.",
    relatedHeading: "Powiązane narzędzia",
    relatedGenerator: "Generator przypisów",
    relatedHowToCite: "Jak zacytować stronę internetową",
    relatedTools: "Wszystkie narzędzia",
  },

  // /shared-bibliography — opens a bibliography that travelled inside a share link.
  sharedBibliographyPage: {
    metaTitle:
      "Udostępniona bibliografia - przeglądaj i importuj udostępnione cytowania",
    metaDescription:
      "Otwórz bibliografię, którą ktoś udostępnił Ci z CitationEasy. Przeglądaj sformatowane cytowania, kopiuj je albo zaimportuj całą listę do własnej bibliografii — za darmo, bez konta, a dane znajdują się w samym linku.",
    ogTitle: "Udostępniona bibliografia",
    ogDescription:
      "Przeglądaj i importuj udostępnioną bibliografię. Cytowania podróżują wewnątrz linku — nic nie jest przechowywane na serwerze, a linki nigdy nie wygasają.",
    breadcrumbRoot: "CitationEasy",
    breadcrumbLabel: "Okruszki nawigacyjne",
    breadcrumbHome: "Strona główna",
    breadcrumbCurrent: "Udostępniona bibliografia",
    heading: "Udostępniona bibliografia",
    intro:
      "Ktoś udostępnił Ci te cytowania. Skopiuj je albo zaimportuj całą listę do własnej bibliografii CitationEasy jednym kliknięciem.",
    loading: "Otwieranie udostępnionej bibliografii…",
    copyAll: "Kopiuj wszystko",
    copied: "Skopiowano",
    copyFailed: "Kopiowanie nie powiodło się",
    citationOne: "cytowanie",
    citationMany: "cytowań",
    addAll: "Dodaj wszystko do mojej bibliografii",
    added: "Dodano {count} do Twojej bibliografii",
    skippedOne: "Pominięto {count} duplikat",
    skippedMany: "Pominięto {count} duplikatów",
    openGenerator: "otwórz generator",
    emptyHeading: "Brak udostępnionej bibliografii w tym linku",
    emptyBody:
      "Ta strona wyświetla bibliografie udostępnione z CitationEasy. Aby udostępnić swoją, otwórz bibliografię w [generatorze przypisów](/), wybierz **Eksportuj → Kopiuj link do udostępnienia** i wyślij link dowolnej osobie. Cytowania podróżują wewnątrz samego linku — nic nie jest przechowywane na serwerze, dzięki czemu linki działają wiecznie, a Twoje dane pozostają prywatne.",
    decodeError: "Nie udało się otworzyć tego linku do udostępniania.",
  },

  // The 19 source types the 15 detailed styles show worked examples for
  // (`DetailedStyleData.examples[].sourceType`). 75 rows, 19 distinct values — so this
  // is a vocabulary, not per-page copy, and it belongs here rather than repeated in
  // every locale's `src/content/style-pages/<locale>.json`.
  //
  // Two casings for the same reason `howToCitePage.refList*Lower` has two: the pages
  // print the label as a heading ("Book") and inside a sentence ("a sample APA entry
  // for a book"). Lower-casing the translated noun in code is wrong in German, where
  // every one of these is capitalised, so the lower form is a real key a translator
  // fills rather than a `.toLowerCase()` call.
  //
  // The citations themselves — `referenceEntry` and `inTextCitation` — are NOT here and
  // are not translatable anywhere: they are worked examples in a specific style's own
  // punctuation. See `src/lib/localized-content.ts`.
  sourceTypes: {
    book: "Książka",
    bookLower: "książka",
    bookChapter: "Rozdział książki",
    bookChapterLower: "rozdział książki",
    case: "Sprawa",
    caseLower: "sprawa",
    conferencePaper: "Referat konferencyjny",
    conferencePaperLower: "referat konferencyjny",
    courtCase: "Sprawa sądowa",
    courtCaseLower: "sprawa sądowa",
    federalStatute: "Ustawa federalna",
    federalStatuteLower: "ustawa federalna",
    governmentDocument: "Dokument rządowy",
    governmentDocumentLower: "dokument rządowy",
    governmentReport: "Raport rządowy",
    governmentReportLower: "raport rządowy",
    journalArticle: "Artykuł naukowy",
    journalArticleLower: "artykuł naukowy",
    lawReviewArticle: "Artykuł w czasopiśmie prawniczym",
    lawReviewArticleLower: "artykuł w czasopiśmie prawniczym",
    legislation: "Akt prawny",
    legislationLower: "akt prawny",
    newspaperArticle: "Artykuł prasowy",
    newspaperArticleLower: "artykuł prasowy",
    patent: "Patent",
    patentLower: "patent",
    podcast: "Podcast",
    podcastLower: "podcast",
    preprint: "Preprint",
    preprintLower: "preprint",
    standard: "Norma",
    standardLower: "norma",
    thesis: "Praca dyplomowa",
    thesisLower: "praca dyplomowa",
    website: "Strona internetowa",
    websiteLower: "strona internetowa",
    youtubeVideo: "Film na YouTube",
    youtubeVideoLower: "film na YouTube",
  },

  // Chrome shared by the five per-style guide routes — /examples, /format,
  // /in-text-citation, /reference-page and /annotated-bibliography, 15 styles each.
  //
  // One section rather than five copies: the CTA, the back link and the cross-links
  // between the five pages are the same sentences on every one of them, and duplicating
  // them per route would be five identical translation units instead of one.
  styleGuidePages: {
    backToStyle: "Powrót do {style}",
    backToGenerator: "Powrót do generatora przypisów",
    ctaHeading: "Generuj cytowania {style} automatycznie",
    ctaButton: "Zacytuj w stylu {style} teraz →",
    faqHeading: "Najczęściej zadawane pytania",
    resourcesHeading: "Więcej materiałów",
    relatedHeading: "Powiązane poradniki {style}",
    resourceGenerator: "Darmowy generator przypisów ({count} style)",
    resourceTools: "Darmowe narzędzia do pisania",
    resourceGuides: "Wszystkie poradniki cytowania",
    resourceStyleGenerator: "Generator przypisów {style}",
    resourceExamples: "Przykłady cytowań {style}",
    resourceFormat: "Poradnik formatowania {style}",
    resourceInText: "Poradnik cytowania w tekście {style}",
    resourceAnnotatedBib: "Poradnik bibliografii adnotowanej {style}",
    resourceReferencePage: "Poradnik „{list}” w stylu {style}",
    notFoundTitle: "Nie znaleziono",
  },

  // /examples/<style> — the copy-ready worked examples for all 15 detailed styles.
  examplesPage: {
    metaTitle: "Przykłady cytowań {style} - wszystkie rodzaje źródeł [2026]",
    metaDescription:
      "Zobacz sformatowane przykłady cytowań {style} ({edition}) dla książek, artykułów naukowych, stron internetowych i innych źródeł. Gotowe do skopiowania pozycje „{list}” oraz cytowania w tekście.",
    ogTitle: "przykłady cytowań {style}",
    ogDescription:
      "Gotowe do skopiowania pozycje {style} dla każdego popularnego rodzaju źródła.",
    ogImageTitle: "Przykłady cytowań {style}",
    ogKind: "{style} {edition}",
    keywordExamples: "przykłady cytowań {style}",
    keywordReference: "przykłady wpisów bibliograficznych {style}",
    keywordInText: "przykłady cytowań w tekście {style}",
    keywordList: "przykłady „{listLower}” w stylu {style}",
    keywordHowTo: "jak cytować w stylu {style}",
    breadcrumb: "Przykłady cytowań {style}",
    heading: "Przykłady cytowań {style}",
    lead: "Zobacz poprawnie sformatowane przykłady cytowań {style} ({edition}) dla {count} popularnych rodzajów źródeł. Każdy przykład zawiera zarówno pozycję w „{listLower}”, jak i odpowiadające jej cytowanie w tekście.",
    entryLabel: "Pozycja w „{list}”:",
    inTextLabel: "Cytowanie w tekście:",
    ctaBody:
      "Pomiń ręczne formatowanie. Wklej DOI, adres URL lub ISBN do CitationEasy i w kilka sekund otrzymaj bezbłędnie sformatowane cytowanie w stylu {style}.",
    faqLookQ: "Jak wygląda cytowanie w stylu {style}?",
    faqLookA:
      "Cytowanie w stylu {style} obejmuje pozycję w „{listLower}” z pełnymi danymi źródła oraz cytowanie w tekście. Format zależy od rodzaju źródła. Na przykład cytowanie książki w stylu {style} ({edition}) zawiera autora, rok, tytuł i wydawcę.",
    faqHowManyQ: "Ile przykładów cytowań {style} jest dostępnych?",
    faqHowManyA:
      "CitationEasy udostępnia przykłady cytowań {style} dla {count} rodzajów źródeł, w tym {types}. Każdy przykład zawiera zarówno pozycję w „{listLower}”, jak i odpowiadające jej cytowanie w tekście.",
    faqCopyQ: "Czy mogę skopiować te przykłady cytowań {style}?",
    faqCopyA:
      "Tak, przykłady {style} na tej stronie pokazują dokładne formatowanie dla każdego rodzaju źródła. Możesz użyć ich jako szablonów dla własnych cytowań. Aby sformatować automatycznie, skorzystaj z naszego darmowego generatora przypisów {style}.",
  },

  // /format/<style> — font, margins, spacing, title page and headers. The VALUES those
  // labels take are per-style prose and live in the overlay, not here.
  formatPage: {
    metaTitle:
      "Poradnik formatowania {style} - zasady formatowania pracy [2026]",
    metaDescription:
      "Kompletny poradnik formatowania pracy w stylu {style} ({edition}). Poznaj poprawną czcionkę, marginesy, interlinię, stronę tytułową, nagłówki oraz zasady formatowania „{listLower}”.",
    ogTitle: "format pracy {style}",
    ogDescription:
      "Marginesy, czcionka, interlinia i strona tytułowa dla pracy w stylu {style}.",
    ogImageTitle: "Format pracy {style}",
    ogImageSubtitle: "Marginesy {margins} · {spacing}",
    ogKind: "{style} {edition}",
    keywordFormat: "format {style}",
    keywordPaperFormat: "format pracy {style}",
    keywordRules: "zasady formatowania {style}",
    keywordMargins: "marginesy czcionka interlinia {style}",
    keywordList: "format „{listLower}” {style}",
    breadcrumb: "Poradnik formatowania {style}",
    heading: "Poradnik formatowania {style}",
    lead: "Zastosuj poniższe zasady formatowania pracy w stylu {style} ({edition}), aby Twój dokument spełniał wymagane standardy. Ten poradnik obejmuje czcionkę, marginesy, interlinię, stronę tytułową, nagłówki oraz formatowanie „{listLower}”.",
    paperHeading: "Formatowanie pracy",
    paperIntro:
      "Poniżej znajdziesz podstawowe wymagania formatowania dla prac pisanych w stylu {style} ({edition}).",
    labelFont: "Czcionka",
    labelFontSize: "Rozmiar czcionki",
    labelMargins: "Marginesy",
    labelSpacing: "Interlinia",
    labelTitlePage: "Strona tytułowa",
    labelHeaders: "Nagłówki / numery stron",
    listHeading: "Formatowanie „{list}”",
    listIntro:
      "Twoja „{listLower}” musi być zgodna z poniższymi zasadami, aby była poprawnie sformatowana w stylu {style}:",
    ctaBody:
      "Pozwól CitationEasy zająć się formatowaniem. Wklej DOI, adres URL lub ISBN i w kilka sekund otrzymaj bezbłędnie sformatowane cytowanie w stylu {style}.",
    faqFontQ: "Jakiej czcionki i rozmiaru użyć w formacie {style}?",
    faqFontA:
      "{style} ({edition}) wymaga czcionki {font}. Standardowy rozmiar czcionki to {fontSize}.",
    faqMarginsQ: "Jakie są wymagania dotyczące marginesów w stylu {style}?",
    faqMarginsA:
      "Prace w stylu {style} wymagają marginesów {margins}. Dotyczy to górnego, dolnego, lewego i prawego marginesu na każdej stronie.",
    faqTitlePageQ: "Czy styl {style} wymaga strony tytułowej?",
  },

  // /in-text-citation/<style> — the six in-text forms. The forms themselves
  // ("(Smith, 2024)") are per-style prose in the overlay.
  inTextCitationPage: {
    metaTitle:
      "Poradnik cytowania w tekście {style} - zasady i przykłady [2026]",
    metaDescription:
      "Dowiedz się, jak formatować cytowania w tekście w stylu {style} ({edition}). Zasady dla jednego autora, wielu autorów, cytatów bezpośrednich, braku autora i braku daty — wraz z przykładami.",
    ogTitle: "cytowania w tekście {style}",
    ogDescription: "Każda forma cytowania w tekście {style} — z przykładami.",
    ogImageTitle: "Cytowania w tekście {style}",
    ogImageSubtitle:
      "Jeden autor {singleAuthor} · trzej i więcej {threeOrMore}",
    ogKind: "{style} {edition}",
    keywordInText: "cytowanie w tekście {style}",
    keywordExamples: "przykłady cytowań w tekście {style}",
    keywordParenthetical: "cytowanie nawiasowe {style}",
    keywordRules: "zasady cytowania {style}",
    keywordHowTo: "jak cytować w tekście {style}",
    breadcrumb: "Cytowania w tekście {style}",
    heading: "Cytowania w tekście {style}",
    lead: "Opanuj cytowania w tekście w stylu {style} ({edition}) dzięki temu kompletnemu poradnikowi. Poznaj poprawny format dla każdej sytuacji, w tym dla jednego i wielu autorów, cytatów bezpośrednich oraz źródeł z brakującymi informacjami.",
    rulesHeading: "Zasady cytowania w tekście",
    rulesIntro:
      "Poniżej znajdziesz zasady cytowania w tekście {style} dla każdej typowej sytuacji, z jaką spotkasz się podczas pisania pracy.",
    labelSingleAuthor: "Jeden autor",
    labelTwoAuthors: "Dwóch autorów",
    labelThreeOrMore: "Trzej autorzy lub więcej",
    labelDirectQuote: "Cytat bezpośredni",
    labelNoAuthor: "Brak autora",
    labelNoDate: "Brak daty",
    examplesHeading: "Szybkie przykłady",
    examplesIntro:
      "Oto rzeczywiste przykłady cytowań w tekście {style} dla różnych rodzajów źródeł:",
    ctaBody:
      "Przestań martwić się formatowaniem cytowań w tekście. Wklej DOI, adres URL lub ISBN do CitationEasy i błyskawicznie otrzymaj zarówno pozycję w „{listLower}”, jak i cytowanie w tekście.",
    faqFormatQ: "Jak sformatować cytowanie w tekście w stylu {style}?",
    faqFormatA:
      "Dla jednego autora w stylu {style} użyj formatu {singleAuthor}. Dla dwóch autorów użyj {twoAuthors}. Dla trzech lub więcej autorów użyj {threeOrMore}.",
    faqQuoteQ: "Jak zacytować cytat bezpośredni w stylu {style}?",
    faqQuoteA:
      "Dla cytatów bezpośrednich w stylu {style} ({edition}) użyj formatu: {directQuote}.",
    faqMissingQ: "Co zrobić, gdy w stylu {style} brakuje autora lub daty?",
    faqMissingA:
      "Gdy w stylu {style} brakuje autora, użyj: {noAuthor}. Gdy brakuje daty, użyj: {noDate}.",
  },

  // /reference-page/<style> — how to build the list at the back of the paper.
  //
  // The five `mistake*` strings carry `**bold**` inline markup because the lead-in of
  // each bullet is emphasised inside the sentence; they render through `InlineText`.
  referenceListPage: {
    metaTitle: "Poradnik „{list}” w stylu {style} - zasady formatowania [2026]",
    metaDescription:
      "Dowiedz się, jak sformatować „{listLower}” w stylu {style} ({edition}). Zasady formatowania krok po kroku, przykłady i najczęstsze błędy do uniknięcia w stylu {fullName}.",
    ogTitle: "{listLower} {style}",
    ogDescription: "Jak zbudować „{list}” w stylu {style}.",
    ogImageTitle: "{list} {style}",
    ogKind: "{style} {edition}",
    breadcrumb: "Jak sformatować „{list}” w stylu {style}",
    heading: "Jak sformatować „{list}” w stylu {style}",
    lead: "„{listLower}” to jedna z najważniejszych części każdej pracy akademickiej sformatowanej w stylu {style} ({edition}). Dostarcza czytelnikom pełnych informacji o każdym cytowanym źródle, umożliwiając ich odnalezienie i zweryfikowanie. Poprawne formatowanie ma kluczowe znaczenie dla wiarygodności akademickiej. Ten poradnik obejmuje dokładne zasady, pokazuje rzeczywiste przykłady i wskazuje najczęstsze błędy popełniane przez studentów.",
    rulesHeading: "Zasady formatowania",
    rulesIntro:
      "Zastosuj poniższe zasady, tworząc swoją „{listLower}” w stylu {style}:",
    exampleHeading: "Przykładowa „{list}”",
    exampleIntro:
      "Oto jak wygląda „{listLower}” w stylu {style} z pozycjami dla różnych rodzajów źródeł:",
    mistakesHeading: "Najczęstsze błędy, których należy unikać",
    mistakesIntro:
      "Oto pięć najczęstszych błędów formatowania popełnianych przez studentów podczas tworzenia „{listLower}” w stylu {style}:",
    mistakeIndent:
      "**Brak lub niepoprawne wcięcie wysunięte:** Pierwszy wiersz każdej pozycji powinien zaczynać się od lewego marginesu, a wszystkie kolejne wiersze powinny być wcięte o 1,27 cm. Użyj ustawień akapitu w edytorze tekstu zamiast klawisza Tab.",
    mistakeOrder:
      "**Niepoprawna kolejność alfabetyczna lub numeryczna:** Pozycje muszą być ułożone zgodnie z zasadami stylu {style}. Przy porządkowaniu alfabetycznym pomijaj przedimki, takie jak angielskie „A”, „An” i „The”. W stylach numerycznych pozycje wymień w kolejności ich pierwszego pojawienia się w tekście.",
    mistakeSpacing:
      "**Niespójna interlinia:** Dokładnie sprawdź interlinię w całej „{listLower}”. Mieszanie pojedynczej i podwójnej interlinii to częsty błąd, który łatwo przeoczyć.",
    mistakeItalics:
      "**Nieprawidłowe użycie kursywy:** Kursywą zapisuj tytuły samodzielnych dzieł, takich jak książki i czasopisma, ale nie tytuły artykułów czy rozdziałów. Sprawdź wytyczne stylu {style}, aby dokładnie ustalić, które elementy powinny być zapisane kursywą.",
    mistakeLinks:
      "**Brak lub uszkodzone numery DOI i adresy URL:** Zawsze podawaj DOI, jeśli jest dostępny, sformatowany jako klikalny link. Sprawdź każdy adres URL przed oddaniem pracy, aby upewnić się, że prowadzi do właściwego źródła.",
    ctaHeading: "Wygeneruj swoją „{list}” automatycznie",
    ctaBody:
      "Pomiń ręczne formatowanie. Wklej DOI, adres URL lub ISBN do CitationEasy i w kilka sekund otrzymaj bezbłędnie sformatowane cytowanie w stylu {style}, gotowe do umieszczenia w Twojej „{listLower}”.",
    faqWhatQ: "Czym jest „{list}” w stylu {style}?",
    faqWhatA:
      "„{list}” w stylu {style} to sekcja na końcu pracy, w której wymieniono wszystkie źródła cytowane w tekście, sformatowane zgodnie z wytycznymi stylu {fullName} ({edition}). Umożliwia czytelnikom odnalezienie i zweryfikowanie każdego przywołanego źródła.",
    faqFormatQ: "Jak sformatować „{listLower}” w stylu {style}?",
    faqFormatA:
      "Rozpocznij na nowej stronie, zatytułuj ją „{list}” i wymień wszystkie źródła cytowane w pracy. Zastosuj się do szczegółowych zasad stylu {style} dotyczących wcięcia wysuniętego, interlinii, kolejności alfabetycznej lub numerycznej oraz kursywy.",
    faqDifferenceQ: "Jaka jest różnica między „{listLower}” a bibliografią?",
    faqDifferenceA:
      "„{listLower}” obejmuje wyłącznie źródła bezpośrednio cytowane w pracy, natomiast bibliografia może zawierać także źródła, z którymi się zapoznano, ale których nie zacytowano. W stylu {style} ({edition}) lista na końcu pracy nosi nazwę „{list}”.",
  },

  // /annotated-bibliography/<style>. `whatTypes` carries `**bold**` inline markup.
  //
  // `exampleAnnotation` is a specimen annotation, not a citation: it is ordinary prose
  // about an imaginary source and translates like any other paragraph. The reference
  // entry printed above it does not — that comes from `DETAILED_STYLES` and stays as
  // the style wrote it.
  annotatedBibPage: {
    metaTitle: "Poradnik i przykłady bibliografii adnotowanej {style} [2026]",
    metaDescription:
      "Dowiedz się, jak napisać bibliografię adnotowaną w stylu {style} ({edition}). Zawiera zasady formatowania, przykładowe pozycje i wskazówki dotyczące bibliografii adnotowanych w stylu {fullName}.",
    ogTitle: "bibliografia adnotowana {style}",
    ogDescription: "Jak sformatować bibliografię adnotowaną w stylu {style}.",
    ogImageTitle: "Bibliografia adnotowana {style}",
    ogKind: "{style} {edition}",
    breadcrumb: "Bibliografia adnotowana {style}",
    heading: "Bibliografia adnotowana {style}",
    lead: "Bibliografia adnotowana to wykaz cytowań źródeł, z których każde zawiera krótki akapit opisowy lub oceniający. W formacie {style} ({edition}) każda pozycja zaczyna się od poprawnie sformatowanego opisu bibliograficznego, po którym następuje adnotacja podsumowująca, oceniająca lub komentująca źródło. Ten poradnik przeprowadzi Cię przez zasady, formatowanie i przykłady potrzebne do stworzenia dopracowanej bibliografii adnotowanej w stylu {style}.",
    whatHeading: "Czym jest bibliografia adnotowana?",
    whatBody:
      "Bibliografia adnotowana wykracza poza standardową „{listLower}”, dodając krótki akapit po każdym cytowaniu. Taka adnotacja daje czytelnikom wgląd w treść, jakość i trafność źródła. Prowadzący zajęcia często zlecają bibliografie adnotowane, aby pomóc studentom krytycznie ocenić swoje źródła i pokazać, jak każde z nich wnosi wkład w temat badawczy.",
    whatTypes:
      "Istnieją trzy popularne rodzaje adnotacji: **opisowe**, które podsumowują źródło, **oceniające**, które oceniają jakość i wiarygodność pracy, oraz **mieszane**, które łączą oba podejścia. Instrukcje do zadania powinny wskazywać, którego rodzaju użyć.",
    rulesHeading: "Zasady bibliografii adnotowanej {style}",
    rulesIntro:
      "Zastosuj poniższe zasady podczas formatowania bibliografii adnotowanej w stylu {fullName}:",
    exampleHeading: "Przykładowa pozycja bibliografii adnotowanej",
    exampleIntro:
      "Poniżej przykładowa pozycja bibliografii adnotowanej {style} dla źródła typu: {sourceType}:",
    exampleAnnotation:
      "To źródło zapewnia wyczerpujący przegląd tematu, przedstawiając dobrze uzasadnione argumenty poparte danymi empirycznymi. Autor korzysta z szerokiego zakresu źródeł pierwotnych i wtórnych, budując przekonującą argumentację. Metodologia jest rzetelna, a wyniki przedstawione w sposób przejrzysty, co czyni tę pracę cennym źródłem wiedzy na dany temat. Źródło to jest szczególnie przydatne przy budowaniu ram teoretycznych projektu badawczego i oferuje perspektywy uzupełniające inne pozycje w bibliografii.",
    tipsHeading: "Wskazówki dotyczące pisania adnotacji w stylu {style}",
    tipSummarize:
      "Zacznij od podsumowania źródła w dwóch–trzech zdaniach, a następnie dodaj własną ocenę jego mocnych stron, ograniczeń i trafności.",
    tipTone:
      "W adnotacjach stosuj trzecią osobę i ton akademicki. Unikaj potocznego języka lub refleksji w pierwszej osobie, chyba że prowadzący zajęcia tego wymaga.",
    tipLength:
      "Każda adnotacja powinna liczyć od 100 do 200 słów. Bądź zwięzły/a i skup się na najważniejszych aspektach źródła.",
    tipRelevance:
      "Wyjaśnij, jak źródło wpisuje się w całość Twoich badań. Opisz, jaką unikalną perspektywę lub jakie dowody wnosi.",
    tipCitation:
      "Przed napisaniem adnotacji upewnij się, że część opisu bibliograficznego każdej pozycji dokładnie odpowiada zasadom formatowania stylu {fullName}.",
    ctaHeading: "Zbuduj swoją bibliografię adnotowaną automatycznie",
    ctaBody:
      "Skorzystaj z kreatora bibliografii adnotowanej CitationEasy, aby wygenerować poprawnie sformatowane cytowania {style}, a następnie dodaj swoje adnotacje.",
    ctaButton: "Otwórz kreator bibliografii adnotowanej →",
    faqWhatQ: "Czym jest bibliografia adnotowana w stylu {style}?",
    faqWhatA:
      "Bibliografia adnotowana w stylu {style} ({edition}) to wykaz cytowań sformatowanych w stylu {fullName}, z których każde jest uzupełnione krótkim akapitem podsumowującym, oceniającym lub komentującym źródło. Pomaga czytelnikom zrozumieć trafność i jakość każdego źródła.",
    faqLengthQ: "Jak długie powinny być adnotacje?",
    faqLengthA:
      "Adnotacje mają zazwyczaj od 100 do 200 słów. Niektóre zadania mogą wymagać krótszych lub dłuższych adnotacji, w zależności od oczekiwanej głębi analizy. Zawsze sprawdź wytyczne prowadzącego zajęcia dotyczące konkretnej wymaganej długości.",
    faqIncludeQ: "Co powinna zawierać adnotacja?",
    faqIncludeA:
      "Adnotacja powinna zawierać krótkie podsumowanie głównego argumentu lub wyników źródła, ocenę jego wiarygodności i przydatności oraz refleksję na temat tego, jak wpisuje się ono w Twoje badania. Niektóre adnotacje mają charakter czysto opisowy, inne zawierają analizę krytyczną.",
  },

  guidePage: {
    byline: "Autor: {author}",
    published: "Opublikowano {date}",
    updated: "Zaktualizowano {date}",
    readingTime:
      "one:{count} minuta czytania|few:{count} minuty czytania|many:{count} minut czytania|other:{count} minuty czytania",
    wordCount:
      "one:{count} słowo|few:{count} słowa|many:{count} słów|other:{count} słowa",
  },

  // /guides hub, /guides/<category> index pages, and the chrome around each guide
  guideLibrary: {
    eyebrow: "Biblioteka poradników",
    browseByCategory: "Przeglądaj według kategorii",
    recentlyUpdated: "Ostatnio zaktualizowane",
    allGuides: "Wszystkie poradniki",
    guideCount:
      "one:{count} poradnik|few:{count} poradniki|many:{count} poradników|other:{count} poradnika",
    updatedOn: "Zaktualizowano {date}",
    minRead:
      "one:{count} min czytania|few:{count} min czytania|many:{count} min czytania|other:{count} min czytania",
    onThisPage: "Na tej stronie",
    viewAllInCategory: "Wszystkie poradniki: {category}",
    moreInCategory: "Więcej z kategorii {category}",
    aboutThisGuide: "O tym poradniku",
    provenance:
      "Autor: {author}. Opublikowano {published}; ostatnia aktualizacja {updated}.",
    categoryIntroSuffix:
      "Każdy poradnik jest bezpłatny, napisany dla studentów i badaczy oraz opatrzony datą, aby było widać, kiedy został ostatnio sprawdzony.",
    photoCredit: "Zdjęcie: {author}, {source} ({license})",
    imageAlt: "Zdjęcie ilustrujące poradniki z kategorii {category}",
    imageSourceCommons: "Wikimedia Commons",
    apaStyleName: "Styl APA",
    apaStyleDescription:
      "Jak cytować strony internetowe, artykuły naukowe, książki, filmy i więcej w APA 7, z przykładami bibliografii i odwołań w tekście.",
    mlaStyleName: "Styl MLA",
    mlaStyleDescription:
      "Jak cytować każde popularne źródło w MLA 9 – od stron WWW i artykułów po wiersze, sztuki, filmy i materiały z zajęć.",
    chicagoStyleName: "Styl Chicago",
    chicagoStyleDescription:
      "Poradniki Chicago Manual of Style obejmujące przypisy z bibliografią oraz system autor-data dla książek, artykułów, archiwów, dokumentów urzędowych i mediów.",
    styleComparisonsName: "Porównania stylów",
    styleComparisonsDescription:
      "Porównania APA, MLA, Chicago, Harvard, Vancouver, IEEE i innych oraz wskazówki, jakiego stylu oczekuje Twoja dyscyplina.",
    researchMethodsName: "Metody badawcze",
    researchMethodsDescription:
      "Jak zaplanować pracę badawczą, przejrzeć literaturę, robić notatki, oceniać źródła, unikać plagiatu i zbudować bibliografię.",
    academicWritingName: "Pisanie akademickie",
    academicWritingDescription:
      "Poradniki pisania abstraktów, wstępów, zakończeń, tez, rozdziałów metodologicznych i klarownej prozy naukowej.",
    fieldSpecificName: "Według dziedziny",
    fieldSpecificDescription:
      "Poradniki cytowania dla poszczególnych dyscyplin – od psychologii, historii i literatury po medycynę, inżynierię, prawo i pielęgniarstwo.",
    sourceEvaluationName: "Ocena źródeł",
    sourceEvaluationDescription:
      "Jak oceniać wiarygodność, odróżniać źródła naukowe od popularnych, korzystać z Google Scholar i baz bibliotecznych oraz rozpoznawać stronniczość.",
    citationHelpName: "Pomoc w cytowaniu",
    citationHelpDescription:
      "Odpowiedzi na trudne przypadki: brak autora lub daty, wielu autorów, pliki PDF, narzędzia AI, sprawy sądowe oraz import i eksport cytowań.",
  },

  common: {
    backToGuides: "← Wróć do poradników",
    free: "Za darmo",
    noSignup: "Bez rejestracji",
    backToHome: "Wróć do generatora przypisów",
    inEnglish: "Po angielsku",
    viewInEnglish: "Zobacz po angielsku",
    availableInEnglish:
      "Ta strona jest dostępna po angielsku, w szerszej wersji.",
    otherLanguages: "Inne języki",
    skipToContent: "Przejdź do treści",
    cookieNotice:
      "Używamy plików cookie do analityki i reklam, aby CitationEasy pozostało bezpłatne.",
    privacyPolicy: "Polityka prywatności",
    accept: "Akceptuję",
    decline: "Odrzuć",
    advertisement: "Reklama",
  },
  legalPage: {
    backLink: "← Powrót do generatora",
    effective: "Data wejścia w życie:",
    updated: "Ostatnia aktualizacja:",
  },
};

export default pl;
